(function () {
  'use strict';

  if (window.SenfinecoCamryMap) {
    window.SenfinecoCamryMap.sync();
    return;
  }

  var CARD_SELECTOR = '#product-grid li.product-grid__item';
  /* EasySearch stores the complete YMM selection as one route segment. */
  var VEHICLE_PATH = /([a-z0-9][a-z0-9-]*-(?:esi|esr)\d+)/i;
  var PILOT_ROUTE = 'toyota-camry-2012-2017-2-5l-4cyl-esi6937864';
  var PILOT_HIDDEN_CODES = {
    'BQ-89467-06130': true,
    '89467-06130': true,
    'BQ-89467-06140': true,
    '89467-06140': true,
    'BQ-89615-12040': true,
    '89615-12040': true
  };
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NON_PHYSICAL_MAP_KEYS = { transmission_service: true };
  var PART_KEY_ALIASES = {
    engine_oil_filter: 'oil_filter',
    cabin_air_filter: 'cabin_filter',
    windshield_wiper_blade: 'wiper',
    ac_compressor_control_valve: 'compressor_valve',
    ac_compressor_sensor: 'compressor_valve',
    mass_air_flow_maf_sensor: 'maf_sensor',
    mass_air_flow_sensor: 'maf_sensor',
    engine_drive_belt: 'drive_belt'
  };

  /* Exact route + SKU locations keep priority.  Typed category zones are
   * available for every Toyota and Lexus route when an exact review is absent. */
  function requiresExactLocation() {
    return false;
  }

  function trustedLegacyLocationProfile(route, profileCode) {
    var code = String(profileCode || '');
    if (/^toyota-camry-/.test(String(route || ''))) {
      var choices = PROFILE_CHOICES_BY_ROUTE[route] || [];
      return choices.some(function (choice) { return choice.code === code; });
    }
    if (route === 'toyota-avalon-2013-2017-v6-esr6785114' && code === 'XX40') return true;
    return /^toyota-land-cruiser-2008-2021-/.test(String(route || '')) && code === 'J200';
  }

  /*
   * The glass-car files are deliberately external Shopify CDN assets.  The
   * scene registry is keyed by generation so the route can never show a
   * different Camry body.  Each generation has front/glass, side, rear and
   * underbody directions; an unavailable direction falls back to the matching
   * generation overview. Canvas remains the last resort when an image cannot
   * be decoded.
   */
  var PROFILE_ASSETS = {
    XV20: {
      glass: true,
      assetRevision: "camry-glass-v1",
      overview: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv20-glass.webp?v=1787397870',
      side: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv20-side.webp?v=1787398462',
      rear: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv20-rear.webp?v=1787398449',
      underbody: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv20-underbody.webp?v=1787398454'
    },
    XV30: {
      glass: true,
      assetRevision: "camry-glass-v1",
      overview: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv30-glass.webp?v=1787397862',
      side: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv30-side.webp?v=1787398485',
      rear: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv30-rear.webp?v=1787398475',
      underbody: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv30-underbody.webp?v=1787398470'
    },
    XV40: {
      glass: true,
      assetRevision: "camry-glass-v1",
      overview: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv40-glass.webp?v=1787397886',
      side: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv40-side.webp?v=1787398494',
      rear: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv40-rear.webp?v=1787398512',
      underbody: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv40-underbody.webp?v=1787398501'
    },
    XV50: {
      glass: true,
      assetRevision: "camry-glass-v1",
      overview: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv50-glass.webp?v=1787397875',
      engine: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv50-engine.webp?v=1787403446',
      side: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv50-side.webp?v=1787398506',
      rear: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv50-rear.webp?v=1787398480',
      underbody: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv50-underbody.webp?v=1787398525'
    },
    XV70: {
      glass: true,
      assetRevision: "camry-glass-v1",
      overview: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv70-glass.webp?v=1787397880',
      side: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv70-side.webp?v=1787398518',
      rear: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv70-rear.webp?v=1787398532',
      underbody: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv70-underbody.webp?v=1787398539'
    },
    J200: {
      glass: true,
      assetRevision: "glass-v4",
      overview: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-land-cruiser-j200-glass-v4.png?v=1787483858'
    },
    J300: {
      glass: true,
      assetRevision: "glass-v4",
      overview: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-land-cruiser-j300-glass-v4.png?v=1787483892'
    },
    J150: {
      glass: true,
      assetRevision: "glass-v4",
      overview: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-prado-j150-glass-v4.png?v=1787483869'
    },
    AN120: {
      glass: true,
      assetRevision: "glass-v4",
      overview: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-hilux-an120-glass-v4.png?v=1787483903'
    },
    "AURION_XV40": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-aurion-xv40-glass-v3.webp?v=1787472415",
      glass: true,
      assetRevision: "glass-v3"
    },
    "AURION_XV50": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-aurion-xv50-glass-v3.webp?v=1787472423",
      glass: true,
      assetRevision: "glass-v3"
    },
    "XX20": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-avalon-xx20-glass-v3.webp?v=1787472461",
      glass: true,
      assetRevision: "glass-v3"
    },
    "XX30": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-avalon-xx30-glass-v3.webp?v=1787472432",
      glass: true,
      assetRevision: "glass-v3"
    },
    "XX40": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-avalon-xx40-glass-v2.png?v=1787470502",
      side: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-avalon-xx40-side-glass-v2.png?v=1787470491",
      rear: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-avalon-xx40-side-glass-v2.png?v=1787470491",
      underbody: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-avalon-xx40-underbody-glass-v2.png?v=1787470481",
      glass: true
    },
    "XX50": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-avalon-xx50-glass-v3.webp?v=1787472442",
      glass: true,
      assetRevision: "glass-v3"
    },
    "E140": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-corolla-e140-glass-v3.webp?v=1787472471",
      glass: true,
      assetRevision: "glass-v3"
    },
    "E170": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-corolla-e170-glass-v3.webp?v=1787472483",
      glass: true,
      assetRevision: "glass-v3"
    },
    "E210": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-corolla-e210-glass-v3.webp?v=1787472451",
      glass: true,
      assetRevision: "glass-v3"
    },
    "XJ10": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-fj-cruiser-xj10-glass-v3.webp?v=1787472775",
      glass: true,
      assetRevision: "glass-v3"
    },
    "AN50": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-fortuner-an50-glass-v3.webp?v=1787472797",
      glass: true,
      assetRevision: "glass-v3"
    },
    "AN160": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-fortuner-an160-glass-v3.webp?v=1787472785",
      glass: true,
      assetRevision: "glass-v3"
    },
    "ZN6": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-86-zn6-glass-v3.webp?v=1787473245",
      glass: true,
      assetRevision: "glass-v3"
    },
    "H200": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-hiace-h200-glass-v4.png?v=1787484657",
      glass: true,
      assetRevision: "glass-v4"
    },
    "H300": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-hiace-h300-glass-v3.webp?v=1787473274",
      glass: true,
      assetRevision: "glass-v3"
    },
    "N70": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-hilux-n70-glass-v3.webp?v=1787472821",
      glass: true,
      assetRevision: "glass-v3"
    },
    "J100": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-land-cruiser-j100-glass-v3.webp?v=1787472832",
      glass: true,
      assetRevision: "glass-v3"
    },
    "XA30": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-rav4-xa30-glass-v3.webp?v=1787472810",
      glass: true,
      assetRevision: "glass-v3"
    },
    "XA40": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-rav4-xa40-glass-v3.webp?v=1787472854",
      glass: true,
      assetRevision: "glass-v3"
    },
    "XA50": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-rav4-xa50-glass-v3.webp?v=1787472840",
      glass: true,
      assetRevision: "glass-v3"
    },
    "XK80": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-sequoia-xk80-glass-v4.png?v=1787483881",
      glass: true,
      assetRevision: "glass-v4"
    },
    "XL20": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-sienna-xl20-glass-v3.webp?v=1787473252",
      glass: true,
      assetRevision: "glass-v3"
    },
    "XL30_PRE": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-sienna-xl30-pre-glass-v3.webp?v=1787473293",
      glass: true,
      assetRevision: "glass-v3"
    },
    "XL30_FACELIFT": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-sienna-xl30-facelift-glass-v3.webp?v=1787473281",
      glass: true,
      assetRevision: "glass-v3"
    },
    "N2XX": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-tacoma-n2xx-glass-v3.webp?v=1787473260",
      glass: true,
      assetRevision: "glass-v3"
    },
    "N300": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-tacoma-n300-glass-v3.webp?v=1787472994",
      glass: true,
      assetRevision: "glass-v3"
    },
    "XK50": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-tundra-xk50-glass-v3.webp?v=1787472984",
      glass: true,
      assetRevision: "glass-v3"
    },
    "XK70": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-tundra-xk70-glass-v3.webp?v=1787472957",
      glass: true,
      assetRevision: "glass-v3"
    },
    "XP90": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-yaris-xp90-glass-v3.webp?v=1787472976",
      glass: true,
      assetRevision: "glass-v3"
    },
    "XP150_PRE": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-yaris-xp150-pre-glass-v3.webp?v=1787473009",
      glass: true,
      assetRevision: "glass-v3"
    },
    "XP150_FACELIFT": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-yaris-xp150-facelift-glass-v3.webp?v=1787473002",
      glass: true,
      assetRevision: "glass-v3"
    },
    "AC100": {
      overview: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-toyota-yaris-ac100-glass-v3.webp?v=1787472967",
      glass: true,
      assetRevision: "glass-v3"
    }
  };

  /* Model-specific assets are injected by Liquid so every draft-theme asset
   * keeps its Shopify CDN URL.  They only supply the vehicle base; exact
   * markers still require an explicit route + SKU record below. */
  var injectedVehicleAssets = window.SenfinecoVehicleAssets || {};
  Object.keys(injectedVehicleAssets).forEach(function (profileCode) {
    PROFILE_ASSETS[profileCode] = injectedVehicleAssets[profileCode];
  });

  var PROFILE_CHOICES_BY_ROUTE = {
    "toyota-aurion-2007-2017-3-5l-v6-esi2361921": [
      {
        "code": "AURION_XV40",
        "label": "2007–2011 · XV40",
        "from": 2007,
        "to": 2011,
        "status": "split_required"
      },
      {
        "code": "AURION_XV50",
        "label": "2012–2017 · XV50",
        "from": 2012,
        "to": 2017,
        "status": "split_required"
      }
    ],
    "toyota-aurion-2013-2017-esr5283327": [
      {
        "code": "AURION_XV50",
        "label": "2013–2017 · XV50",
        "from": 2013,
        "to": 2017,
        "status": "direct"
      }
    ],
    "toyota-avalon-2000-2004-3-0l-v6-esi9037412": [
      {
        "code": "XX20",
        "label": "2000–2004 · XX20",
        "from": 2000,
        "to": 2004,
        "status": "direct"
      }
    ],
    "toyota-avalon-2007-2012-v6-esr3996771": [
      {
        "code": "XX30",
        "label": "2007–2012 · XX30",
        "from": 2007,
        "to": 2012,
        "status": "direct"
      }
    ],
    "toyota-avalon-2013-2017-v6-esr6785114": [
      {
        "code": "XX40",
        "label": "2013–2017 · XX40",
        "from": 2013,
        "to": 2017,
        "status": "direct"
      }
    ],
    "toyota-avalon-2019-2024-3-5l-v6-esi1034212": [
      {
        "code": "XX50",
        "label": "2019–2022 · XX50",
        "from": 2019,
        "to": 2022,
        "status": "year_validation_required"
      }
    ],
    "toyota-corolla-2008-2013-1-8l-4cyl-esi1214424": [
      {
        "code": "E140",
        "label": "2008–2013 · E140",
        "from": 2008,
        "to": 2013,
        "status": "direct"
      }
    ],
    "toyota-corolla-2014-2019-1-8l-4cyl-esi5121305": [
      {
        "code": "E170",
        "label": "2014–2019 · E170",
        "from": 2014,
        "to": 2019,
        "status": "direct"
      }
    ],
    "toyota-corolla-2019-2024-2-0l-4cyl-esi3521759": [
      {
        "code": "E210",
        "label": "2019–2024 · E210",
        "from": 2019,
        "to": 2024,
        "status": "direct"
      }
    ],
    "toyota-fj-cruiser-2007-2023-4-0l-v6-esi6254254": [
      {
        "code": "XJ10",
        "label": "2007–2023 · XJ10",
        "from": 2007,
        "to": 2023,
        "status": "direct"
      }
    ],
    "toyota-fj-cruiser-2011-2023-v6-esr4883839": [
      {
        "code": "XJ10",
        "label": "2011–2023 · XJ10",
        "from": 2011,
        "to": 2023,
        "status": "direct"
      }
    ],
    "toyota-fortuner-2006-2026-2-7l-4cyl-esr2778177": [
      {
        "code": "AN50",
        "label": "2006–2015 · AN50/60",
        "from": 2006,
        "to": 2015,
        "status": "split_required"
      },
      {
        "code": "AN160",
        "label": "2016–2026 · AN150/160",
        "from": 2016,
        "to": 2026,
        "status": "split_required"
      }
    ],
    "toyota-fortuner-2006-2026-4-0l-v6-esr7852650": [
      {
        "code": "AN50",
        "label": "2006–2015 · AN50/60",
        "from": 2006,
        "to": 2015,
        "status": "split_required"
      },
      {
        "code": "AN160",
        "label": "2016–2026 · AN150/160",
        "from": 2016,
        "to": 2026,
        "status": "split_required"
      }
    ],
    "toyota-gt86--86-2012-2020-2-0l-boxer-4cyl-esr6576653": [
      {
        "code": "ZN6",
        "label": "2012–2020 · ZN6",
        "from": 2012,
        "to": 2020,
        "status": "direct"
      }
    ],
    "toyota-hiace-2005-2018-2-7l-4cyl-esr3477303": [
      {
        "code": "H200",
        "label": "2005–2018 · H200",
        "from": 2005,
        "to": 2018,
        "status": "direct"
      }
    ],
    "toyota-hiace-2019-2026-3-5l-v6-esr5654306": [
      {
        "code": "H300",
        "label": "2019–2026 · H300",
        "from": 2019,
        "to": 2026,
        "status": "direct"
      }
    ],
    "toyota-hilux-2006-2015-2-0l-4cyl-esi7777604": [
      {
        "code": "N70",
        "label": "2006–2015 · AN10/20/30",
        "from": 2006,
        "to": 2015,
        "status": "direct"
      }
    ],
    "toyota-hilux-2006-2015-2-7l-4cyl-esr9317937": [
      {
        "code": "N70",
        "label": "2006–2015 · AN10/20/30",
        "from": 2006,
        "to": 2015,
        "status": "direct"
      }
    ],
    "toyota-land-cruiser-1999-2007-4-0l-v6-esr3497629": [
      {
        "code": "J100",
        "label": "1999–2007 · J100",
        "from": 1999,
        "to": 2007,
        "status": "direct"
      }
    ],
    "toyota-land-cruiser-1999-2007-4-7l-v8-esr7401462": [
      {
        "code": "J100",
        "label": "1999–2007 · J100",
        "from": 1999,
        "to": 2007,
        "status": "direct"
      }
    ],
    "toyota-rav4-2006-2018-3-5l-v6-esr4544844": [
      {
        "code": "XA30",
        "label": "2006–2012 · XA30",
        "from": 2006,
        "to": 2012,
        "status": "route_error"
      }
    ],
    "toyota-rav4-2013-2018-2-5l-4cyl-esr8427981": [
      {
        "code": "XA40",
        "label": "2013–2018 · XA40",
        "from": 2013,
        "to": 2018,
        "status": "direct"
      }
    ],
    "toyota-rav4-2019-2024-2-5l-4cyl-esi2057141": [
      {
        "code": "XA50",
        "label": "2019–2024 · XA50",
        "from": 2019,
        "to": 2024,
        "status": "direct"
      }
    ],
    "toyota-sequoia-2023-2026-3-5l-v6-hybrid-esr9313787": [
      {
        "code": "XK80",
        "label": "2023–2026 · XK80",
        "from": 2023,
        "to": 2026,
        "status": "direct"
      }
    ],
    "toyota-sienna-2007-2016-3-5l-v6-esi6360054": [
      {
        "code": "XL20",
        "label": "2007–2010 · XL20",
        "from": 2007,
        "to": 2010,
        "status": "split_required"
      },
      {
        "code": "XL30_PRE",
        "label": "2011–2016 · XL30",
        "from": 2011,
        "to": 2016,
        "status": "split_required"
      }
    ],
    "toyota-sienna-2017-2020-3-5l-v6-esi6550260": [
      {
        "code": "XL30_FACELIFT",
        "label": "2017–2020 · XL30 facelift",
        "from": 2017,
        "to": 2020,
        "status": "direct"
      }
    ],
    "toyota-tacoma-2005-2023-2-7l-4cyl-esr8292228": [
      {
        "code": "N2XX",
        "label": "2005–2015 · N2xx",
        "from": 2005,
        "to": 2015,
        "status": "split_required"
      },
      {
        "code": "N300",
        "label": "2016–2023 · N300",
        "from": 2016,
        "to": 2023,
        "status": "split_required"
      }
    ],
    "toyota-tacoma-2016-2023-3-5l-v6-esr8935258": [
      {
        "code": "N300",
        "label": "2016–2023 · N300",
        "from": 2016,
        "to": 2023,
        "status": "direct"
      }
    ],
    "toyota-tundra-2007-2021-5-7l-v8-esr9668147": [
      {
        "code": "XK50",
        "label": "2007–2021 · XK50",
        "from": 2007,
        "to": 2021,
        "status": "direct"
      }
    ],
    "toyota-tundra-2022-2026-3-5l-v6-turbo-esr8640439": [
      {
        "code": "XK70",
        "label": "2022–2026 · XK70",
        "from": 2022,
        "to": 2026,
        "status": "direct"
      }
    ],
    "toyota-yaris-2006-2013-1-3l-4cyl-esi3399741": [
      {
        "code": "XP90",
        "label": "2006–2013 · XP90",
        "from": 2006,
        "to": 2013,
        "status": "direct"
      }
    ],
    "toyota-yaris-2006-2017-1-5l-4cyl-esr5595038": [
      {
        "code": "XP90",
        "label": "2006–2013 · XP90",
        "from": 2006,
        "to": 2013,
        "status": "split_required"
      },
      {
        "code": "XP150_PRE",
        "label": "2014–2017 · XP150",
        "from": 2014,
        "to": 2017,
        "status": "split_required"
      }
    ],
    "toyota-yaris-2014-2022-1-3l-4cyl-esi7615832": [
      {
        "code": "XP150_PRE",
        "label": "2014–2017 · XP150",
        "from": 2014,
        "to": 2017,
        "status": "split_required"
      },
      {
        "code": "XP150_FACELIFT",
        "label": "2018–2022 · XP150 facelift",
        "from": 2018,
        "to": 2022,
        "status": "split_required"
      }
    ],
    "toyota-yaris-2018-2024-1-5l-4cyl-esr5203508": [
      {
        "code": "XP150_FACELIFT",
        "label": "2018–2022 · XP150 facelift",
        "from": 2018,
        "to": 2022,
        "status": "split_required"
      },
      {
        "code": "AC100",
        "label": "2023–2024 · AC100",
        "from": 2023,
        "to": 2024,
        "status": "split_required"
      }
    ],
    "toyota-camry-1998-2001-3-0l-v6-esr5312582": [
      {
        "code": "XV20",
        "label": "1998–2001 · XV20",
        "from": 1998,
        "to": 2001,
        "status": "direct"
      }
    ],
    "toyota-camry-2002-2006-2-4l-4cyl-esr2068487": [
      {
        "code": "XV30",
        "label": "2002–2006 · XV30",
        "from": 2002,
        "to": 2006,
        "status": "direct"
      }
    ],
    "toyota-camry-2002-2006-3-0l-v6-esr5508564": [
      {
        "code": "XV30",
        "label": "2002–2006 · XV30",
        "from": 2002,
        "to": 2006,
        "status": "direct"
      }
    ],
    "toyota-camry-2007-2011-2-4l-4cyl-esr2431563": [
      {
        "code": "XV40",
        "label": "2007–2011 · XV40",
        "from": 2007,
        "to": 2011,
        "status": "direct"
      }
    ],
    "toyota-camry-2007-2011-3-5l-v6-esi1697382": [
      {
        "code": "XV40",
        "label": "2007–2011 · XV40",
        "from": 2007,
        "to": 2011,
        "status": "direct"
      }
    ],
    "toyota-camry-2012-2017-2-5l-4cyl-esi6937864": [
      {
        "code": "XV50",
        "label": "2012–2017 · XV50",
        "from": 2012,
        "to": 2017,
        "status": "direct"
      }
    ],
    "toyota-camry-2012-2017-3-5l-v6-esi4119943": [
      {
        "code": "XV50",
        "label": "2012–2017 · XV50",
        "from": 2012,
        "to": 2017,
        "status": "direct"
      }
    ],
    "toyota-camry-2018-2023-2-5l-4cyl-esi6467877": [
      {
        "code": "XV70",
        "label": "2018–2023 · XV70",
        "from": 2018,
        "to": 2023,
        "status": "direct"
      }
    ],
    "toyota-camry-2018-2023-3-5l-v6-esr6765415": [
      {
        "code": "XV70",
        "label": "2018–2023 · XV70",
        "from": 2018,
        "to": 2023,
        "status": "direct"
      }
    ],
    "toyota-hilux-2016-2024-2-7l-4cyl-esi2331860": [
      {
        "code": "AN120",
        "label": "2016–2024 · AN120",
        "from": 2016,
        "to": 2024,
        "status": "direct"
      }
    ],
    "toyota-hilux-2016-2026-4-0l-v6-esi5977940": [
      {
        "code": "AN120",
        "label": "2016–2026 · AN120",
        "from": 2016,
        "to": 2026,
        "status": "direct"
      }
    ],
    "toyota-land-cruiser-2008-2021-4-0l-v6-esr2768890": [
      {
        "code": "J200",
        "label": "2008–2021 · J200",
        "from": 2008,
        "to": 2021,
        "status": "direct"
      }
    ],
    "toyota-land-cruiser-2008-2021-4-6l-v8-esr1948861": [
      {
        "code": "J200",
        "label": "2008–2021 · J200",
        "from": 2008,
        "to": 2021,
        "status": "direct"
      }
    ],
    "toyota-land-cruiser-2008-2021-5-7l-v8-esr3444555": [
      {
        "code": "J200",
        "label": "2008–2021 · J200",
        "from": 2008,
        "to": 2021,
        "status": "direct"
      }
    ],
    "toyota-land-cruiser-2022-2026-3-5l-v6-turbo-esr6383321": [
      {
        "code": "J300",
        "label": "2022–2026 · J300",
        "from": 2022,
        "to": 2026,
        "status": "direct"
      }
    ],
    "toyota-prado-2010-2023-2-7l-4cyl-esr9186963": [
      {
        "code": "J150",
        "label": "2010–2023 · J150",
        "from": 2010,
        "to": 2023,
        "status": "direct"
      }
    ],
    "toyota-prado-2010-2023-4-0l-v6-esr3212527": [
      {
        "code": "J150",
        "label": "2010–2023 · J150",
        "from": 2010,
        "to": 2023,
        "status": "direct"
      }
    ]
  };
  var SELECTED_PROFILE_BY_ROUTE = Object.create(null);

  var SCENE_VIEWS = {
    overview:     { scene: 'overview',     x: 50, y: 50, scale: 1,    turn: 0,   anchor: [50, 51] },
    engine:       { scene: 'overview',     x: 57, y: 36, scale: 2.05, turn: -2,  anchor: [61, 38] },
    engine_low:   { scene: 'overview',     x: 51, y: 55, scale: 2.35, turn: -3,  anchor: [48, 58] },
    cabin:        { scene: 'side',         x: 50, y: 49, scale: 1.82, turn: 1,   anchor: [57, 48] },
    underbody:    { scene: 'underbody',    x: 48, y: 66, scale: 1.95, turn: 0,   anchor: [50, 67] },
    front_wheels: { scene: 'side',         x: 67, y: 58, scale: 2.08, turn: -4,  anchor: [72, 61] },
    rear_wheels:  { scene: 'rear',         x: 28, y: 58, scale: 2.08, turn: 4,   anchor: [27, 61] },
    windshield:   { scene: 'side',         x: 50, y: 37, scale: 1.72, turn: 0,   anchor: [50, 37] },
    front:        { scene: 'overview',     x: 66, y: 47, scale: 1.9,  turn: -3,  anchor: [72, 48] }
  };

  var state = {
    available: new Map(),
    selected: [],
    activeKey: '',
    activeProductId: '',
    activeLocation: null,
    modal: null,
    canvas: null,
    context: null,
    visual: null,
    realScene: null,
    sceneCamera: null,
    sceneImage: null,
    sceneCallout: null,
    sceneCalloutImage: null,
    sceneCalloutName: null,
    sceneConfidence: null,
    sceneInstalled: null,
    scenePending: null,
    beltOverlay: null,
    stage: null,
    gallery: null,
    galleryList: null,
    galleryTitle: null,
    realReady: false,
    sceneView: null,
    sceneZoom: 1,
    scenePanX: 0,
    scenePanY: 0,
    markers: null,
    partsList: null,
    selectedList: null,
    search: null,
    statusTitle: null,
    statusNote: null,
    vehicleLabel: null,
    generationList: null,
    creditLink: null,
    launchButton: null,
    lastFocus: null,
    profile: null,
    camera: { yaw: -0.62, pitch: 0.52, zoom: 0.92, focus: [0, 0, 0.68] },
    tweenFrame: 0,
    dragging: false,
    pointerStart: null,
    pointers: new Map(),
    pinchDistance: 0,
    observer: null,
    resizeObserver: null
  };

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[\u064b-\u065f\u0670]/g, '')
      .replace(/[إأآ]/g, 'ا')
      .replace(/ى/g, 'ي')
      .replace(/ة/g, 'ه')
      .replace(/ؤ/g, 'و')
      .replace(/ئ/g, 'ي')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function includesAny(haystack, needles) {
    for (var i = 0; i < needles.length; i += 1) {
      if (haystack.indexOf(needles[i]) !== -1) return true;
    }
    return false;
  }

  var PARTS = {
    oxygen_b1s1: {
      ar: 'حساس A/F — Bank 1 Sensor 1',
      en: 'Bank 1 Sensor 1 · upstream',
      icon: 'λ',
      zone: 'engine',
      points: [[0.38, 1.04, 0.48]]
    },
    oxygen_b2s1: {
      ar: 'حساس A/F — Bank 2 Sensor 1',
      en: 'Bank 2 Sensor 1 · upstream',
      icon: 'λ',
      zone: 'engine',
      points: [[-0.38, 1.04, 0.48]]
    },
    oxygen_b1s2: {
      ar: 'حساس O₂ — Bank 1 Sensor 2',
      en: 'Bank 1 Sensor 2 · downstream',
      icon: 'λ',
      zone: 'underbody',
      points: [[0.3, 0.16, 0.27]]
    },
    oxygen_b2s2: {
      ar: 'حساس O₂ — Bank 2 Sensor 2',
      en: 'Bank 2 Sensor 2 · downstream',
      icon: 'λ',
      zone: 'underbody',
      points: [[-0.3, 0.16, 0.27]]
    },
    oxygen_front_left: {
      ar: 'حساس الهواء/الأكسجين — أمامي يسار',
      en: 'Front LH Air/Fuel or O₂ sensor',
      icon: 'λ',
      zone: 'engine',
      points: [[-0.38, 1.04, 0.48]]
    },
    oxygen_front_right: {
      ar: 'حساس الهواء/الأكسجين — أمامي يمين',
      en: 'Front RH Air/Fuel or O₂ sensor',
      icon: 'λ',
      zone: 'engine',
      points: [[0.38, 1.04, 0.48]]
    },
    oxygen_front: {
      ar: 'حساس الهواء/الأكسجين الأمامي',
      en: 'Upstream Air/Fuel or O₂ sensor',
      icon: 'λ',
      zone: 'engine',
      points: [[0, 1.06, 0.49]]
    },
    oxygen_rear: {
      ar: 'حساس الأكسجين الخلفي',
      en: 'Downstream O₂ sensor',
      icon: 'λ',
      zone: 'underbody',
      points: [[0, 0.05, 0.27]]
    },
    maf_sensor: {
      ar: 'حساس كتلة الهواء MAF',
      en: 'Mass air flow sensor',
      icon: '≋',
      zone: 'engine',
      points: [[0.59, 1.58, 0.83]]
    },
    knock_sensor: {
      ar: 'حساس الطرق (Knock Sensor)',
      en: 'Knock sensor',
      icon: '◉',
      zone: 'engine',
      points: [[0, 1.08, 0.59]]
    },
    ac_pressure_sensor: {
      ar: 'حساس ضغط المكيّف',
      en: 'A/C pressure sensor',
      icon: '❄',
      zone: 'engine',
      points: [[0.65, 1.72, 0.64]]
    },
    ignition_coil: {
      ar: 'كويلات الإشعال',
      en: 'Ignition coils',
      icon: 'ϟ',
      zone: 'engine',
      dynamic: 'cylinders'
    },
    spark_plug: {
      ar: 'شمعات الاحتراق (البواجي)',
      en: 'Spark plugs',
      icon: 'ϟ',
      zone: 'engine',
      dynamic: 'cylinders_low'
    },
    cabin_filter: {
      ar: 'فلتر المكيّف داخل المقصورة',
      en: 'Cabin air filter',
      icon: '▥',
      zone: 'cabin',
      points: [[0.46, 0.17, 1.04]]
    },
    engine_air_filter: {
      ar: 'فلتر هواء المحرك',
      en: 'Engine air filter',
      icon: '▥',
      zone: 'engine',
      points: [[0.6, 1.45, 0.8]]
    },
    oil_filter: {
      ar: 'فلتر زيت المحرك',
      en: 'Engine oil filter',
      icon: '●',
      zone: 'engine_low',
      points: [[-0.29, 1.18, 0.39]]
    },
    transmission_filter: {
      ar: 'فلتر ناقل الحركة',
      en: 'Transmission filter',
      icon: '▰',
      zone: 'underbody',
      points: [[-0.43, 0.77, 0.25]]
    },
    brake_front: {
      ar: 'سفايف/فحمات الفرامل الأمامية',
      en: 'Front brake pads',
      icon: '◍',
      zone: 'front_wheels',
      points: [[-0.94, 1.45, 0.46], [0.94, 1.45, 0.46]]
    },
    brake_rear: {
      ar: 'سفايف/فحمات الفرامل الخلفية',
      en: 'Rear brake pads',
      icon: '◍',
      zone: 'rear_wheels',
      points: [[-0.94, -1.42, 0.46], [0.94, -1.42, 0.46]]
    },
    wiper: {
      ar: 'مسّاحات الزجاج الأمامي',
      en: 'Front wipers',
      icon: '⌁',
      zone: 'windshield',
      points: [[-0.38, 0.52, 1.19], [0.38, 0.52, 1.19]]
    },
    transmission_service: {
      ar: 'خدمة زيت ناقل الحركة ATF',
      en: 'Transmission fluid service point',
      icon: '◒',
      zone: 'underbody',
      points: [[-0.42, 0.82, 0.32]]
    },
    ac_system: {
      ar: 'نظام تكييف السيارة',
      en: 'Vehicle A/C system',
      icon: '❄',
      zone: 'engine',
      points: [[-0.57, 1.2, 0.43], [0.35, 0.1, 1.04]]
    },
    ac_evaporator: {
      ar: 'مبخر المكيّف',
      en: 'A/C evaporator',
      icon: '▤',
      zone: 'cabin',
      points: [[0.35, 0.1, 1.04]]
    },
    thermostat: {
      ar: 'بلف الحرارة (الثرموستات)',
      en: 'Engine thermostat',
      icon: '◐',
      zone: 'engine',
      points: [[0.37, 1.61, 0.62]]
    },
    brake_vacuum_pump: {
      ar: 'مضخة فاكيوم الفرامل',
      en: 'Brake vacuum pump',
      icon: '◎',
      zone: 'engine',
      points: [[-0.52, 1.02, 0.69]]
    },
    drive_belt: {
      ar: 'سير المحرك',
      en: 'Engine drive belt',
      icon: '∞',
      zone: 'engine',
      points: [[0.68, 1.2, 0.6]]
    },
    compressor_valve: {
      ar: 'حساس/صمام تحكم كمبريسر المكيّف',
      en: 'A/C compressor control solenoid / valve',
      icon: '❄',
      zone: 'engine_low',
      points: [[-0.58, 1.2, 0.41]]
    },
    radiator: {
      ar: 'الراديتر',
      en: 'Radiator',
      icon: '▦',
      zone: 'front',
      points: [[0, 2.08, 0.66]]
    },
    radiator_hose_upper: {
      ar: 'هوز/خرطوم الراديتر العلوي',
      en: 'Upper radiator hose',
      icon: '⌇',
      zone: 'engine',
      points: [[0.17, 1.74, 0.84]]
    },
    radiator_hose_lower: {
      ar: 'هوز/خرطوم الراديتر السفلي',
      en: 'Lower radiator hose',
      icon: '⌇',
      zone: 'engine_low',
      points: [[-0.17, 1.78, 0.43]]
    },
    water_pump: {
      ar: 'طرمبة/مضخة الماء',
      en: 'Engine water pump',
      icon: '◉',
      zone: 'engine',
      points: [[0.55, 1.28, 0.58]]
    },
    engine_mount_left_upper: {
      ar: 'كرسي المكينة العلوي يسار',
      en: 'Upper LH engine mount',
      icon: '◆',
      zone: 'engine',
      points: [[-0.73, 1.12, 0.76]]
    },
    engine_mount_right_upper: {
      ar: 'كرسي المكينة العلوي يمين',
      en: 'Upper RH engine mount',
      icon: '◆',
      zone: 'engine',
      points: [[0.73, 1.12, 0.76]]
    },
    engine_mount_front: {
      ar: 'كرسي المكينة الأمامي',
      en: 'Front engine mount',
      icon: '◆',
      zone: 'engine',
      points: [[0, 1.77, 0.58]]
    },
    engine_mount_rear: {
      ar: 'كرسي المكينة الخلفي',
      en: 'Rear engine mount',
      icon: '◆',
      zone: 'engine',
      points: [[0, 0.65, 0.53]]
    },
    fuel_pump: {
      ar: 'طرمبة/مضخة الوقود (فيول بمب)',
      en: 'Fuel pump · inside fuel tank',
      icon: '⛽',
      zone: 'underbody',
      points: [[0, -0.68, 0.34]]
    },
    shock_absorber_front: {
      ar: 'المساعد الأمامي',
      en: 'Front shock absorber / strut',
      icon: '↕',
      zone: 'front_wheels',
      points: [[-0.82, 1.4, 0.62], [0.82, 1.4, 0.62]]
    },
    shock_absorber_rear: {
      ar: 'المساعد الخلفي',
      en: 'Rear shock absorber',
      icon: '↕',
      zone: 'rear_wheels',
      points: [[-0.82, -1.38, 0.62], [0.82, -1.38, 0.62]]
    },
    steering_tie_rod: {
      ar: 'رود/تي رود الدركسون',
      en: 'Steering tie rod / rack end',
      icon: '↔',
      zone: 'front_wheels',
      points: [[-0.78, 1.28, 0.4], [0.78, 1.28, 0.4]]
    },
    belt_tensioner: {
      ar: 'شداد السير',
      en: 'Drive belt tensioner',
      icon: '◉',
      zone: 'engine',
      points: [[0.58, 1.24, 0.58]]
    },
    idler_pulley: {
      ar: 'بكرة/رمانة السير',
      en: 'Drive belt idler pulley / bearing',
      icon: '⊙',
      zone: 'engine',
      points: [[0.45, 1.34, 0.6]]
    }
  };

  /*
   * Keep the physical catalogue understandable even when a selected vehicle
   * has no product in a category.  Missing categories are shown as neutral,
   * disabled rows; they never create a marker, move the camera or imply
   * fitment.  Oxygen-sensor positions are grouped into front/rear families so
   * the unavailable list does not repeat Bank/side variants.
   */
  var DISCOVERABLE_PHYSICAL_PARTS = [
    { key: 'oxygen_front', members: ['oxygen_front', 'oxygen_front_left', 'oxygen_front_right', 'oxygen_b1s1', 'oxygen_b2s1'], terms: 'حساس اكسجين أمامي حساس الهواء والوقود oxygen o2 air fuel upstream' },
    { key: 'oxygen_rear', members: ['oxygen_rear', 'oxygen_b1s2', 'oxygen_b2s2'], terms: 'حساس اكسجين خلفي oxygen o2 downstream' },
    { key: 'maf_sensor' },
    { key: 'knock_sensor' },
    { key: 'ac_pressure_sensor' },
    { key: 'compressor_valve' },
    { key: 'ac_evaporator', terms: 'ثلاجة المكيف ثلاجه المكيف مبخر المكيف evaporator ac' },
    { key: 'ignition_coil' },
    { key: 'spark_plug' },
    { key: 'drive_belt', terms: 'سيور المحرك سير المحرك سير المكينة سير مكينه drive serpentine belt' },
    { key: 'engine_air_filter' },
    { key: 'cabin_filter' },
    { key: 'oil_filter' },
    { key: 'transmission_filter' },
    { key: 'thermostat' },
    { key: 'radiator' },
    { key: 'radiator_hose_upper' },
    { key: 'radiator_hose_lower' },
    { key: 'water_pump' },
    { key: 'brake_vacuum_pump' },
    { key: 'brake_front' },
    { key: 'brake_rear' },
    { key: 'wiper' },
    { key: 'engine_mount_left_upper' },
    { key: 'engine_mount_right_upper' },
    { key: 'engine_mount_front' },
    { key: 'engine_mount_rear' },
    { key: 'fuel_pump', terms: 'فيول بمب طرمبة بنزين مضخة وقود fuel pump' },
    { key: 'shock_absorber_front', terms: 'مساعد امامي shock absorber strut front' },
    { key: 'shock_absorber_rear', terms: 'مساعد خلفي shock absorber rear' },
    { key: 'steering_tie_rod', terms: 'رود تي رود rack end tie rod دركسون' },
    { key: 'belt_tensioner', terms: 'شداد السير belt tensioner' },
    { key: 'idler_pulley', terms: 'بكرة السير رمانة السير ميرانية السير idler pulley bearing' }
  ];

  function discoverableMembers(entry) {
    return entry.members || [entry.key];
  }

  function discoverableAvailable(entry) {
    return discoverableMembers(entry).some(function (key) {
      return state.available.has(key) && state.available.get(key).length > 0;
    });
  }

  function discoverableSearchText(entry) {
    var part = PARTS[entry.key];
    return normalize((part ? part.ar + ' ' + part.en : '') + ' ' + (entry.terms || ''));
  }

  /* Normalised anchors are relative to the active real-image scene. */
  var PART_SCENES = {
    oxygen_front_left:       { anchor: [39, 43], scale: 2.45, scene: 'side' },
    oxygen_front_right:      { anchor: [63, 43], scale: 2.45, scene: 'side' },
    oxygen_front:            { anchor: [52, 43], scale: 2.45 },
    oxygen_rear:             { anchor: [49, 60], scale: 2.35, scene: 'rear' },
    maf_sensor:              { anchor: [67, 35], scale: 2.65 },
    knock_sensor:            { anchor: [49, 44], scale: 2.7 },
    ac_pressure_sensor:      { anchor: [69, 47], scale: 2.55 },
    ignition_coil:           { anchor: [50, 36], scale: 2.55 },
    spark_plug:              { anchor: [50, 40], scale: 2.75 },
    cabin_filter:            { anchor: [60, 48], scale: 2.25 },
    engine_air_filter:       { anchor: [66, 37], scale: 2.55 },
    oil_filter:              { anchor: [39, 59], scale: 2.8 },
    transmission_filter:     { anchor: [43, 66], scale: 2.55 },
    brake_front:             { anchor: [72, 61], scale: 2.45 },
    brake_rear:              { anchor: [27, 61], scale: 2.45 },
    wiper:                   { anchor: [51, 36], scale: 2.1 },
    transmission_service:    { anchor: [43, 64], scale: 2.45 },
    ac_system:               { anchor: [60, 48], scale: 2.3 },
    thermostat:              { anchor: [60, 43], scale: 2.65 },
    brake_vacuum_pump:       { anchor: [39, 40], scale: 2.65 },
    drive_belt:              { anchor: [66, 50], scale: 2.95, scene: 'overview' },
    compressor_valve:        { anchor: [40, 46], scale: 3.2, scene: 'underbody' },
    radiator:                { anchor: [73, 48], scale: 2.25 },
    radiator_hose_upper:     { anchor: [56, 41], scale: 2.6 },
    radiator_hose_lower:     { anchor: [48, 58], scale: 2.7 },
    water_pump:              { anchor: [61, 51], scale: 2.8 },
    engine_mount_left_upper: { anchor: [35, 41], scale: 2.7 },
    engine_mount_right_upper:{ anchor: [70, 42], scale: 2.7 },
    engine_mount_front:      { anchor: [54, 55], scale: 2.65 },
    engine_mount_rear:       { anchor: [46, 53], scale: 2.65 },
    fuel_pump:                { anchor: [50, 68], scale: 2.25, scene: 'underbody' },
    shock_absorber_front:     { anchor: [72, 58], scale: 2.25, scene: 'side' },
    shock_absorber_rear:      { anchor: [28, 58], scale: 2.25, scene: 'rear' },
    steering_tie_rod:         { anchor: [69, 62], scale: 2.35, scene: 'side' },
    belt_tensioner:           { anchor: [62, 49], scale: 2.45, scene: 'overview' },
    idler_pulley:             { anchor: [58, 46], scale: 2.45, scene: 'overview' }
  };

  /*
   * Spatial anchors calibrated against every non-Camry Toyota glass asset.
   * Coordinates are percentages of the uncropped source image.  They describe
   * the correct mechanical zone on the active generation; they are never used
   * without a route, generation, physical part key and a real product SKU.
   */
  var TOYOTA_GLASS_PROFILE_ZONES = {
  "AURION_XV40": {
    "engine_top": [
      74,
      49
    ],
    "engine_airbox": [
      86,
      46
    ],
    "maf": [
      81,
      43
    ],
    "engine_lower": [
      70,
      61
    ],
    "belt_side": [
      69,
      66
    ],
    "compressor_lower": [
      72,
      70
    ],
    "transmission_lower": [
      63,
      61
    ],
    "exhaust_front": [
      53,
      64
    ],
    "exhaust_rear": [
      36,
      62
    ],
    "dash_passenger": [
      68,
      35
    ],
    "windshield_driver": [
      60,
      37
    ],
    "windshield_passenger": [
      68,
      36
    ],
    "front_wheel": [
      56,
      72
    ],
    "rear_wheel": [
      11,
      56
    ],
    "fuel_tank": [
      25,
      49
    ]
  },
  "AURION_XV50": {
    "engine_top": [
      74,
      47
    ],
    "engine_airbox": [
      86,
      45
    ],
    "maf": [
      82,
      42
    ],
    "engine_lower": [
      69,
      59
    ],
    "belt_side": [
      67,
      65
    ],
    "compressor_lower": [
      70,
      69
    ],
    "transmission_lower": [
      62,
      59
    ],
    "exhaust_front": [
      54,
      61
    ],
    "exhaust_rear": [
      35,
      58
    ],
    "dash_passenger": [
      68,
      34
    ],
    "windshield_driver": [
      60,
      38
    ],
    "windshield_passenger": [
      68,
      37
    ],
    "front_wheel": [
      56,
      69
    ],
    "rear_wheel": [
      12,
      51
    ],
    "fuel_tank": [
      25,
      47
    ]
  },
  "XX20": {
    "engine_top": [
      74,
      49
    ],
    "engine_airbox": [
      86,
      47
    ],
    "maf": [
      81,
      43
    ],
    "engine_lower": [
      70,
      59
    ],
    "belt_side": [
      68,
      66
    ],
    "compressor_lower": [
      71,
      70
    ],
    "transmission_lower": [
      62,
      60
    ],
    "exhaust_front": [
      53,
      67
    ],
    "exhaust_rear": [
      35,
      64
    ],
    "dash_passenger": [
      60,
      37
    ],
    "windshield_driver": [
      61,
      39
    ],
    "windshield_passenger": [
      69,
      38
    ],
    "front_wheel": [
      56,
      72
    ],
    "rear_wheel": [
      13,
      57
    ],
    "fuel_tank": [
      25,
      50
    ]
  },
  "XX30": {
    "engine_top": [
      75,
      49
    ],
    "engine_airbox": [
      86,
      45
    ],
    "maf": [
      81,
      42
    ],
    "engine_lower": [
      69,
      59
    ],
    "belt_side": [
      67,
      66
    ],
    "compressor_lower": [
      71,
      70
    ],
    "transmission_lower": [
      62,
      60
    ],
    "exhaust_front": [
      54,
      65
    ],
    "exhaust_rear": [
      37,
      61
    ],
    "dash_passenger": [
      68,
      35
    ],
    "windshield_driver": [
      61,
      37
    ],
    "windshield_passenger": [
      69,
      36
    ],
    "front_wheel": [
      56,
      71
    ],
    "rear_wheel": [
      12,
      54
    ],
    "fuel_tank": [
      25,
      50
    ]
  },
  "XX40": {
    "engine_top": [78, 47],
    "engine_airbox": [87, 42],
    "maf": [83, 44],
    "engine_lower": [76, 55],
    "belt_side": [82, 51],
    "compressor_lower": [79, 59],
    "transmission_lower": [68, 58],
    "exhaust_front": [72, 57],
    "exhaust_rear": [38, 63],
    "dash_passenger": [72, 45],
    "windshield_driver": [63, 36],
    "windshield_passenger": [73, 36],
    "front_wheel": [84, 68],
    "rear_wheel": [18, 67],
    "fuel_tank": [38, 62]
  },
  "XX50": {
    "engine_top": [
      78,
      48
    ],
    "engine_airbox": [
      88,
      49
    ],
    "maf": [
      84,
      45
    ],
    "engine_lower": [
      74,
      57
    ],
    "belt_side": [
      69,
      59
    ],
    "compressor_lower": [
      71,
      64
    ],
    "transmission_lower": [
      66,
      59
    ],
    "exhaust_front": [
      54,
      66
    ],
    "exhaust_rear": [
      34,
      62
    ],
    "dash_passenger": [
      70,
      37
    ],
    "windshield_driver": [
      62,
      39
    ],
    "windshield_passenger": [
      70,
      38
    ],
    "front_wheel": [
      58,
      71
    ],
    "rear_wheel": [
      12,
      55
    ],
    "fuel_tank": [
      25,
      52
    ]
  },
  "E140": {
    "engine_top": [
      74,
      45
    ],
    "engine_airbox": [
      86,
      45
    ],
    "maf": [
      82,
      43
    ],
    "engine_lower": [
      70,
      60
    ],
    "belt_side": [
      73,
      65
    ],
    "compressor_lower": [
      73,
      69
    ],
    "transmission_lower": [
      63,
      60
    ],
    "exhaust_front": [
      54,
      61
    ],
    "exhaust_rear": [
      33,
      59
    ],
    "dash_passenger": [
      68,
      35
    ],
    "windshield_driver": [
      60,
      37
    ],
    "windshield_passenger": [
      68,
      36
    ],
    "front_wheel": [
      56,
      69
    ],
    "rear_wheel": [
      11,
      54
    ],
    "fuel_tank": [
      28,
      49
    ]
  },
  "E170": {
    "engine_top": [
      73,
      46
    ],
    "engine_airbox": [
      86,
      45
    ],
    "maf": [
      82,
      43
    ],
    "engine_lower": [
      69,
      61
    ],
    "belt_side": [
      67,
      66
    ],
    "compressor_lower": [
      70,
      70
    ],
    "transmission_lower": [
      62,
      61
    ],
    "exhaust_front": [
      54,
      64
    ],
    "exhaust_rear": [
      29,
      62
    ],
    "dash_passenger": [
      68,
      36
    ],
    "windshield_driver": [
      61,
      38
    ],
    "windshield_passenger": [
      69,
      37
    ],
    "front_wheel": [
      56,
      72
    ],
    "rear_wheel": [
      12,
      55
    ],
    "fuel_tank": [
      27,
      52
    ]
  },
  "E210": {
    "engine_top": [
      76,
      45
    ],
    "engine_airbox": [
      86,
      46
    ],
    "maf": [
      82,
      44
    ],
    "engine_lower": [
      71,
      58
    ],
    "belt_side": [
      69,
      62
    ],
    "compressor_lower": [
      72,
      66
    ],
    "transmission_lower": [
      64,
      59
    ],
    "exhaust_front": [
      54,
      62
    ],
    "exhaust_rear": [
      30,
      60
    ],
    "dash_passenger": [
      69,
      35
    ],
    "windshield_driver": [
      62,
      37
    ],
    "windshield_passenger": [
      70,
      36
    ],
    "front_wheel": [
      56,
      69
    ],
    "rear_wheel": [
      11,
      54
    ],
    "fuel_tank": [
      25,
      52
    ]
  },
  "ZN6": {
    "engine_top": [
      76,
      55
    ],
    "engine_airbox": [
      87,
      55
    ],
    "maf": [
      83,
      54
    ],
    "engine_lower": [
      75,
      68
    ],
    "belt_side": [
      84,
      66
    ],
    "compressor_lower": [
      79,
      69
    ],
    "transmission_lower": [
      54,
      56
    ],
    "exhaust_front": [
      70,
      68
    ],
    "exhaust_rear": [
      39,
      61
    ],
    "dash_passenger": [
      64,
      35
    ],
    "windshield_driver": [
      57,
      36
    ],
    "windshield_passenger": [
      65,
      35
    ],
    "front_wheel": [
      51,
      70
    ],
    "rear_wheel": [
      7,
      50
    ],
    "fuel_tank": [
      23,
      47
    ]
  },
  "XP90": {
    "engine_top": [
      74,
      46
    ],
    "engine_airbox": [
      87,
      46
    ],
    "maf": [
      82,
      50
    ],
    "engine_lower": [
      72,
      57
    ],
    "belt_side": [
      74,
      63
    ],
    "compressor_lower": [
      74,
      69
    ],
    "transmission_lower": [
      66,
      60
    ],
    "exhaust_front": [
      55,
      64
    ],
    "exhaust_rear": [
      39,
      63
    ],
    "dash_passenger": [
      68,
      36
    ],
    "windshield_driver": [
      61,
      38
    ],
    "windshield_passenger": [
      69,
      37
    ],
    "front_wheel": [
      63,
      74
    ],
    "rear_wheel": [
      13,
      55
    ],
    "fuel_tank": [
      31,
      52
    ]
  },
  "XP150_PRE": {
    "engine_top": [
      73,
      47
    ],
    "engine_airbox": [
      86,
      46
    ],
    "maf": [
      81,
      49
    ],
    "engine_lower": [
      71,
      57
    ],
    "belt_side": [
      73,
      61
    ],
    "compressor_lower": [
      74,
      68
    ],
    "transmission_lower": [
      65,
      61
    ],
    "exhaust_front": [
      55,
      65
    ],
    "exhaust_rear": [
      38,
      61
    ],
    "dash_passenger": [
      68,
      35
    ],
    "windshield_driver": [
      61,
      37
    ],
    "windshield_passenger": [
      70,
      36
    ],
    "front_wheel": [
      59,
      77
    ],
    "rear_wheel": [
      12,
      55
    ],
    "fuel_tank": [
      28,
      50
    ]
  },
  "XP150_FACELIFT": {
    "engine_top": [
      74,
      45
    ],
    "engine_airbox": [
      86,
      46
    ],
    "maf": [
      81,
      48
    ],
    "engine_lower": [
      71,
      57
    ],
    "belt_side": [
      70,
      61
    ],
    "compressor_lower": [
      73,
      67
    ],
    "transmission_lower": [
      64,
      60
    ],
    "exhaust_front": [
      54,
      64
    ],
    "exhaust_rear": [
      36,
      57
    ],
    "dash_passenger": [
      68,
      34
    ],
    "windshield_driver": [
      61,
      36
    ],
    "windshield_passenger": [
      69,
      35
    ],
    "front_wheel": [
      61,
      74
    ],
    "rear_wheel": [
      11,
      54
    ],
    "fuel_tank": [
      28,
      46
    ]
  },
  "AC100": {
    "engine_top": [
      75,
      45
    ],
    "engine_airbox": [
      86,
      47
    ],
    "maf": [
      82,
      46
    ],
    "engine_lower": [
      71,
      57
    ],
    "belt_side": [
      70,
      60
    ],
    "compressor_lower": [
      72,
      66
    ],
    "transmission_lower": [
      64,
      60
    ],
    "exhaust_front": [
      54,
      61
    ],
    "exhaust_rear": [
      34,
      57
    ],
    "dash_passenger": [
      68,
      34
    ],
    "windshield_driver": [
      61,
      36
    ],
    "windshield_passenger": [
      69,
      35
    ],
    "front_wheel": [
      58,
      75
    ],
    "rear_wheel": [
      11,
      54
    ],
    "fuel_tank": [
      28,
      47
    ]
  },
  "XJ10": {
    "engine_top": [
      73.5,
      44.5
    ],
    "engine_airbox": [
      82.3,
      43.8
    ],
    "maf": [
      79.1,
      43.6
    ],
    "engine_lower": [
      71,
      56.8
    ],
    "belt_side": [
      81.1,
      50.5
    ],
    "compressor_lower": [
      77.8,
      57
    ],
    "transmission_lower": [
      55.7,
      57.9
    ],
    "exhaust_front": [
      63.6,
      61.2
    ],
    "exhaust_rear": [
      41.8,
      64.4
    ],
    "dash_passenger": [
      70.5,
      35.2
    ],
    "windshield_driver": [
      66.1,
      37.9
    ],
    "windshield_passenger": [
      73.4,
      38.9
    ],
    "front_wheel": [
      59.4,
      79.2
    ],
    "rear_wheel": [
      13,
      68.5
    ],
    "fuel_tank": [
      35.8,
      56
    ]
  },
  "AN50": {
    "engine_top": [
      75.4,
      46
    ],
    "engine_airbox": [
      86.2,
      47.4
    ],
    "maf": [
      82.8,
      45.7
    ],
    "engine_lower": [
      72.3,
      56.7
    ],
    "belt_side": [
      84,
      50
    ],
    "compressor_lower": [
      80.1,
      56.5
    ],
    "transmission_lower": [
      51,
      57.4
    ],
    "exhaust_front": [
      63,
      61.1
    ],
    "exhaust_rear": [
      36,
      64
    ],
    "dash_passenger": [
      68,
      34.5
    ],
    "windshield_driver": [
      63.5,
      37
    ],
    "windshield_passenger": [
      70.2,
      38.1
    ],
    "front_wheel": [
      56.4,
      75.4
    ],
    "rear_wheel": [
      14.1,
      59.2
    ],
    "fuel_tank": [
      34,
      53.5
    ]
  },
  "AN160": {
    "engine_top": [
      75,
      47
    ],
    "engine_airbox": [
      86.2,
      49
    ],
    "maf": [
      82.6,
      47.8
    ],
    "engine_lower": [
      72.7,
      57.8
    ],
    "belt_side": [
      85.1,
      52
    ],
    "compressor_lower": [
      80,
      58.4
    ],
    "transmission_lower": [
      48.1,
      59.1
    ],
    "exhaust_front": [
      63.2,
      61.1
    ],
    "exhaust_rear": [
      34.1,
      62
    ],
    "dash_passenger": [
      68.3,
      34.8
    ],
    "windshield_driver": [
      63.7,
      37
    ],
    "windshield_passenger": [
      70.5,
      38
    ],
    "front_wheel": [
      58.8,
      79.7
    ],
    "rear_wheel": [
      13.6,
      63.3
    ],
    "fuel_tank": [
      35,
      51.2
    ]
  },
  "N70": {
    "engine_top": [
      75.2,
      42.5
    ],
    "engine_airbox": [
      85.8,
      44.2
    ],
    "maf": [
      82.8,
      43.1
    ],
    "engine_lower": [
      72,
      56
    ],
    "belt_side": [
      86.1,
      48.4
    ],
    "compressor_lower": [
      80.1,
      54.7
    ],
    "transmission_lower": [
      50.5,
      60.1
    ],
    "exhaust_front": [
      65,
      62
    ],
    "exhaust_rear": [
      23,
      60
    ],
    "dash_passenger": [
      68.2,
      34
    ],
    "windshield_driver": [
      63.9,
      35.5
    ],
    "windshield_passenger": [
      70.8,
      36.5
    ],
    "front_wheel": [
      58.5,
      78.2
    ],
    "rear_wheel": [
      12.7,
      59.5
    ],
    "fuel_tank": [
      28.2,
      53
    ]
  },
  "H200": {
    "engine_top": [
      65,
      58
    ],
    "engine_airbox": [
      61,
      56
    ],
    "maf": [
      63,
      57
    ],
    "engine_lower": [
      65,
      65
    ],
    "belt_side": [
      75,
      64
    ],
    "compressor_lower": [
      73,
      69
    ],
    "transmission_lower": [
      55,
      65
    ],
    "exhaust_front": [
      56,
      70
    ],
    "exhaust_rear": [
      30,
      71
    ],
    "dash_passenger": [
      72,
      36
    ],
    "windshield_driver": [
      70,
      34
    ],
    "windshield_passenger": [
      78,
      35
    ],
    "front_wheel": [
      57,
      78
    ],
    "rear_wheel": [
      17,
      61
    ],
    "fuel_tank": [
      39,
      69
    ],
    "radiator_front": [
      87,
      58
    ]
  },
  "H300": {
    "engine_top": [
      78,
      54
    ],
    "engine_airbox": [
      88,
      55
    ],
    "maf": [
      84.7,
      53.8
    ],
    "engine_lower": [
      75,
      63.5
    ],
    "belt_side": [
      85.7,
      60.8
    ],
    "compressor_lower": [
      81.8,
      66
    ],
    "transmission_lower": [
      65,
      67.7
    ],
    "exhaust_front": [
      60.5,
      69
    ],
    "exhaust_rear": [
      37,
      68.8
    ],
    "dash_passenger": [
      72.3,
      42.5
    ],
    "windshield_driver": [
      69.5,
      42.4
    ],
    "windshield_passenger": [
      76.5,
      43.6
    ],
    "front_wheel": [
      61.5,
      79.6
    ],
    "rear_wheel": [
      14.2,
      66.4
    ],
    "fuel_tank": [
      43,
      68.5
    ]
  },
  "J100": {
    "engine_top": [
      75,
      47
    ],
    "engine_airbox": [
      84,
      47
    ],
    "maf": [
      81.2,
      45.8
    ],
    "engine_lower": [
      70.5,
      57.6
    ],
    "belt_side": [
      86.2,
      51.5
    ],
    "compressor_lower": [
      80,
      57.8
    ],
    "transmission_lower": [
      47.8,
      58.8
    ],
    "exhaust_front": [
      63,
      62.6
    ],
    "exhaust_rear": [
      32,
      68
    ],
    "dash_passenger": [
      69,
      35.5
    ],
    "windshield_driver": [
      64.8,
      38.7
    ],
    "windshield_passenger": [
      71.8,
      39.8
    ],
    "front_wheel": [
      64.5,
      76.5
    ],
    "rear_wheel": [
      15.3,
      62.8
    ],
    "fuel_tank": [
      27,
      50
    ]
  },
  "XA30": {
    "engine_top": [
      80.2,
      46
    ],
    "engine_airbox": [
      87.2,
      49
    ],
    "maf": [
      84.2,
      47.8
    ],
    "engine_lower": [
      74,
      60.8
    ],
    "belt_side": [
      78.2,
      64
    ],
    "compressor_lower": [
      78.8,
      71.5
    ],
    "transmission_lower": [
      56.8,
      64.8
    ],
    "exhaust_front": [
      63.8,
      67.5
    ],
    "exhaust_rear": [
      38.8,
      68
    ],
    "dash_passenger": [
      67,
      36
    ],
    "windshield_driver": [
      62.8,
      38.8
    ],
    "windshield_passenger": [
      69.5,
      40
    ],
    "front_wheel": [
      63.5,
      76
    ],
    "rear_wheel": [
      13.7,
      64
    ],
    "fuel_tank": [
      29.5,
      53
    ]
  },
  "XA40": {
    "engine_top": [
      76.2,
      46
    ],
    "engine_airbox": [
      86,
      48.5
    ],
    "maf": [
      82.4,
      46.8
    ],
    "engine_lower": [
      72.8,
      60.5
    ],
    "belt_side": [
      72.5,
      59
    ],
    "compressor_lower": [
      72.3,
      65
    ],
    "transmission_lower": [
      60.5,
      63.5
    ],
    "exhaust_front": [
      56.8,
      67
    ],
    "exhaust_rear": [
      36,
      68
    ],
    "dash_passenger": [
      66,
      35
    ],
    "windshield_driver": [
      62.5,
      37.8
    ],
    "windshield_passenger": [
      69,
      39
    ],
    "front_wheel": [
      58.3,
      77.5
    ],
    "rear_wheel": [
      12.7,
      61.5
    ],
    "fuel_tank": [
      31,
      56.5
    ]
  },
  "XA50": {
    "engine_top": [
      78,
      46
    ],
    "engine_airbox": [
      87,
      47
    ],
    "maf": [
      83.5,
      45.5
    ],
    "engine_lower": [
      72,
      61.8
    ],
    "belt_side": [
      72.5,
      60.5
    ],
    "compressor_lower": [
      73,
      67
    ],
    "transmission_lower": [
      62,
      62.5
    ],
    "exhaust_front": [
      55.5,
      65.5
    ],
    "exhaust_rear": [
      34,
      68
    ],
    "dash_passenger": [
      66,
      35
    ],
    "windshield_driver": [
      63.8,
      37.2
    ],
    "windshield_passenger": [
      70.5,
      38.5
    ],
    "front_wheel": [
      58.7,
      76.5
    ],
    "rear_wheel": [
      13.2,
      59.5
    ],
    "fuel_tank": [
      32,
      54
    ]
  },
  "XK80": {
    "engine_top": [
      76,
      43
    ],
    "engine_airbox": [
      86,
      43
    ],
    "maf": [
      83,
      44
    ],
    "engine_lower": [
      73,
      57
    ],
    "belt_side": [
      82,
      52
    ],
    "compressor_lower": [
      79,
      61
    ],
    "transmission_lower": [
      56,
      60
    ],
    "exhaust_front": [
      66,
      63
    ],
    "exhaust_rear": [
      29,
      64
    ],
    "dash_passenger": [
      68,
      37
    ],
    "windshield_driver": [
      68,
      33
    ],
    "windshield_passenger": [
      77,
      33
    ],
    "front_wheel": [
      62,
      74
    ],
    "rear_wheel": [
      18,
      63
    ],
    "fuel_tank": [
      38,
      48
    ]
  },
  "XL20": {
    "engine_top": [
      75.5,
      48.8
    ],
    "engine_airbox": [
      86.4,
      48
    ],
    "maf": [
      82.8,
      47
    ],
    "engine_lower": [
      74.5,
      59
    ],
    "belt_side": [
      77.7,
      61.5
    ],
    "compressor_lower": [
      74.1,
      66
    ],
    "transmission_lower": [
      67.6,
      63.6
    ],
    "exhaust_front": [
      62.7,
      62.3
    ],
    "exhaust_rear": [
      33.7,
      64.5
    ],
    "dash_passenger": [
      69.4,
      41.6
    ],
    "windshield_driver": [
      70.5,
      35.9
    ],
    "windshield_passenger": [
      62.5,
      35.6
    ],
    "front_wheel": [
      55.9,
      72.5
    ],
    "rear_wheel": [
      11.5,
      59.3
    ],
    "fuel_tank": [
      32.8,
      55.4
    ]
  },
  "XL30_PRE": {
    "engine_top": [
      75.8,
      47.8
    ],
    "engine_airbox": [
      87.2,
      47.4
    ],
    "maf": [
      83.5,
      46.6
    ],
    "engine_lower": [
      74.8,
      58.2
    ],
    "belt_side": [
      78.1,
      61
    ],
    "compressor_lower": [
      74.2,
      65.6
    ],
    "transmission_lower": [
      67.5,
      63.6
    ],
    "exhaust_front": [
      62.3,
      61.9
    ],
    "exhaust_rear": [
      36,
      64.9
    ],
    "dash_passenger": [
      68.4,
      40.9
    ],
    "windshield_driver": [
      70,
      35.6
    ],
    "windshield_passenger": [
      61.6,
      35.2
    ],
    "front_wheel": [
      56,
      72.6
    ],
    "rear_wheel": [
      11.6,
      57.4
    ],
    "fuel_tank": [
      32.8,
      56.1
    ]
  },
  "XL30_FACELIFT": {
    "engine_top": [
      75.3,
      47.3
    ],
    "engine_airbox": [
      87.3,
      47
    ],
    "maf": [
      83.5,
      45.9
    ],
    "engine_lower": [
      74.1,
      57.3
    ],
    "belt_side": [
      77.1,
      60.2
    ],
    "compressor_lower": [
      70.2,
      65.1
    ],
    "transmission_lower": [
      65.6,
      62.2
    ],
    "exhaust_front": [
      61,
      60.5
    ],
    "exhaust_rear": [
      35.3,
      64.1
    ],
    "dash_passenger": [
      67.8,
      39.6
    ],
    "windshield_driver": [
      70.2,
      34.2
    ],
    "windshield_passenger": [
      61.7,
      34.2
    ],
    "front_wheel": [
      53.7,
      74.1
    ],
    "rear_wheel": [
      11.2,
      55.9
    ],
    "fuel_tank": [
      33.1,
      55.7
    ]
  },
  "N2XX": {
    "engine_top": [
      76.6,
      42.4
    ],
    "engine_airbox": [
      87.5,
      43.3
    ],
    "maf": [
      84.5,
      42.8
    ],
    "engine_lower": [
      75,
      51.7
    ],
    "belt_side": [
      82.1,
      52
    ],
    "compressor_lower": [
      78.5,
      58.5
    ],
    "transmission_lower": [
      40,
      53.5
    ],
    "exhaust_front": [
      53.6,
      60
    ],
    "exhaust_rear": [
      20.3,
      56.7
    ],
    "dash_passenger": [
      66.6,
      34.3
    ],
    "windshield_driver": [
      69.7,
      31.9
    ],
    "windshield_passenger": [
      61.6,
      31.8
    ],
    "front_wheel": [
      57.5,
      71.2
    ],
    "rear_wheel": [
      11.8,
      54.4
    ],
    "fuel_tank": [
      30,
      46.7
    ]
  },
  "N300": {
    "engine_top": [
      78.9,
      40.8
    ],
    "engine_airbox": [
      87.9,
      40.2
    ],
    "maf": [
      84.6,
      39.9
    ],
    "engine_lower": [
      76.6,
      49.7
    ],
    "belt_side": [
      82.1,
      50.3
    ],
    "compressor_lower": [
      77.6,
      57.5
    ],
    "transmission_lower": [
      53.6,
      53
    ],
    "exhaust_front": [
      59,
      58.3
    ],
    "exhaust_rear": [
      18,
      50.1
    ],
    "dash_passenger": [
      68,
      33.4
    ],
    "windshield_driver": [
      70,
      31.7
    ],
    "windshield_passenger": [
      61.5,
      31.7
    ],
    "front_wheel": [
      66.6,
      70.8
    ],
    "rear_wheel": [
      14.2,
      55.5
    ],
    "fuel_tank": [
      35,
      47.1
    ]
  },
  "XK50": {
    "engine_top": [
      78.9,
      40.1
    ],
    "engine_airbox": [
      88.2,
      39.9
    ],
    "maf": [
      85.3,
      39.9
    ],
    "engine_lower": [
      77.6,
      49.7
    ],
    "belt_side": [
      82.4,
      49.7
    ],
    "compressor_lower": [
      77.7,
      56.9
    ],
    "transmission_lower": [
      57.6,
      53.5
    ],
    "exhaust_front": [
      64.1,
      57.3
    ],
    "exhaust_rear": [
      36.6,
      59
    ],
    "dash_passenger": [
      68,
      33.1
    ],
    "windshield_driver": [
      69.9,
      30.9
    ],
    "windshield_passenger": [
      61.3,
      31.1
    ],
    "front_wheel": [
      66.8,
      74.6
    ],
    "rear_wheel": [
      14.3,
      54.5
    ],
    "fuel_tank": [
      38.8,
      48
    ]
  },
  "XK70": {
    "engine_top": [
      77,
      40.7
    ],
    "engine_airbox": [
      88.3,
      40.3
    ],
    "maf": [
      85,
      40.4
    ],
    "engine_lower": [
      75.7,
      50.2
    ],
    "belt_side": [
      81.4,
      51.1
    ],
    "compressor_lower": [
      76.5,
      57.4
    ],
    "transmission_lower": [
      55.9,
      53.5
    ],
    "exhaust_front": [
      63.9,
      56.9
    ],
    "exhaust_rear": [
      36.4,
      58.8
    ],
    "dash_passenger": [
      66.6,
      32.8
    ],
    "windshield_driver": [
      68.9,
      31.1
    ],
    "windshield_passenger": [
      60.6,
      31.1
    ],
    "front_wheel": [
      64.3,
      72.3
    ],
    "rear_wheel": [
      12.9,
      52.9
    ],
    "fuel_tank": [
      38.9,
      47.2
    ]
  },
  "J200": {
    "engine_top": [76, 45],
    "engine_airbox": [86, 43],
    "maf": [82, 44],
    "engine_lower": [73, 57],
    "belt_side": [81, 53],
    "compressor_lower": [78, 61],
    "transmission_lower": [56, 60],
    "exhaust_front": [66, 63],
    "exhaust_rear": [29, 64],
    "dash_passenger": [60, 37],
    "windshield_driver": [68, 34],
    "windshield_passenger": [77, 34],
    "front_wheel": [63, 73],
    "rear_wheel": [20, 61],
    "fuel_tank": [39, 49]
  },
  "J300": {
    "engine_top": [75, 44],
    "engine_airbox": [86, 44],
    "maf": [82, 45],
    "engine_lower": [72, 56],
    "belt_side": [81, 52],
    "compressor_lower": [78, 59],
    "transmission_lower": [55, 60],
    "exhaust_front": [66, 62],
    "exhaust_rear": [29, 63],
    "dash_passenger": [60, 37],
    "windshield_driver": [68, 34],
    "windshield_passenger": [77, 34],
    "front_wheel": [62, 73],
    "rear_wheel": [19, 61],
    "fuel_tank": [36, 50]
  },
  "J150": {
    "engine_top": [76, 43],
    "engine_airbox": [85, 44],
    "maf": [82, 45],
    "engine_lower": [73, 56],
    "belt_side": [81, 52],
    "compressor_lower": [78, 59],
    "transmission_lower": [56, 60],
    "exhaust_front": [66, 62],
    "exhaust_rear": [29, 63],
    "dash_passenger": [60, 37],
    "windshield_driver": [68, 34],
    "windshield_passenger": [77, 34],
    "front_wheel": [62, 73],
    "rear_wheel": [20, 62],
    "fuel_tank": [36, 50]
  },
  "AN120": {
    "engine_top": [78, 43],
    "engine_airbox": [87, 43],
    "maf": [83, 44],
    "engine_lower": [75, 55],
    "belt_side": [82, 52],
    "compressor_lower": [79, 59],
    "transmission_lower": [58, 60],
    "exhaust_front": [68, 62],
    "exhaust_rear": [29, 62],
    "dash_passenger": [61, 37],
    "windshield_driver": [68, 33],
    "windshield_passenger": [77, 33],
    "front_wheel": [62, 75],
    "rear_wheel": [18, 64],
    "fuel_tank": [43, 55]
  }
};

  var TOYOTA_GLASS_PART_BLUEPRINTS = {
    oxygen_b1s1:            { zone: 'exhaust_front', shape: 'oxygen_sensor', scale: 2.55, dx: 2 },
    oxygen_b2s1:            { zone: 'exhaust_front', shape: 'oxygen_sensor', scale: 2.55, dx: -2 },
    oxygen_b1s2:            { zone: 'exhaust_rear', shape: 'oxygen_sensor', scale: 2.45, dx: 2 },
    oxygen_b2s2:            { zone: 'exhaust_rear', shape: 'oxygen_sensor', scale: 2.45, dx: -2 },
    oxygen_front_left:      { zone: 'exhaust_front', shape: 'oxygen_sensor', scale: 2.55, dx: -2 },
    oxygen_front_right:     { zone: 'exhaust_front', shape: 'oxygen_sensor', scale: 2.55, dx: 2 },
    oxygen_front:           { zone: 'exhaust_front', shape: 'oxygen_sensor', scale: 2.55 },
    oxygen_rear:            { zone: 'exhaust_rear', shape: 'oxygen_sensor', scale: 2.45 },
    maf_sensor:             { zone: 'maf', shape: 'maf_sensor', scale: 2.55 },
    knock_sensor:           { zone: 'engine_lower', shape: 'knock_sensor', scale: 2.7 },
    ac_pressure_sensor:     { zone: 'compressor_lower', scale: 2.55 },
    ignition_coil:          { zone: 'engine_top', shape: 'ignition_coil', scale: 2.55, dy: -1 },
    spark_plug:             { zone: 'engine_top', shape: 'spark_plug_single', scale: 2.65, dy: 2 },
    cabin_filter:           { zone: 'dash_passenger', shape: 'cabin_filter', scale: 2.35 },
    engine_air_filter:      { zone: 'engine_airbox', shape: 'air_filter', scale: 2.5 },
    oil_filter:             { zone: 'engine_lower', shape: 'oil_filter', scale: 2.65 },
    transmission_filter:    { zone: 'transmission_lower', shape: 'transmission_filter', scale: 2.55 },
    brake_front:            { zone: 'front_wheel', shape: 'brake_pad', scale: 2.4, tall: true },
    brake_rear:             { zone: 'rear_wheel', shape: 'brake_pad', scale: 2.4, tall: true },
    wiper:                  { zone: 'windshield_driver', shape: 'wiper_driver', scale: 2.1, wide: true },
    ac_evaporator:          { zone: 'dash_passenger', shape: 'ac_evaporator', scale: 2.4, dy: 3 },
    thermostat:             { zone: 'engine_top', shape: 'thermostat', scale: 2.65, dy: 4 },
    brake_vacuum_pump:      { zone: 'engine_top', shape: 'vacuum_pump', scale: 2.65, dx: -3 },
    drive_belt:             { zone: 'belt_side', scale: 2.75 },
    compressor_valve:       { zone: 'compressor_lower', shape: 'compressor_control_valve', scale: 2.9 },
    radiator:               { zone: 'engine_airbox', scale: 2.3, towardFront: 7, dy: 5 },
    radiator_hose_upper:    { zone: 'engine_top', scale: 2.55, dx: 4, dy: 3 },
    radiator_hose_lower:    { zone: 'engine_lower', scale: 2.65, dx: 3, dy: 3 },
    water_pump:             { zone: 'belt_side', scale: 2.7, dx: -2 },
    engine_mount_left_upper:{ zone: 'engine_top', scale: 2.6, dx: -6 },
    engine_mount_right_upper:{ zone: 'engine_top', scale: 2.6, dx: 6 },
    engine_mount_front:     { zone: 'engine_lower', scale: 2.55, towardFront: 4 },
    engine_mount_rear:      { zone: 'transmission_lower', scale: 2.55, dy: -4 },
    fuel_pump:              { zone: 'fuel_tank', scale: 2.35 },
    shock_absorber_front:   { zone: 'front_wheel', scale: 2.35, dy: -8 },
    shock_absorber_rear:    { zone: 'rear_wheel', scale: 2.35, dy: -8 },
    steering_tie_rod:       { zone: 'front_wheel', scale: 2.4, dy: 4 },
    belt_tensioner:         { zone: 'belt_side', scale: 2.65, dx: -2, dy: -2 },
    idler_pulley:           { zone: 'belt_side', scale: 2.65, dx: 2, dy: -3 }
  };


  /*
   * A belt layout is selected from the exact generation/engine profile.  It
   * is an explanatory overlay: the current product photo remains the source
   * of truth and is shown beside it and in the gallery.
   */
  var BELT_LAYOUTS = {
    'XV70-3.5L': { path: 'M63 44 C96 20 158 20 190 45 L235 75 C253 89 251 119 231 130 L205 143 C188 151 182 175 194 190 L208 208 C221 224 210 249 188 250 L105 250 C82 250 70 226 84 208 L101 186 C113 171 105 149 87 142 L55 129 C30 119 27 85 49 70 Z', pulleys: [[72,92,25],[149,69,32],[220,101,24],[175,211,30],[109,211,26],[115,139,18]] },
    'XV50-3.5L': { path: 'M54 218 C48 190 69 169 102 162 C121 158 128 148 126 132 C123 112 96 113 73 111 C49 109 42 85 57 68 C78 43 111 42 127 48 C145 55 153 38 173 43 C194 48 215 52 230 65 C250 82 248 111 231 125 C215 138 193 145 190 164 C187 181 203 188 222 192 C248 198 256 225 239 244 C218 266 190 257 172 249 C145 237 120 243 103 254 C82 266 59 249 54 218 Z', pulleys: [[80,88,26],[145,50,17],[218,82,31],[83,220,35],[145,142,21],[220,218,31]] },
    'XV40-3.5L': { path: 'M118 231 C99 219 91 199 94 185 C98 169 84 161 68 158 C43 154 25 139 27 116 C29 92 51 84 76 91 C89 95 93 82 101 69 C112 50 131 45 148 48 C164 51 173 38 193 44 C222 51 245 67 247 91 C249 111 235 125 221 136 C204 148 204 164 222 176 C245 191 254 219 236 239 C217 260 188 250 173 238 C155 224 136 220 118 231 Z', pulleys: [[46,125,24],[103,83,25],[150,48,17],[220,80,29],[229,166,29],[150,224,35],[88,173,18],[146,141,21]] },
    'XV30-3.0L': { path: 'M55 58 C91 24 152 18 191 43 L229 68 C252 83 255 112 235 130 L211 151 C195 164 195 187 211 200 L218 207 C238 225 226 256 198 258 L99 258 C70 258 55 225 75 204 L90 188 C104 173 97 151 78 143 L49 130 C24 119 23 87 44 70 Z', pulleys: [[67,98,25],[146,72,32],[222,102,24],[187,219,29],[105,220,28],[113,145,18]] },
    'XV20-3.0L': { path: 'M54 59 C89 25 151 19 190 43 L228 67 C254 83 257 113 235 132 L211 152 C195 165 196 187 212 201 L219 207 C238 226 225 256 197 258 L98 258 C70 258 54 225 75 203 L89 188 C103 173 97 152 78 143 L48 130 C23 118 23 87 44 70 Z', pulleys: [[66,98,25],[145,72,32],[222,103,24],[187,219,29],[104,220,28],[112,145,18]] }
  };

  /* Verified route + engine + OEM-code locations. Unlisted codes never get a pin. */
  var LOCATION_BY_ROUTE_AND_CODE = {
    'toyota-avalon-2013-2017-v6-esr6785114': {
      "BQ-90919-02256": {"part":"ignition_coil","verified":true,"confidence":"direct","scene":"overview","anchor":[78,47],"calloutAnchor":[66,31],"focusRect":[68,33,22,29],"overlayRect":[74,41,9,14],"shape":"ignition_coil","scale":2.55,"note":"كويل 90919-02256 يركب رأسيًا أعلى رأسي محرك 3.5L V6، فوق البوجي مباشرة. للمحرك ستة كويلات موزعة على صفّين."},
      "90919-02256": {"part":"ignition_coil","verified":true,"confidence":"direct","scene":"overview","anchor":[78,47],"calloutAnchor":[66,31],"focusRect":[68,33,22,29],"overlayRect":[74,41,9,14],"shape":"ignition_coil","scale":2.55,"note":"كويل 90919-02256 يركب رأسيًا أعلى رأسي محرك 3.5L V6، فوق البوجي مباشرة. للمحرك ستة كويلات موزعة على صفّين."},
      "SEN-90919-01247": {"part":"spark_plug","verified":true,"confidence":"direct","scene":"overview","anchor":[78,50],"calloutAnchor":[66,34],"focusRect":[68,36,22,28],"overlayRect":[74,45,8,12],"shape":"spark_plug_single","scale":2.65,"note":"البوجي 90919-01247 يركب تحت الكويل داخل رأس المحرك؛ توجد ستة مواضع لمحرك V6، والخريطة تبيّن موضع تركيب واحد بوضوح."},
      "90919-01247": {"part":"spark_plug","verified":true,"confidence":"direct","scene":"overview","anchor":[78,50],"calloutAnchor":[66,34],"focusRect":[68,36,22,28],"overlayRect":[74,45,8,12],"shape":"spark_plug_single","scale":2.65,"note":"البوجي 90919-01247 يركب تحت الكويل داخل رأس المحرك؛ توجد ستة مواضع لمحرك V6، والخريطة تبيّن موضع تركيب واحد بوضوح."},
      "SEN-17801-31130": {"part":"engine_air_filter","verified":true,"confidence":"direct","scene":"overview","anchor":[87,42],"calloutAnchor":[75,28],"focusRect":[78,29,19,27],"overlayRect":[83,37,10,11],"shape":"air_filter","scale":2.45,"note":"فلتر هواء المحرك 17801-31130 داخل علبة الهواء السوداء في مقدمة حجرة المحرك، قبل حساس MAF وأنبوب السحب."},
      "17801-31130": {"part":"engine_air_filter","verified":true,"confidence":"direct","scene":"overview","anchor":[87,42],"calloutAnchor":[75,28],"focusRect":[78,29,19,27],"overlayRect":[83,37,10,11],"shape":"air_filter","scale":2.45,"note":"فلتر هواء المحرك 17801-31130 داخل علبة الهواء السوداء في مقدمة حجرة المحرك، قبل حساس MAF وأنبوب السحب."},
      "BQ-22204-31020": {"part":"maf_sensor","verified":true,"confidence":"direct","scene":"overview","anchor":[83,44],"calloutAnchor":[72,30],"focusRect":[75,32,18,24],"overlayRect":[80,40,7,8],"shape":"maf_sensor","scale":2.55,"note":"حساس MAF 22204-31020 مثبت على مخرج علبة فلتر الهواء وقبل خرطوم السحب المتجه إلى الثروتل."},
      "22204-31020": {"part":"maf_sensor","verified":true,"confidence":"direct","scene":"overview","anchor":[83,44],"calloutAnchor":[72,30],"focusRect":[75,32,18,24],"overlayRect":[80,40,7,8],"shape":"maf_sensor","scale":2.55,"note":"حساس MAF 22204-31020 مثبت على مخرج علبة فلتر الهواء وقبل خرطوم السحب المتجه إلى الثروتل."},
      "BQ-22204-28010": {"part":"maf_sensor","verified":true,"confidence":"vin-required","scene":"overview","anchor":[83,44],"calloutAnchor":[72,30],"focusRect":[75,32,18,24],"overlayRect":[80,40,7,8],"shape":"maf_sensor","scale":2.55,"note":"موضع حساس MAF على مخرج علبة الهواء صحيح، لكن رقم 22204-28010 يحتاج مطابقة VIN لأن تجهيز أفالون قد يستخدم 22204-31020 حسب السوق."},
      "22204-28010": {"part":"maf_sensor","verified":true,"confidence":"vin-required","scene":"overview","anchor":[83,44],"calloutAnchor":[72,30],"focusRect":[75,32,18,24],"overlayRect":[80,40,7,8],"shape":"maf_sensor","scale":2.55,"note":"موضع حساس MAF على مخرج علبة الهواء صحيح، لكن رقم 22204-28010 يحتاج مطابقة VIN لأن تجهيز أفالون قد يستخدم 22204-31020 حسب السوق."},
      "SEN-87139-30040": {"part":"cabin_filter","verified":true,"confidence":"cross-reference","scene":"side","anchor":[72,45],"calloutAnchor":[61,30],"focusRect":[61,32,23,28],"overlayRect":[68,40,9,12],"shape":"cabin_filter","scale":2.2,"note":"فلتر المكيّف 87139-30040 خلف درج الراكب الأمامي داخل بيت التكييف، وليس داخل حجرة المحرك."},
      "87139-30040": {"part":"cabin_filter","verified":true,"confidence":"cross-reference","scene":"side","anchor":[72,45],"calloutAnchor":[61,30],"focusRect":[61,32,23,28],"overlayRect":[68,40,9,12],"shape":"cabin_filter","scale":2.2,"note":"فلتر المكيّف 87139-30040 خلف درج الراكب الأمامي داخل بيت التكييف، وليس داخل حجرة المحرك."},
      "SEN-04152-31090": {"part":"oil_filter","verified":true,"confidence":"direct","scene":"underbody","anchor":[76,55],"calloutAnchor":[64,39],"focusRect":[65,39,23,30],"overlayRect":[72,50,8,11],"shape":"oil_filter","scale":2.5,"note":"فلتر زيت cartridge رقم 04152-31090 داخل غطائه أسفل محرك V6 قرب حوض الزيت؛ يعرض المشهد السفلي موضع الوصول الصحيح."},
      "04152-31090": {"part":"oil_filter","verified":true,"confidence":"direct","scene":"underbody","anchor":[76,55],"calloutAnchor":[64,39],"focusRect":[65,39,23,30],"overlayRect":[72,50,8,11],"shape":"oil_filter","scale":2.5,"note":"فلتر زيت cartridge رقم 04152-31090 داخل غطائه أسفل محرك V6 قرب حوض الزيت؛ يعرض المشهد السفلي موضع الوصول الصحيح."},
      "SEN-04465-07010-G1": {"part":"brake_front","verified":true,"confidence":"direct","scene":"side","anchor":[84,68],"calloutAnchor":[72,51],"focusRect":[75,48,20,40],"overlayRect":[81,59,8,19],"shape":"brake_pad","scale":2.3,"note":"طقم الفحمات الأمامية داخل كاليبرَي الدسك للعجلتين الأماميتين؛ العلامة على العجلة الأمامية الظاهرة، والطقم يخدم الجانبين."},
      "04465-07010-G1": {"part":"brake_front","verified":true,"confidence":"direct","scene":"side","anchor":[84,68],"calloutAnchor":[72,51],"focusRect":[75,48,20,40],"overlayRect":[81,59,8,19],"shape":"brake_pad","scale":2.3,"note":"طقم الفحمات الأمامية داخل كاليبرَي الدسك للعجلتين الأماميتين؛ العلامة على العجلة الأمامية الظاهرة، والطقم يخدم الجانبين."},
      "SEN-04466-33200-AQ": {"part":"brake_rear","verified":true,"confidence":"direct","scene":"side","anchor":[18,67],"calloutAnchor":[30,50],"focusRect":[8,47,21,40],"overlayRect":[14,58,8,19],"shape":"brake_pad","scale":2.3,"note":"طقم الفحمات الخلفية داخل كاليبرَي الدسك للعجلتين الخلفيتين؛ العلامة على العجلة الخلفية الظاهرة."},
      "04466-33200-AQ": {"part":"brake_rear","verified":true,"confidence":"direct","scene":"side","anchor":[18,67],"calloutAnchor":[30,50],"focusRect":[8,47,21,40],"overlayRect":[14,58,8,19],"shape":"brake_pad","scale":2.3,"note":"طقم الفحمات الخلفية داخل كاليبرَي الدسك للعجلتين الخلفيتين؛ العلامة على العجلة الخلفية الظاهرة."},
      "35330-48020": {"part":"transmission_filter","verified":true,"confidence":"vin-required","scene":"underbody","anchor":[68,58],"calloutAnchor":[57,42],"focusRect":[56,41,25,31],"overlayRect":[63,52,12,12],"shape":"transmission_filter","scale":2.45,"note":"فلتر القير 35330-48020 داخل ناقل الحركة فوق حوض القير؛ يظهر موضعه بعد فك الحوض. يلزم مطابقة VIN وكود القير."},
      "35168-33080": {"part":"transmission_filter","verified":true,"confidence":"vin-required","scene":"underbody","anchor":[68,58],"calloutAnchor":[57,42],"focusRect":[56,41,25,31],"overlayRect":[63,52,12,12],"shape":"transmission_filter","scale":2.45,"note":"الجاسكت 35168-33080 يخص حوض القير المحيط بفلتر 35330-48020؛ يعرض المشهد موضع مجموعة الحوض والفلتر. يلزم مطابقة VIN وكود القير."},
      "BQ-89467-06130": {"part":"oxygen_front_left","verified":true,"confidence":"vin-required","scene":"underbody","anchor":[71,46],"calloutAnchor":[59,30],"focusRect":[60,33,23,27],"overlayRect":[67,42,7,10],"shape":"oxygen_sensor","scale":2.55,"note":"حساس Air/Fuel الأمامي الأيسر 89467-06130 قبل المحفّز في مجمع العادم. هذا الرقم مذكور لموديلات 2013–2014؛ تحقق من VIN قبل الطلب."},
      "89467-06130": {"part":"oxygen_front_left","verified":true,"confidence":"vin-required","scene":"underbody","anchor":[71,46],"calloutAnchor":[59,30],"focusRect":[60,33,23,27],"overlayRect":[67,42,7,10],"shape":"oxygen_sensor","scale":2.55,"note":"حساس Air/Fuel الأمامي الأيسر 89467-06130 قبل المحفّز في مجمع العادم. هذا الرقم مذكور لموديلات 2013–2014؛ تحقق من VIN قبل الطلب."},
      "BQ-89467-06140": {"part":"oxygen_front_right","verified":true,"confidence":"vin-required","scene":"underbody","anchor":[78,48],"calloutAnchor":[66,32],"focusRect":[67,35,23,27],"overlayRect":[74,44,7,10],"shape":"oxygen_sensor","scale":2.55,"note":"حساس Air/Fuel الأمامي الأيمن 89467-06140 قبل المحفّز في مجمع العادم. هذا الرقم مذكور لموديلات 2013–2014؛ تحقق من VIN قبل الطلب."},
      "89467-06140": {"part":"oxygen_front_right","verified":true,"confidence":"vin-required","scene":"underbody","anchor":[78,48],"calloutAnchor":[66,32],"focusRect":[67,35,23,27],"overlayRect":[74,44,7,10],"shape":"oxygen_sensor","scale":2.55,"note":"حساس Air/Fuel الأمامي الأيمن 89467-06140 قبل المحفّز في مجمع العادم. هذا الرقم مذكور لموديلات 2013–2014؛ تحقق من VIN قبل الطلب."},
      "8679": {"part":"transmission_service","verified":true,"confidence":"service","scene":"underbody","anchor":[69,59],"calloutAnchor":[58,43],"focusRect":[57,43,24,29],"overlayRect":[66,55,7,8],"shape":"service_point","scale":2.35,"note":"هذا زيت خدمة؛ الخريطة تبيّن موضع خدمة ناقل الحركة ولا تعرض عبوة الزيت كقطعة مركبة."},
      "8699": {"part":"transmission_service","verified":true,"confidence":"service","scene":"underbody","anchor":[69,59],"calloutAnchor":[58,43],"focusRect":[57,43,24,29],"overlayRect":[66,55,7,8],"shape":"service_point","scale":2.35,"note":"هذا زيت خدمة؛ الخريطة تبيّن موضع خدمة ناقل الحركة ولا تعرض عبوة الزيت كقطعة مركبة."}
    },
    'toyota-camry-2018-2023-2-5l-4cyl-esi6467877': {
      'BQ-000069': { part: 'compressor_valve', verified: true, confidence: 'vin-required', scene: 'underbody', anchor: [28, 38], calloutAnchor: [43, 25], focusRect: [14, 23, 30, 31], overlayRect: [24, 34, 8, 10], shape: 'compressor_control_valve', scale: 3.05, note: 'حساس/صمام BQ-000069 يركب داخل جسم كمبريسر المكيّف في أسفل المحرك؛ العلامة تركز على جسم الكمبريسر نفسه، ويجب مطابقة رقم الكمبريسر أو VIN قبل الطلب.' },
      'BQ-89467-06250': { part: 'oxygen_front', verified: true, confidence: 'vin-required', scene: 'underbody', anchor: [31, 37], calloutAnchor: [46, 24], focusRect: [17, 23, 30, 29], overlayRect: [27, 33, 8, 10], shape: 'oxygen_sensor', scale: 2.85, note: 'حساس Air/Fuel الأمامي (Bank 1 Sensor 1) قبل المحفّز، قريب من مجمع العادم في مقدمة مجموعة المحرك. رقم 89467-06250 موثق كحساس علوي؛ تحقق من VIN ومواصفات الخليج.' },
      'BQ-89465-06280': { part: 'oxygen_rear', verified: true, confidence: 'vin-required', scene: 'underbody', anchor: [41, 51], calloutAnchor: [54, 36], focusRect: [28, 37, 28, 29], overlayRect: [37, 47, 8, 10], shape: 'oxygen_sensor', scale: 2.75, note: 'هذا حساس أكسجين خلفي بعد المحفّز، وليس حساس المقدمة. رقم 89465-06280 يرتبط بتجهيزات محرك/سوق مختلفة؛ العلامة للموقع الفيزيائي الصحيح، والتوافق النهائي برقم VIN.' },
      'BQ-22204-75040': { part: 'maf_sensor', verified: true, confidence: 'direct', scene: 'overview', anchor: [37, 57], calloutAnchor: [49, 43], focusRect: [27, 47, 23, 23], overlayRect: [34, 53, 7, 8], shape: 'maf_sensor', scale: 2.75, note: 'حساس MAF مثبت على مجرى سحب الهواء مباشرة بعد علبة فلتر هواء المحرك وقبل بوابة الهواء.' },
      'BQ-90919-02276': { part: 'ignition_coil', verified: true, confidence: 'direct', scene: 'overview', anchor: [28, 48], calloutAnchor: [43, 35], focusRect: [17, 35, 25, 27], overlayRect: [25, 43, 7, 12], shape: 'ignition_coil', scale: 2.7, note: 'الكويل يركب رأسيًا أعلى رأس المحرك فوق البوجي مباشرة؛ توجد أربعة مواضع متطابقة لمحرك الأربع سلندر، وتظهر الخريطة قطعة واحدة مختارة.' },
      'SEN-87139-48050': { part: 'cabin_filter', verified: true, confidence: 'direct', scene: 'side', anchor: [38, 44], calloutAnchor: [50, 29], focusRect: [27, 27, 23, 37], overlayRect: [34, 38, 8, 12], shape: 'cabin_filter', scale: 2.45, note: 'فلتر المكيّف خلف درج الراكب الأمامي، في جهة الراكب اليمنى لسيارات عُمان ذات المقود اليسار؛ ليس في جهة السائق.' },
      'SEN-17801-25020': { part: 'engine_air_filter', verified: true, confidence: 'direct', scene: 'overview', anchor: [34, 62], calloutAnchor: [48, 48], focusRect: [23, 51, 24, 24], overlayRect: [29, 57, 12, 11], shape: 'air_filter', scale: 2.65, note: 'فلتر هواء المحرك داخل علبة الهواء السوداء؛ يُرفع غطاء العلبة للوصول إلى عنصر الفلتر المستطيل.' },
      'SEN-90915-10009': { part: 'oil_filter', verified: true, confidence: 'vin-required', scene: 'underbody', anchor: [25, 35], calloutAnchor: [40, 23], focusRect: [12, 21, 28, 29], overlayRect: [21, 31, 8, 10], shape: 'oil_filter', scale: 2.75, note: 'فلتر زيت المحرك في الجزء السفلي من مجموعة المحرك قرب حوض الزيت. العلامة تعرض موضع التركيب لا عبوة الزيت؛ تحقق من VIN وكود المحرك.' },
      'SEN-04465-33480': { part: 'brake_front', verified: true, confidence: 'direct', scene: 'side', anchor: [25, 69], calloutAnchor: [37, 54], focusRect: [12, 49, 27, 40], overlayRect: [21, 60, 9, 20], shape: 'brake_pad', scale: 2.45, note: 'طقم الفحمات داخل كاليبرَي الدسك للعجلتين الأماميتين؛ تُبرز الخريطة العجلة الأمامية الظاهرة لتوضيح الموضع.' },
      'SEN-04466-0E070': { part: 'brake_rear', verified: true, confidence: 'direct', scene: 'side', anchor: [82, 66], calloutAnchor: [69, 51], focusRect: [69, 47, 27, 39], overlayRect: [78, 57, 9, 19], shape: 'brake_pad', scale: 2.45, note: 'طقم الفحمات داخل كاليبرَي الدسك للعجلتين الخلفيتين؛ تُبرز الخريطة العجلة الخلفية الظاهرة لتوضيح الموضع.' },
      '29300-25012': { part: 'brake_vacuum_pump', verified: true, confidence: 'direct', scene: 'overview', anchor: [24, 49], calloutAnchor: [39, 35], focusRect: [14, 36, 23, 27], overlayRect: [21, 45, 7, 9], shape: 'vacuum_pump', scale: 2.75, note: 'مضخة فاكيوم الفرامل مركبة على رأس المحرك وتغذي معزز الفرامل؛ العلامة تركز على جسم المضخة لا على علبة سائل الفرامل.' },
      '16260-25011': { part: 'thermostat', verified: true, confidence: 'direct', scene: 'overview', anchor: [28, 57], calloutAnchor: [43, 43], focusRect: [17, 44, 25, 27], overlayRect: [25, 53, 7, 9], shape: 'thermostat', scale: 2.8, note: 'الثرموستات داخل مجموعة مخرج/مدخل سائل التبريد على جانب المحرك، وليس داخل الراديتر؛ يظهر شكله في موضع بيت الثرموستات.' },
      'SEN-90919-01289': { part: 'spark_plug', verified: true, confidence: 'vin-required', scene: 'overview', anchor: [28, 50], calloutAnchor: [43, 36], focusRect: [17, 36, 25, 28], overlayRect: [25, 45, 7, 12], shape: 'spark_plug_single', scale: 2.75, note: 'البوجي يركب رأسيًا تحت الكويل في رأس المحرك. الخريطة تعرض بوجيًا واحدًا مختارًا؛ يلزم تأكيد الرقم من VIN/كود المحرك.' },
      'SEN-90919-01259': { part: 'spark_plug', verified: true, confidence: 'vin-required', scene: 'overview', anchor: [28, 50], calloutAnchor: [43, 36], focusRect: [17, 36, 25, 28], overlayRect: [25, 45, 7, 12], shape: 'spark_plug_single', scale: 2.75, note: 'البوجي يركب رأسيًا تحت الكويل في رأس المحرك. الخريطة تعرض بوجيًا واحدًا مختارًا؛ يلزم تأكيد الرقم من VIN لأن التجهيز قد يختلف بين البنزين والهايبرد/السوق.' },
      'SEN-26': { part: 'wiper', verified: true, confidence: 'direct', scene: 'overview', anchor: [42, 39], calloutAnchor: [52, 27], focusRect: [27, 27, 31, 22], overlayRect: [34, 35, 22, 9], shape: 'wiper_driver', scale: 2.15, note: 'مسّاحة 26 بوصة في جهة السائق، عند قاعدة الزجاج الأمامي. يظهر شكل الريشة نفسها بالبرتقالي.' },
      'SEN-20': { part: 'wiper', verified: true, confidence: 'direct', scene: 'overview', anchor: [34, 40], calloutAnchor: [45, 28], focusRect: [22, 29, 27, 21], overlayRect: [28, 36, 18, 8], shape: 'wiper_passenger', scale: 2.15, note: 'مسّاحة 20 بوصة في جهة الراكب، عند قاعدة الزجاج الأمامي. يظهر شكل الريشة نفسها بالبرتقالي.' }
    },
    'toyota-camry-2012-2017-2-5l-4cyl-esi6937864': {
      'SEN-17801-28030': { part: 'engine_air_filter', verified: true, confidence: 'direct', scene: 'engine', anchor: [38, 54], calloutAnchor: [38, 46], focusRect: [27, 42, 22, 24], overlayRect: [34, 49, 9, 9], shape: 'air_filter', scale: 2.65, note: 'فلتر الهواء داخل العلبة السوداء بجوار البطارية، ويُركّب أفقيًا تحت غطائها.' },
      '17801-28030':     { part: 'engine_air_filter', verified: true, confidence: 'direct', scene: 'engine', anchor: [38, 54], calloutAnchor: [38, 46], focusRect: [27, 42, 22, 24], overlayRect: [34, 49, 9, 9], shape: 'air_filter', scale: 2.65, note: 'فلتر الهواء داخل العلبة السوداء بجوار البطارية، ويُركّب أفقيًا تحت غطائها.' },
      'BQ-22204-28010':  { part: 'maf_sensor', verified: true, confidence: 'direct', scene: 'engine', anchor: [32, 47], calloutAnchor: [39, 39], focusRect: [22, 35, 23, 25], overlayRect: [30, 43, 7, 8], shape: 'maf_sensor', scale: 2.75, note: 'حساس MAF مثبت على مخرج علبة فلتر الهواء قبل خرطوم سحب المحرك.' },
      '22204-28010':     { part: 'maf_sensor', verified: true, confidence: 'direct', scene: 'engine', anchor: [32, 47], calloutAnchor: [39, 39], focusRect: [22, 35, 23, 25], overlayRect: [30, 43, 7, 8], shape: 'maf_sensor', scale: 2.75, note: 'حساس MAF مثبت على مخرج علبة فلتر الهواء قبل خرطوم سحب المحرك.' },
      'SEN-90919-01233': { part: 'spark_plug', verified: true, confidence: 'direct', scene: 'engine', anchor: [29, 47], calloutAnchor: [37, 36], focusRect: [16, 32, 27, 28], overlayRect: [20, 40, 21, 13], shape: 'spark_plugs', scale: 2.65, note: 'أربع بواجي في صف أعلى رأس المحرك، مباشرة تحت كويلات الإشعال وغطاء المحرك.' },
      '90919-01233':     { part: 'spark_plug', verified: true, confidence: 'direct', scene: 'engine', anchor: [29, 47], calloutAnchor: [37, 36], focusRect: [16, 32, 27, 28], overlayRect: [20, 40, 21, 13], shape: 'spark_plugs', scale: 2.65, note: 'أربع بواجي في صف أعلى رأس المحرك، مباشرة تحت كويلات الإشعال وغطاء المحرك.' },
      'SEN-87139-30040': { part: 'cabin_filter', verified: true, confidence: 'cross-reference', scene: 'overview', anchor: [49, 44], calloutAnchor: [56, 35], focusRect: [35, 31, 27, 27], overlayRect: [43, 39, 12, 11], shape: 'cabin_filter', scale: 2.15, note: 'فلتر المكيّف خلف درج الراكب داخل بيت المكيّف؛ ينزل الدرج للوصول إلى غطائه.' },
      '87139-30040':     { part: 'cabin_filter', verified: true, confidence: 'cross-reference', scene: 'overview', anchor: [49, 44], calloutAnchor: [56, 35], focusRect: [35, 31, 27, 27], overlayRect: [43, 39, 12, 11], shape: 'cabin_filter', scale: 2.15, note: 'فلتر المكيّف خلف درج الراكب داخل بيت المكيّف؛ ينزل الدرج للوصول إلى غطائه.' },
      'SEN-04152-31090': { part: 'oil_filter', verified: true, confidence: 'direct', scene: 'underbody', anchor: [51, 43], calloutAnchor: [58, 34], focusRect: [40, 31, 24, 24], overlayRect: [47, 39, 8, 10], shape: 'oil_filter', scale: 2.55, note: 'فلتر زيت cartridge داخل غطاء من أسفل جهة الراكب، أمام حوض زيت المحرك.' },
      '04152-31090':     { part: 'oil_filter', verified: true, confidence: 'direct', scene: 'underbody', anchor: [51, 43], calloutAnchor: [58, 34], focusRect: [40, 31, 24, 24], overlayRect: [47, 39, 8, 10], shape: 'oil_filter', scale: 2.55, note: 'فلتر زيت cartridge داخل غطاء من أسفل جهة الراكب، أمام حوض زيت المحرك.' },
      'SEN-04465-07010-G1': { part: 'brake_front', verified: true, confidence: 'direct', scene: 'side', anchor: [21, 73], calloutAnchor: [29, 61], focusRect: [10, 53, 23, 39], overlayRect: [16.8, 63, 9, 20], shape: 'brake_pad', scale: 2.35, note: 'الفحمات داخل كاليبر الدسك في العجلة الأمامية؛ الطقم يخدم الجانبين.' },
      '04465-07010-G1':     { part: 'brake_front', verified: true, confidence: 'direct', scene: 'side', anchor: [21, 73], calloutAnchor: [29, 61], focusRect: [10, 53, 23, 39], overlayRect: [16.8, 63, 9, 20], shape: 'brake_pad', scale: 2.35, note: 'الفحمات داخل كاليبر الدسك في العجلة الأمامية؛ الطقم يخدم الجانبين.' },
      'SEN-04466-33200-AQ': { part: 'brake_rear', verified: true, confidence: 'direct', scene: 'side', anchor: [83, 69], calloutAnchor: [75, 57], focusRect: [71, 50, 24, 40], overlayRect: [79, 59, 9, 20], shape: 'brake_pad', scale: 2.35, note: 'الفحمات داخل كاليبر الدسك في العجلة الخلفية.' },
      '04466-33200-AQ':     { part: 'brake_rear', verified: true, confidence: 'direct', scene: 'side', anchor: [83, 69], calloutAnchor: [75, 57], focusRect: [71, 50, 24, 40], overlayRect: [79, 59, 9, 20], shape: 'brake_pad', scale: 2.35, note: 'الفحمات داخل كاليبر الدسك في العجلة الخلفية.' },
      'SEN-26': { part: 'wiper', verified: true, confidence: 'direct', scene: 'engine', anchor: [49, 39], calloutAnchor: [55, 31], focusRect: [31, 28, 32, 23], overlayRect: [39, 35, 24, 10], shape: 'wiper_driver', scale: 2.05, note: 'مسّاحة 26 بوصة لجهة السائق، عند قاعدة الزجاج الأمامي فوق الـcowl.' },
      'SEN-18': { part: 'wiper', verified: true, confidence: 'direct', scene: 'engine', anchor: [39, 40], calloutAnchor: [45, 31], focusRect: [25, 29, 29, 23], overlayRect: [30, 36, 20, 9], shape: 'wiper_passenger', scale: 2.05, note: 'مسّاحة 18 بوصة لجهة الراكب، عند قاعدة الزجاج الأمامي فوق الـcowl.' },
      'BQ-000063': { part: 'compressor_valve', verified: true, confidence: 'vin-required', scene: 'underbody', anchor: [40, 46], calloutAnchor: [40, 35], focusRect: [29, 34, 23, 25], overlayRect: [36, 42, 7, 9], shape: 'compressor_control_valve', scale: 3.2, note: 'حساس BQ-000063 هو صمام تحكم أسطواني يدخل داخل جسم كمبريسر المكيّف، في الجزء السفلي الخلفي/الداخلي مقابل بكرة الكمبريسر. الكاميرا تركز على كمبريسر جهة الراكب؛ تحقق من VIN ورقم الكمبريسر لتأكيد التوافق.' },
      '000063': { part: 'compressor_valve', verified: true, confidence: 'vin-required', scene: 'underbody', anchor: [40, 46], calloutAnchor: [40, 35], focusRect: [29, 34, 23, 25], overlayRect: [36, 42, 7, 9], shape: 'compressor_control_valve', scale: 3.2, note: 'حساس BQ-000063 هو صمام تحكم أسطواني يدخل داخل جسم كمبريسر المكيّف، في الجزء السفلي الخلفي/الداخلي مقابل بكرة الكمبريسر. الكاميرا تركز على كمبريسر جهة الراكب؛ تحقق من VIN ورقم الكمبريسر لتأكيد التوافق.' },
      '35330-73010': { part: 'transmission_filter', verified: true, confidence: 'vin-required', scene: 'underbody', anchor: [66, 43], calloutAnchor: [58, 33], focusRect: [53, 30, 26, 27], overlayRect: [59, 36, 14, 16], shape: 'transmission_filter', scale: 2.5, note: 'فلتر القير داخل ناقل U760E فوق حوض القير؛ يظهر بعد فك الحوض. يلزم التحقق من VIN وكود القير.' },
      '35168-73010': { part: 'transmission_filter', verified: true, confidence: 'vin-required', scene: 'underbody', anchor: [66, 43], calloutAnchor: [58, 33], focusRect: [53, 30, 26, 27], overlayRect: [59, 36, 14, 16], shape: 'transmission_filter', scale: 2.5, note: 'فلتر القير داخل ناقل U760E فوق حوض القير؛ يظهر بعد فك الحوض. يلزم التحقق من VIN وكود القير.' },
      '8699': { part: 'transmission_service', verified: true, confidence: 'service', scene: 'underbody', anchor: [66, 47], calloutAnchor: [58, 36], focusRect: [54, 34, 24, 27], overlayRect: [62, 43, 7, 8], shape: 'service_point', scale: 2.45, note: 'هذا زيت خدمة، لذلك يُبرز موضع خدمة ناقل الحركة وليس عبوة الزيت كقطعة مركبة.' },
      '8679': { part: 'transmission_service', verified: true, confidence: 'service', scene: 'underbody', anchor: [66, 47], calloutAnchor: [58, 36], focusRect: [54, 34, 24, 27], overlayRect: [62, 43, 7, 8], shape: 'service_point', scale: 2.45, note: 'هذا زيت خدمة، لذلك يُبرز موضع خدمة ناقل الحركة وليس عبوة الزيت كقطعة مركبة.' }
    },
    'toyota-camry-2012-2017-3-5l-v6-esi4119943': {
      '99367-K1550': { part: 'drive_belt', verified: true, scene: 'overview', anchor: [28, 55], calloutAnchor: [42, 32], scale: 1.65, overlay: 'belt', beltLayout: 'XV50-3.5L', asset: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv50-v6-belt.webp?v=1787398803' },
      '7PK1550':     { part: 'drive_belt', verified: true, scene: 'overview', anchor: [28, 55], calloutAnchor: [42, 32], scale: 1.65, overlay: 'belt', beltLayout: 'XV50-3.5L', asset: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv50-v6-belt.webp?v=1787398803' }
    },
    'toyota-camry-2007-2011-3-5l-v6-esi1697382': {
      '99367-C2090': { part: 'drive_belt', verified: true, scene: 'overview', anchor: [28, 55], calloutAnchor: [42, 32], scale: 1.65, overlay: 'belt', beltLayout: 'XV40-3.5L', asset: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv40-v6-belt.webp?v=1787398798' },
      '7PK2090':     { part: 'drive_belt', verified: true, scene: 'overview', anchor: [28, 55], calloutAnchor: [42, 32], scale: 1.65, overlay: 'belt', beltLayout: 'XV40-3.5L', asset: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-camry-xv40-v6-belt.webp?v=1787398798' },
      '89467-07030': { part: 'oxygen_b2s1', verified: true, confidence: 'direct', scene: 'overview', anchor: [31, 52], calloutAnchor: [45, 32], scale: 1.78, note: 'Bank 2 Sensor 1 (LH): قبل المحفز في مشعب العادم الأمامي جهة الرديتر. تحقق من VIN قبل الشراء.' },
      '89467-07040': { part: 'oxygen_b1s1', verified: true, confidence: 'direct', scene: 'overview', anchor: [43, 39], calloutAnchor: [59, 24], scale: 1.9, note: 'Bank 1 Sensor 1 (RH): قبل المحفز في مشعب العادم الخلفي جهة الجدار الناري. تحقق من VIN قبل الشراء.' },
      '89465-07080': { part: 'oxygen_b1s2', verified: true, confidence: 'cross-reference', scene: 'underbody', anchor: [52, 55], calloutAnchor: [70, 35], scale: 1.82, note: 'Bank 1 Sensor 2 (RH): بعد محفز Bank 1 على فرع العادم الأيمن أسفل السيارة. تحقق من VIN قبل الشراء.' }
    }
  };

  /* LC200/J200 locations shared by the three store engine routes.  These are
   * limited to positions confirmed by Toyota documentation/part identity.
   * Engine internals, belt, evaporator and transmission variants stay
   * unpinned until their exact route + code combination is documented. */
  var J200_CONFIRMED_LOCATIONS = {
    'SEN-87139-30040': { part: 'cabin_filter', verified: true, confidence: 'direct', scene: 'overview', anchor: [47, 40], calloutAnchor: [59, 27], focusRect: [34, 28, 25, 25], overlayRect: [43, 36, 9, 10], shape: 'cabin_filter', scale: 2.35, note: 'فلتر المكيّف خلف درج الراكب الأمامي داخل بيت التكييف؛ ينزل درج الراكب للوصول إلى غطاء الفلتر.' },
    '87139-30040':     { part: 'cabin_filter', verified: true, confidence: 'direct', scene: 'overview', anchor: [47, 40], calloutAnchor: [59, 27], focusRect: [34, 28, 25, 25], overlayRect: [43, 36, 9, 10], shape: 'cabin_filter', scale: 2.35, note: 'فلتر المكيّف خلف درج الراكب الأمامي داخل بيت التكييف؛ ينزل درج الراكب للوصول إلى غطاء الفلتر.' },
    'SEN-04465-60280-R2': { part: 'brake_front', verified: true, confidence: 'direct', scene: 'overview', anchor: [54, 76], calloutAnchor: [65, 58], focusRect: [44, 60, 21, 32], overlayRect: [50, 68, 9, 18], shape: 'brake_pad', scale: 2.45, note: 'طقم الفحمات 04465-60280 داخل كاليبرَي الدسك للعجلتين الأماميتين؛ تُبرز الخريطة العجلة الأمامية الظاهرة.' },
    '04465-60280':        { part: 'brake_front', verified: true, confidence: 'direct', scene: 'overview', anchor: [54, 76], calloutAnchor: [65, 58], focusRect: [44, 60, 21, 32], overlayRect: [50, 68, 9, 18], shape: 'brake_pad', scale: 2.45, note: 'طقم الفحمات 04465-60280 داخل كاليبرَي الدسك للعجلتين الأماميتين؛ تُبرز الخريطة العجلة الأمامية الظاهرة.' },
    'SEN-04466-60160-AC': { part: 'brake_rear', verified: true, confidence: 'direct', scene: 'overview', anchor: [84, 65], calloutAnchor: [73, 48], focusRect: [74, 51, 19, 28], overlayRect: [80, 58, 8, 16], shape: 'brake_pad', scale: 2.45, note: 'طقم الفحمات 04466-60160 داخل كاليبرَي الدسك للعجلتين الخلفيتين؛ تُبرز الخريطة العجلة الخلفية الظاهرة.' },
    '04466-60160':        { part: 'brake_rear', verified: true, confidence: 'direct', scene: 'overview', anchor: [84, 65], calloutAnchor: [73, 48], focusRect: [74, 51, 19, 28], overlayRect: [80, 58, 8, 16], shape: 'brake_pad', scale: 2.45, note: 'طقم الفحمات 04466-60160 داخل كاليبرَي الدسك للعجلتين الخلفيتين؛ تُبرز الخريطة العجلة الخلفية الظاهرة.' }
  };

  [
    'toyota-land-cruiser-2008-2021-4-0l-v6-esr2768890',
    'toyota-land-cruiser-2008-2021-4-6l-v8-esr1948861',
    'toyota-land-cruiser-2008-2021-5-7l-v8-esr3444555'
  ].forEach(function (route) {
    LOCATION_BY_ROUTE_AND_CODE[route] = Object.assign(
      {},
      LOCATION_BY_ROUTE_AND_CODE[route] || {},
      J200_CONFIRMED_LOCATIONS
    );
  });

  /* DENSO 447610-2560 is already attached to these exact Camry routes in the
   * catalogue.  The evaporator sits inside the HVAC case behind the dashboard
   * on the passenger side, not in the engine bay. */
  var CAMRY_EVAPORATOR_447610_2560 = {
    '447610-2560': { part: 'ac_evaporator', verified: true, confidence: 'direct', scene: 'overview', anchor: [52, 47], calloutAnchor: [64, 32], focusRect: [38, 32, 29, 32], overlayRect: [47, 41, 11, 15], shape: 'ac_evaporator', scale: 2.4, note: 'ثلاجة المكيّف داخل بيت التكييف خلف لوحة العدادات في جهة الراكب، بعد فلتر المكيّف؛ ليست داخل حجرة المحرك.' }
  };
  [
    'toyota-camry-2007-2011-2-4l-4cyl-esr2431563',
    'toyota-camry-2007-2011-3-5l-v6-esi1697382',
    'toyota-camry-2012-2017-2-5l-4cyl-esi6937864',
    'toyota-camry-2012-2017-3-5l-v6-esi4119943'
  ].forEach(function (route) {
    LOCATION_BY_ROUTE_AND_CODE[route] = Object.assign(
      {},
      LOCATION_BY_ROUTE_AND_CODE[route] || {},
      CAMRY_EVAPORATOR_447610_2560
    );
  });

  function canonicalMapRoute(route) {
    var raw = String(route || '').toLowerCase();
    if (!raw || PROFILE_CHOICES_BY_ROUTE[raw]) return raw;

    /* EasySearch can regenerate the final esi/esr identifier without changing
     * the actual make, model, years or engine. Resolve that volatile suffix to
     * the single reviewed route with the same vehicle signature. If the
     * signature is not unique, fail closed and leave the unknown route alone. */
    var signature = raw.replace(/-(?:esi|esr)\d+$/, '');
    var matches = Object.keys(PROFILE_CHOICES_BY_ROUTE).filter(function (knownRoute) {
      return knownRoute.replace(/-(?:esi|esr)\d+$/, '') === signature;
    });
    return matches.length === 1 ? matches[0] : raw;
  }

  function routeFromPath() {
    var path = decodeURIComponent(window.location.pathname || '').toLowerCase();
    var match = path.match(VEHICLE_PATH);
    return match ? canonicalMapRoute(match[1]) : '';
  }

  function titleFromSlug(slug) {
    return String(slug || '').split('-').filter(Boolean).map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  }

  function engineFromSlug(slug) {
    return String(slug || '')
      .replace(/(\d)-(\d)-(\d)-(\d)l/g, '$1.$2–$3.$4L')
      .replace(/(\d)-(\d)l/g, '$1.$2L')
      .replace(/(\d)-(\d)(?=-|$)/g, '$1.$2')
      .replace(/4cyl/g, '4Cyl')
      .replace(/6cyl/g, '6Cyl')
      .replace(/8cyl/g, '8Cyl')
      .replace(/\bv4\b/g, 'V4')
      .replace(/\bv6\b/g, 'V6')
      .replace(/\bv8\b/g, 'V8')
      .replace(/-/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  var MULTI_WORD_MAKE_SLUGS = [
    'mercedes-benz',
    'aston-martin',
    'rolls-royce',
    'alfa-romeo',
    'great-wall',
    'land-rover'
  ];

  function makeSlugFromVehicleSlug(vehicleSlug) {
    for (var i = 0; i < MULTI_WORD_MAKE_SLUGS.length; i += 1) {
      var candidate = MULTI_WORD_MAKE_SLUGS[i];
      if (vehicleSlug === candidate || vehicleSlug.indexOf(candidate + '-') === 0) return candidate;
    }
    return vehicleSlug.split('-')[0] || '';
  }

  function profileFromPage() {
    var route = routeFromPath();
    var yearMatch = route.match(/-(\d{4})(?:-(\d{4}))?(?=-|$)/);
    var modelEnd = yearMatch && typeof yearMatch.index === 'number' ? yearMatch.index : -1;
    var vehicleSlug = modelEnd > -1 ? route.slice(0, modelEnd) : '';
    var makeSlug = makeSlugFromVehicleSlug(vehicleSlug);
    var makeLabels = {
      'land-rover': 'Land Rover',
      'mercedes-benz': 'Mercedes-Benz',
      'aston-martin': 'Aston Martin',
      'rolls-royce': 'Rolls-Royce',
      'alfa-romeo': 'Alfa Romeo',
      'great-wall': 'Great Wall',
      gmc: 'GMC',
      mg: 'MG'
    };
    var make = makeLabels[makeSlug] || titleFromSlug(makeSlug);
    var modelSlug = vehicleSlug && makeSlug ? vehicleSlug.slice(makeSlug.length + 1) : '';
    var model = titleFromSlug(modelSlug);
    var engineStart = yearMatch ? yearMatch.index + yearMatch[0].length : -1;
    var engineSlug = engineStart > -1
      ? route.slice(engineStart).replace(/^-/, '').replace(/-(?:esi|esr)\d+$/, '')
      : '';
    var cylinderMatch = route.match(/(?:^|-)(4cyl|6cyl|8cyl|v4|v6|v8)(?:-|$)/);
    var from = yearMatch ? Number(yearMatch[1]) : 0;
    var to = yearMatch ? Number(yearMatch[2] || yearMatch[1]) : 0;
    var engine = engineFromSlug(engineSlug);
    var cylinderToken = cylinderMatch ? cylinderMatch[1] : '';
    var cylinders = cylinderToken.indexOf('8') !== -1 ? 8 : (cylinderToken.indexOf('6') !== -1 ? 6 : (cylinderToken.indexOf('4') !== -1 ? 4 : 0));
    var templates = PROFILE_CHOICES_BY_ROUTE[route] || [];
    if (!templates.length) templates = sfUniversalProfileChoices(route, from, to);
    var choices = templates.map(function (choice) {
      return {
        code: choice.code,
        label: choice.label,
        from: choice.from,
        to: choice.to,
        status: choice.status,
        assets: PROFILE_ASSETS[choice.code] || null
      };
    });
    var selectedCode = SELECTED_PROFILE_BY_ROUTE[route] || (choices[0] && choices[0].code) || '';
    var selected = choices.filter(function (choice) { return choice.code === selectedCode; })[0] || choices[0] || null;
    var code = selected ? selected.code : '';
    return {
      route: route,
      make: make,
      model: model,
      modelSlug: modelSlug,
      from: from,
      to: to,
      engine: engine,
      cylinders: cylinders,
      code: code,
      assets: selected ? selected.assets : null,
      choices: choices,
      profileStatus: selected ? selected.status : '',
      profileLabel: selected ? selected.label : ''
    };
  }

  function usesDirectProductRows() {
    return Boolean((state.profile && state.profile.route) || document.querySelector('#senfinecoYmmCategories'));
  }

  function vehicleText() {
    var nav = document.querySelector('#senfinecoYmmCategories');
    var make = nav && nav.querySelector('.sf-ymm-nav__vehicle-cell--make dd');
    var model = nav && nav.querySelector('.sf-ymm-nav__vehicle-cell--model dd');
    var year = nav && nav.querySelector('.sf-ymm-nav__vehicle-cell--year dd');
    var engine = nav && nav.querySelector('.sf-ymm-nav__vehicle-cell--engine dd');
    var values = [
      make ? make.textContent.trim() : state.profile.make,
      model ? model.textContent.trim() : state.profile.model,
      year ? year.textContent.trim() : (state.profile.from && state.profile.to ? state.profile.from + '–' + state.profile.to : ''),
      engine ? engine.textContent.trim() : state.profile.engine
    ].filter(Boolean);
    return values.join(' · ');
  }

  function activeProfileChoice() {
    var choices = state.profile && state.profile.choices ? state.profile.choices : [];
    for (var i = 0; i < choices.length; i += 1) {
      if (choices[i].code === state.profile.code) return choices[i];
    }
    return choices[0] || null;
  }

  function renderGenerationChoices() {
    if (!state.generationList) return;
    var choices = state.profile && state.profile.choices ? state.profile.choices : [];
    state.generationList.replaceChildren();
    state.generationList.hidden = choices.length < 2;
    if (choices.length < 2) return;
    var label = document.createElement('span');
    label.textContent = 'اختر جيل السيارة:';
    state.generationList.appendChild(label);
    choices.forEach(function (choice) {
      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('data-profile-code', choice.code);
      button.setAttribute('aria-pressed', choice.code === state.profile.code ? 'true' : 'false');
      button.textContent = choice.label;
      state.generationList.appendChild(button);
    });
  }

  function renderImageCredit() {
    if (!state.creditLink) return;
    var assets = state.profile && state.profile.assets;
    var source = assets && assets.source;
    state.creditLink.hidden = !source;
    if (!source) {
      state.creditLink.removeAttribute('href');
      return;
    }
    state.creditLink.href = source;
    state.creditLink.textContent = assets.sourceLabel || 'مصدر صورة السيارة والترخيص';
  }

  function refreshVehicleHeader() {
    if (!state.vehicleLabel) return;
    var choice = activeProfileChoice();
    state.vehicleLabel.textContent = vehicleText() + (choice ? ' · الشكل ' + choice.label : '');
    renderGenerationChoices();
    renderImageCredit();
  }

  function chooseGeneration(code) {
    if (!state.profile || !state.profile.route) return;
    var choices = state.profile.choices || [];
    var choice = choices.filter(function (entry) { return entry.code === code; })[0];
    if (!choice) return;
    SELECTED_PROFILE_BY_ROUTE[state.profile.route] = code;
    state.profile.code = code;
    state.profile.assets = choice.assets;
    state.profile.profileLabel = choice.label;
    state.realReady = false;
    state.sceneImage.removeAttribute('src');
    refreshVehicleHeader();
    scanCards();
    if (state.activeKey && !productsFor(state.activeKey).length) {
      state.activeKey = '';
      state.activeProductId = '';
      state.activeLocation = null;
    }
    updateLaunchNote();
    focusRealScene(state.activeKey || '');
    if (state.activeKey) state.statusNote.textContent = locationNote(state.activeKey);
  }

  function isYmmPage() {
    return Boolean(routeFromPath() || document.querySelector('#senfinecoYmmCategories'));
  }

  function codeVariants(code) {
    var normalized = String(code || '').toUpperCase().trim();
    var variants = normalized ? [normalized] : [];
    /* Strip BQ-/SEN- only for an OEM-shaped code.  Internal SKUs such as
     * SEN-26 and BQ-000069 must remain exact to avoid cross-product matches. */
    var withoutMerchantPrefix = /^(?:BQ|SEN)-\d{5}-[A-Z0-9-]+$/.test(normalized)
      ? normalized.replace(/^(?:BQ|SEN)-/, '')
      : '';
    if (withoutMerchantPrefix && variants.indexOf(withoutMerchantPrefix) === -1) variants.push(withoutMerchantPrefix);
    return variants;
  }


function sfUniversalBodyForRoute(route){var value=String(route||"").toLowerCase();return/(?:hilux|tacoma|tundra)/.test(value)?"pickup":/(?:hiace|sienna|innova|veloz)/.test(value)?"van":/(?:gt86|gr86|(?:^|-)86(?:-|$)|supra|lexus-rc|lexus-lc500)/.test(value)?"coupe":/(?:land-cruiser|prado|fj-cruiser|fortuner|sequoia|lexus-gx|lexus-lx)/.test(value)?"suv":/(?:rav4|highlander|corolla-cross|raize|c-hr|bz4x|lexus-rx|lexus-nx|lexus-ux|lexus-rz)/.test(value)?"crossover":/(?:corolla|yaris|lexus-ct)/.test(value)?"compact":"sedan"}
var SF_UNIVERSAL_ASSET_CACHE=Object.create(null);
function sfUniversalVehicleAsset(body){if(SF_UNIVERSAL_ASSET_CACHE[body])return SF_UNIVERSAL_ASSET_CACHE[body];var geometry=body==="pickup"?{outline:"M92 116Q104 84 148 78H350L396 58H623Q676 58 710 86L817 128Q843 141 843 180Q843 219 817 232L710 274Q676 302 623 302H396L350 282H148Q104 276 92 244Z",glass:"M405 91Q432 73 472 73H616Q655 73 679 98L712 132H405ZM405 228H712L679 262Q655 287 616 287H472Q432 287 405 269Z"}:body==="van"?{outline:"M88 125Q98 80 154 72H706Q778 72 821 120Q844 145 844 180Q844 215 821 240Q778 288 706 288H154Q98 280 88 235Z",glass:"M445 90H690Q749 90 789 133L812 180L789 227Q749 270 690 270H445Z"}:body==="suv"||body==="crossover"?{outline:"M84 180Q84 119 139 91L247 66Q324 48 628 62L771 101Q829 120 842 180Q829 240 771 259L628 298Q324 312 247 294L139 269Q84 241 84 180Z",glass:"M285 82Q380 65 610 79L706 111L755 180L706 249L610 281Q380 295 285 278L236 226V134Z"}:body==="coupe"?{outline:"M86 180Q100 127 155 105L285 77Q405 47 618 77L772 118Q828 135 842 180Q828 225 772 242L618 283Q405 313 285 283L155 255Q100 233 86 180Z",glass:"M326 91Q420 69 593 91L685 122L727 180L685 238L593 269Q420 291 326 269L270 221V139Z"}:body==="compact"?{outline:"M92 180Q104 128 157 105L270 78Q390 56 617 78L766 117Q824 135 840 180Q824 225 766 243L617 282Q390 304 270 282L157 255Q104 232 92 180Z",glass:"M302 93Q395 73 596 91L688 122L733 180L688 238L596 269Q395 287 302 267L250 222V138Z"}:{outline:"M86 180Q98 131 151 109L274 77Q380 51 624 77L773 117Q826 133 842 180Q826 227 773 243L624 283Q380 309 274 283L151 251Q98 229 86 180Z",glass:"M309 91Q408 69 598 91L690 122L735 180L690 238L598 269Q408 291 309 269L253 222V138Z"},svg='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 360"><defs><linearGradient id="b" x1="0" x2="1"><stop stop-color="#0a5358" stop-opacity=".48"/><stop offset=".5" stop-color="#58b8b6" stop-opacity=".2"/><stop offset="1" stop-color="#0a5358" stop-opacity=".48"/></linearGradient><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop stop-color="#efffff" stop-opacity=".72"/><stop offset="1" stop-color="#8fd5d2" stop-opacity=".24"/></linearGradient></defs><rect width="900" height="360" fill="#eef8f7"/><g stroke="#0a5f63" stroke-width="2"><path d="'+geometry.outline+'" fill="url(#b)"/><path d="'+geometry.glass+'" fill="url(#g)"/><path d="M665 112Q776 116 817 151V209Q776 244 665 248Z" fill="#ff991c" fill-opacity=".12"/><path d="M132 235Q286 236 406 225T742 230" fill="none" stroke="#be7a24" stroke-dasharray="7 6"/><circle cx="738" cy="180" r="46" fill="#0a686c" fill-opacity=".16"/><circle cx="184" cy="180" r="38" fill="#0a686c" fill-opacity=".1"/><rect x="186" y="43" width="76" height="28" rx="13" fill="#26383a"/><rect x="186" y="289" width="76" height="28" rx="13" fill="#26383a"/><rect x="658" y="43" width="76" height="28" rx="13" fill="#26383a"/><rect x="658" y="289" width="76" height="28" rx="13" fill="#26383a"/></g><path d="M790 35h62m0 0-16-12m16 12-16 12" fill="none" stroke="#ff8f0a" stroke-width="7" stroke-linecap="round" stroke-linejoin="round"/></svg>';return SF_UNIVERSAL_ASSET_CACHE[body]="data:image/svg+xml;charset=utf-8,"+encodeURIComponent(svg)}
var SF_REAL_VEHICLE_ASSETS={"LEXUS_ES300_XV20_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-es300-1998-2001.webp?v=1787725355","revision":"lexus-model-real-v1-lexus_es300_xv20_real"},"LEXUS_ES330_XV30_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-es330-2002-2006.webp?v=1787725347","revision":"lexus-model-real-v1-lexus_es330_xv30_real"},"LEXUS_ES350_XV40_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-es350-2007-2012.webp?v=1787725341","revision":"lexus-model-real-v1-lexus_es350_xv40_real"},"LEXUS_ES350_XV60_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-es350-2013-2018.webp?v=1787725359","revision":"lexus-model-real-v1-lexus_es350_xv60_real"},"LEXUS_ES350_XZ10_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-es350-2019-2025.webp?v=1787725373","revision":"lexus-model-real-v1-lexus_es350_xz10_real"},"LEXUS_GS_S190_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-gs350-2007-2011.webp?v=1787725376","revision":"lexus-model-real-v1-lexus_gs_s190_real"},"LEXUS_GS_L10_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-gs-l10-2012-2020.webp?v=1787725384","revision":"lexus-model-real-v1-lexus_gs_l10_real"},"LEXUS_GX550_J250_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-gx550-2024-2026.webp?v=1787725380","revision":"lexus-model-real-v1-lexus_gx550_j250_real"},"LEXUS_IS_XE30_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-is-xe30-2014-2026.webp?v=1787725389","revision":"lexus-model-real-v1-lexus_is_xe30_real"},"LEXUS_IS_XE20_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-is350-xe20-2006-2013.webp?v=1787725392","revision":"lexus-model-real-v1-lexus_is_xe20_real"},"LEXUS_LS_XF20_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-ls400-1997-2000.webp?v=1787725404","revision":"lexus-model-real-v1-lexus_ls_xf20_real"},"LEXUS_LS_XF30_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-ls430-2001-2006.webp?v=1787725407","revision":"lexus-model-real-v1-lexus_ls_xf30_real"},"LEXUS_LS_XF40_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-ls460-2007-2017.webp?v=1787725416","revision":"lexus-model-real-v1-lexus_ls_xf40_real"},"LEXUS_LS_XF50_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-ls500-2018-2026.webp?v=1787725419","revision":"lexus-model-real-v1-lexus_ls_xf50_real"},"LEXUS_LX_J100_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-lx470-1998-2007.webp?v=1787725413","revision":"lexus-model-real-v1-lexus_lx_j100_real"},"LEXUS_LX_J200_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-lx570-2008-2021.webp?v=1787725410","revision":"lexus-model-real-v1-lexus_lx_j200_real"},"LEXUS_LX_J300_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-lx600-2022-2026.webp?v=1787725435","revision":"lexus-model-real-v1-lexus_lx_j300_real"},"LEXUS_NX_AZ10_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-nx-az10-2015-2021.webp?v=1787725449","revision":"lexus-model-real-v1-lexus_nx_az10_real"},"LEXUS_NX_AZ20_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-nx-az20-2022-2026.webp?v=1787725441","revision":"lexus-model-real-v1-lexus_nx_az20_real"},"LEXUS_RX_OLD_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-rx350-2007-2015.webp?v=1787725432","revision":"lexus-model-real-v1-lexus_rx_old_real"},"LEXUS_RX_AL20_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-lexus-rx350-2016-2022.webp?v=1787725438","revision":"lexus-model-real-v1-lexus_rx_al20_real"},"TOYOTA_SEQUOIA_XK60_REAL":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-toyota-sequoia-xk60-2008-2022.webp?v=1787725445","revision":"toyota-model-real-v1-toyota_sequoia_xk60_real"},"SF_REAL_GENERIC_SEDAN":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-generic-real-sedan.webp?v=1787725335","revision":"generic-real-v1-sf_real_generic_sedan"},"SF_REAL_GENERIC_SUV_FAMILY":{"url":"https://cdn.shopify.com/s/files/1/0737/9700/9582/files/senfineco-map-v2-generic-real-suv-family.webp?v=1787725351","revision":"generic-real-v1-sf_real_generic_suv_family"}};
var SF_REAL_SEDAN_FRONT_RIGHT_ZONES={engine_top:[72,44],engine_airbox:[76,45],maf:[74,45],engine_lower:[68,55],belt_side:[78,52],compressor_lower:[73,60],transmission_lower:[57,59],exhaust_front:[57,63],exhaust_rear:[40,60],dash_passenger:[53,39],windshield_driver:[55,33],windshield_passenger:[49,34],front_wheel:[69,69],rear_wheel:[25,53],fuel_tank:[39,55],radiator_front:[84,49],cooling_front:[81,54]};
var SF_REAL_SUV_FRONT_RIGHT_ZONES={engine_top:[73,44],engine_airbox:[77,46],maf:[75,46],engine_lower:[69,56],belt_side:[79,53],compressor_lower:[74,61],transmission_lower:[57,60],exhaust_front:[58,64],exhaust_rear:[39,64],dash_passenger:[53,38],windshield_driver:[56,32],windshield_passenger:[49,34],front_wheel:[66,74],rear_wheel:[20,63],fuel_tank:[38,57],radiator_front:[84,49],cooling_front:[81,54]};
function sfRealProfileUsesSuvZones(code){return/(?:_GX|_LX|_NX|_RX|SEQUOIA|SUV_FAMILY)/.test(String(code||""))}
Object.keys(SF_REAL_VEHICLE_ASSETS).forEach(function(code){var record=SF_REAL_VEHICLE_ASSETS[code];PROFILE_ASSETS[code]={glass:true,assetRevision:record.revision,overview:record.url,side:record.url,rear:record.url,underbody:record.url,mapKind:code.indexOf("SF_REAL_GENERIC_")===0?"generic-real":"model-real"};TOYOTA_GLASS_PROFILE_ZONES[code]=sfRealProfileUsesSuvZones(code)?SF_REAL_SUV_FRONT_RIGHT_ZONES:SF_REAL_SEDAN_FRONT_RIGHT_ZONES});
function sfRealChoice(code,label,from,to,status){return PROFILE_ASSETS[code]?[{code:code,label:label,from:from,to:to,status:status||"model_real"}]:[]}
function sfLexusRealProfileChoices(route,from,to){var value=String(route||"").toLowerCase(),code="",label="";
if(/^lexus-es300-/.test(value)){code="LEXUS_ES300_XV20_REAL";label="ES300 · 1998–2001"}
else if(/^lexus-es330-/.test(value)){code="LEXUS_ES330_XV30_REAL";label="ES330 · 2002–2006"}
else if(/^lexus-es350-/.test(value)){if(from>=2019){code="LEXUS_ES350_XZ10_REAL";label="ES350 · 2019–2025"}else if(from>=2013){code="LEXUS_ES350_XV60_REAL";label="ES350 · 2013–2018"}else{code="LEXUS_ES350_XV40_REAL";label="ES350 · 2007–2012"}}
else if(/^lexus-gs350-/.test(value)&&from<2012){code="LEXUS_GS_S190_REAL";label="GS350 · 2007–2011"}
else if(/^lexus-(?:gs200t|gs300t|gs200t-300t|gs350)-/.test(value)){code="LEXUS_GS_L10_REAL";label="GS · 2012–2020"}
else if(/^lexus-gx550-/.test(value)){code="LEXUS_GX550_J250_REAL";label="GX550 · 2024–2026"}
else if(/^lexus-(?:is200t|is300|is200t-300|is250)-/.test(value)){code="LEXUS_IS_XE30_REAL";label="IS · 2014–2026"}
else if(/^lexus-is350-/.test(value)){code=from>=2014?"LEXUS_IS_XE30_REAL":"LEXUS_IS_XE20_REAL";label=from>=2014?"IS350 · 2014–2026":"IS350 · 2006–2013"}
else if(/^lexus-ls400-/.test(value)){code="LEXUS_LS_XF20_REAL";label="LS400 · 1997–2000"}
else if(/^lexus-ls430-/.test(value)){code="LEXUS_LS_XF30_REAL";label="LS430 · 2001–2006"}
else if(/^lexus-ls460-/.test(value)){code="LEXUS_LS_XF40_REAL";label="LS460 · 2007–2017"}
else if(/^lexus-ls500-/.test(value)){code="LEXUS_LS_XF50_REAL";label="LS500 · 2018–2026"}
else if(/^lexus-lx470-/.test(value)){code="LEXUS_LX_J100_REAL";label="LX470 · 1998–2007"}
else if(/^lexus-lx570-/.test(value)){code="LEXUS_LX_J200_REAL";label="LX570 · 2008–2021"}
else if(/^lexus-lx600-/.test(value)){code="LEXUS_LX_J300_REAL";label="LX600 · 2022–2026"}
else if(/^lexus-(?:nx200t|nx300|nx200t-300)-/.test(value)){code="LEXUS_NX_AZ10_REAL";label="NX · 2015–2021"}
else if(/^lexus-nx350-/.test(value)){code="LEXUS_NX_AZ20_REAL";label="NX350 · 2022–2026"}
else if(/^lexus-rx350-/.test(value)){code=from>=2016?"LEXUS_RX_AL20_REAL":"LEXUS_RX_OLD_REAL";label=from>=2016?"RX350 · 2016–2022":"RX350 · 2007–2015"}
return code?sfRealChoice(code,label,from,to,"model_real"):[]}
function sfOtherVehicleUsesSuvFamily(route){return/(?:^|-)(?:silverado|tahoe|durango|ram-1500|ram-1500-classic|ram-2500|expedition|explorer|f-150|gv70|gv80|acadia|sierra|yukon|santa-fe|santa-fe-v6|tucson|qx80|cherokee|grand-cherokee|wrangler|sorento|soul|sportage|defender-110|defender-90|discovery|discovery-4|range-rover|range-rover-sport|range-rover-velar|range-rover-vogue|cx-5|cx-9|glc200|glc250|glc300|gle400|gle450|rx5|l200|outlander|pajero|armada|navara|pathfinder|patrol|rogue|safari-y61|x-trail|xterra)(?:-|$)/.test(String(route||"").toLowerCase())}
function sfToyotaMissingRealProfileChoices(route,from,to){var value=String(route||"").toLowerCase();if(/^toyota-sequoia-/.test(value)&&from<2023)return sfRealChoice("TOYOTA_SEQUOIA_XK60_REAL","Sequoia · 2008–2022 · XK60",from,to,"model_real");return[]}
function sfUniversalProfileChoices(route,from,to){var value=String(route||"").toLowerCase();if(/^lexus-/.test(value))return sfLexusRealProfileChoices(value,from,to);if(/^toyota-/.test(value))return sfToyotaMissingRealProfileChoices(value,from,to);var suv=sfOtherVehicleUsesSuvFamily(value),code=suv?"SF_REAL_GENERIC_SUV_FAMILY":"SF_REAL_GENERIC_SEDAN",label=suv?"صورة توضيحية SUV / عائلية":"صورة توضيحية سيدان";return sfRealChoice(code,label,from,to,"generic_real")}
/* These points are percentages of each Camry overview source, not mirrored
 * copies of another vehicle.  All five images face front-left.  radiator_front
 * stores y five points above the visible core because the existing radiator
 * blueprint adds dy:5; the resolved pin therefore lands on the core itself. */
var SF_CAMRY_GLASS_PROFILE_ZONES={
XV20:{engine_top:[27,48],engine_airbox:[37,50],maf:[34,49],engine_lower:[28,59],belt_side:[21,55],compressor_lower:[27,66],transmission_lower:[36,61],exhaust_front:[46,66],exhaust_rear:[69,60],dash_passenger:[51,39],windshield_driver:[45,34],windshield_passenger:[55,35],front_wheel:[47,76],rear_wheel:[89,48],fuel_tank:[76,55],radiator_front:[18,63],cooling_front:[21,57]},
XV30:{engine_top:[25,49],engine_airbox:[35,52],maf:[32,50],engine_lower:[28,59],belt_side:[20,55],compressor_lower:[27,66],transmission_lower:[35,61],exhaust_front:[46,66],exhaust_rear:[69,60],dash_passenger:[49,38],windshield_driver:[44,33],windshield_passenger:[55,34],front_wheel:[46,77],rear_wheel:[89,48],fuel_tank:[76,55],radiator_front:[17,64],cooling_front:[20,57]},
XV40:{engine_top:[27,48],engine_airbox:[36,51],maf:[32,49],engine_lower:[28,59],belt_side:[21,55],compressor_lower:[28,66],transmission_lower:[35,60],exhaust_front:[47,68],exhaust_rear:[69,59],dash_passenger:[49,38],windshield_driver:[45,33],windshield_passenger:[55,34],front_wheel:[46,76],rear_wheel:[89,47],fuel_tank:[76,55],radiator_front:[16,63],cooling_front:[20,57]},
XV50:{engine_top:[26,46],engine_airbox:[37,50],maf:[33,49],engine_lower:[27,57],belt_side:[21,54],compressor_lower:[27,65],transmission_lower:[35,59],exhaust_front:[49,67],exhaust_rear:[70,57],dash_passenger:[49,38],windshield_driver:[44,32],windshield_passenger:[54,34],front_wheel:[45,75],rear_wheel:[89,52],fuel_tank:[77,57],radiator_front:[17,62],cooling_front:[21,56]},
XV70:{engine_top:[24,48],engine_airbox:[31,59],maf:[29,55],engine_lower:[27,60],belt_side:[20,55],compressor_lower:[27,68],transmission_lower:[35,62],exhaust_front:[48,70],exhaust_rear:[71,58],dash_passenger:[50,40],windshield_driver:[43,33],windshield_passenger:[55,35],front_wheel:[44,76],rear_wheel:[89,47],fuel_tank:[76,54],radiator_front:[16,62],cooling_front:[21,55]}
};
Object.keys(SF_CAMRY_GLASS_PROFILE_ZONES).forEach(function(code){TOYOTA_GLASS_PROFILE_ZONES[code]=SF_CAMRY_GLASS_PROFILE_ZONES[code]});
var SF_GENERAL_ZONE_BY_PART={
engine_mount_general:"engine_lower",brake_system:"mid_wheels",shock_absorber_general:"mid_wheels",oxygen_general:"exhaust_rear",radiator_hose_general:"cooling_front",engine_internal:"engine_top",engine_sensor_general:"engine_top",cooling_system:"cooling_front",suspension_general:"mid_wheels",steering_system:"front_wheel",fuel_system:"engine_airbox",transmission_general:"transmission_lower",drivetrain_general:"mid_underbody",clutch_system:"transmission_lower",exhaust_system:"exhaust_rear",electrical_system:"engine_top",body_system:"body_center",wheel_hub_general:"mid_wheels",vehicle_general:"body_center",ac_system:"compressor_lower"
};
function sfActiveProfileZones(){return state.profile&&TOYOTA_GLASS_PROFILE_ZONES[state.profile.code]||null}
function sfAverageAnchor(a,b,yShift){return a&&b?[(Number(a[0])+Number(b[0]))/2,(Number(a[1])+Number(b[1]))/2+(yShift||0)]:null}
function sfProfileAnchorForKey(key){var zones=sfActiveProfileZones();if(!zones)return null;var blueprint=TOYOTA_GLASS_PART_BLUEPRINTS[key],zoneName=key==="radiator"&&zones.radiator_front?"radiator_front":SF_GENERAL_ZONE_BY_PART[key]||blueprint&&blueprint.zone;if(zoneName==="mid_wheels")return sfAverageAnchor(zones.front_wheel,zones.rear_wheel,0);if(zoneName==="mid_underbody")return sfAverageAnchor(zones.front_wheel,zones.rear_wheel,7);if(zoneName==="body_center")return sfAverageAnchor(zones.front_wheel,zones.rear_wheel,-20);var base=zones[zoneName];if(!base)return null;if(zoneName==="radiator_front")return[Number(base[0]),Number(base[1])+5];if(SF_GENERAL_ZONE_BY_PART[key])return[Number(base[0]),Number(base[1])];var frontIsRight=zones.engine_top&&zones.rear_wheel?zones.engine_top[0]>zones.rear_wheel[0]:true,frontShift=blueprint&&blueprint.towardFront?blueprint.towardFront*(frontIsRight?1:-1):0;return[clamp(Number(base[0])+(blueprint&&blueprint.dx||0)+frontShift,4,96),clamp(Number(base[1])+(blueprint&&blueprint.dy||0),7,93)]}
function sfCalibrateCategoryLocation(location,key){if(!location||location.verified===true||location.confidence!=="category-zone")return location;var anchor=sfProfileAnchorForKey(key);if(!anchor)return location;location.scene="overview";location.anchor=anchor;location.calloutAnchor=[clamp(anchor[0]+(anchor[0]>55?-13:13),10,90),clamp(anchor[1]-15,10,90)];location.note=(location.note?location.note+" ":"")+"المؤشر معاير لاتجاه صورة هذا الجيل.";return location}
var SF_UNIVERSAL_PARTS={engine_mount_general:{ar:"قواعد المحرك والجير",en:"Engine / transmission mounts",icon:"◆",zone:"engine",points:[[0,1.15,.62]],anchor:[58,48]},brake_system:{ar:"منظومة الفرامل",en:"Brake system",icon:"◉",zone:"underbody",points:[[0,0,.35]],anchor:[50,61]},shock_absorber_general:{ar:"المساعدات والتعليق",en:"Shocks and suspension",icon:"↕",zone:"underbody",points:[[0,0,.45]],anchor:[50,58]},oxygen_general:{ar:"حساسات الأكسجين والعادم",en:"Oxygen / exhaust sensors",icon:"λ",zone:"underbody",points:[[0,.15,.28]],anchor:[49,61]},radiator_hose_general:{ar:"خراطيم نظام التبريد",en:"Cooling hoses",icon:"⌇",zone:"engine",points:[[0,1.6,.55]],anchor:[61,49]},engine_internal:{ar:"القطع الداخلية للمحرك",en:"Internal engine parts",icon:"⚙",zone:"engine",points:[[0,1.15,.68]],anchor:[59,43]},engine_sensor_general:{ar:"حساسات المحرك",en:"Engine sensors",icon:"◉",zone:"engine",points:[[0,1.2,.7]],anchor:[61,42]},cooling_system:{ar:"نظام التبريد",en:"Cooling system",icon:"▦",zone:"front",points:[[0,1.9,.65]],anchor:[72,49]},suspension_general:{ar:"التعليق والمقصات والجلب",en:"Suspension, arms and bushings",icon:"↕",zone:"underbody",points:[[0,0,.38]],anchor:[50,59]},steering_system:{ar:"نظام التوجيه والدركسون",en:"Steering system",icon:"↔",zone:"front_wheels",points:[[0,1.25,.42]],anchor:[69,60]},fuel_system:{ar:"نظام الوقود وسحب الهواء",en:"Fuel and intake system",icon:"⛽",zone:"engine",points:[[.35,1.35,.65]],anchor:[65,44]},transmission_general:{ar:"الجير والدفرنس",en:"Transmission and differential",icon:"▰",zone:"underbody",points:[[0,.55,.28]],anchor:[45,63]},drivetrain_general:{ar:"العكوس ونقل الحركة",en:"Drivetrain and axles",icon:"↔",zone:"underbody",points:[[0,0,.3]],anchor:[48,62]},clutch_system:{ar:"نظام الكلتش",en:"Clutch system",icon:"◌",zone:"underbody",points:[[0,.7,.3]],anchor:[47,61]},exhaust_system:{ar:"نظام العادم",en:"Exhaust system",icon:"≈",zone:"underbody",points:[[0,-.15,.25]],anchor:[44,66]},electrical_system:{ar:"القطع الكهربائية",en:"Electrical system",icon:"⚡",zone:"engine",points:[[.45,1.2,.72]],anchor:[66,42]},body_system:{ar:"الهيكل والملحقات",en:"Body and accessories",icon:"◇",zone:"overview",points:[[0,0,.85]],anchor:[50,38]},wheel_hub_general:{ar:"هوبات ورمانات العجلات",en:"Wheel hubs and bearings",icon:"◉",zone:"underbody",points:[[0,0,.4]],anchor:[50,58]},vehicle_general:{ar:"موقع القطعة في السيارة",en:"Vehicle part location",icon:"⌖",zone:"overview",points:[[0,0,.7]],anchor:[50,50]}};
var SF_PRECISE_DYNAMIC_PARTS={fuel_pump_engine:{ar:"مضخة الوقود عالية الضغط على المحرك",en:"Engine-mounted high-pressure fuel pump",icon:"⛽",zone:"engine",points:[[0,1.2,.7]],anchor:[66,45]},abs_sensor_front:{ar:"حساس ABS للعجلة الأمامية",en:"Front wheel ABS speed sensor",icon:"◉",zone:"front_wheels",points:[[0,1.3,.4]],anchor:[72,61]},abs_sensor_rear:{ar:"حساس ABS للعجلة الخلفية",en:"Rear wheel ABS speed sensor",icon:"◉",zone:"rear_wheels",points:[[0,-1.2,.4]],anchor:[27,61]},suspension_front:{ar:"قطعة تعليق أمامية",en:"Front suspension part",icon:"↕",zone:"front_wheels",points:[[0,1.2,.4]],anchor:[72,60]},suspension_rear:{ar:"قطعة تعليق خلفية",en:"Rear suspension part",icon:"↕",zone:"rear_wheels",points:[[0,-1.2,.4]],anchor:[27,60]}};
Object.keys(SF_PRECISE_DYNAMIC_PARTS).forEach(function(key){SF_UNIVERSAL_PARTS[key]=SF_PRECISE_DYNAMIC_PARTS[key]});
TOYOTA_GLASS_PART_BLUEPRINTS.fuel_pump_engine={zone:"engine_top",scale:2.5,dy:2};
TOYOTA_GLASS_PART_BLUEPRINTS.abs_sensor_front={zone:"front_wheel",scale:2.4};
TOYOTA_GLASS_PART_BLUEPRINTS.abs_sensor_rear={zone:"rear_wheel",scale:2.4};
TOYOTA_GLASS_PART_BLUEPRINTS.suspension_front={zone:"front_wheel",scale:2.35};
TOYOTA_GLASS_PART_BLUEPRINTS.suspension_rear={zone:"rear_wheel",scale:2.35};
Object.keys(SF_UNIVERSAL_PARTS).forEach(function(key){var record=SF_UNIVERSAL_PARTS[key],anchor=record.anchor;PARTS[key]||(PARTS[key]={ar:record.ar,en:record.en,icon:record.icon,zone:record.zone,points:record.points}),PART_SCENES[key]||(PART_SCENES[key]={anchor:anchor,scale:record.zone==="overview"?1.45:2.15,scene:record.zone==="underbody"?"underbody":"overview"})});
function sfUniversalRaw(card){return normalize([(card.getAttribute("data-sf-part-key")||""),(card.getAttribute("data-sf-part-type")||""),(card.getAttribute("data-sf-subcategory")||""),(card.getAttribute("data-sf-main-category")||""),card.getAttribute("data-sf-position")||"",card.getAttribute("data-sf-map-zone")||"",card.getAttribute("data-sf-product-tags")||"",card.getAttribute("data-sf-product-info")||"",card.getAttribute("data-sf-product-title")||""].join(" ").replace(/[_\/\-–—]+/g," "))}
function sfPreciseOverridePartKey(card){var raw=sfUniversalRaw(card),front=includesAny(raw,["front","امامي","الامامي"]),rear=includesAny(raw,["rear","back","خلفي","الخلفي"]);if(includesAny(raw,["high pressure fuel pump","direct injection pump","طرمبه بنزين ضغط عالي","طرمبة بنزين ضغط عالي"]))return"fuel_pump_engine";if(includesAny(raw,["abs speed sensor","wheel speed sensor","حساس abs"]))return rear&&!front?"abs_sensor_rear":front&&!rear?"abs_sensor_front":"wheel_hub_general";if(includesAny(raw,["strut mount","strut bearing","mount bearing","بيرنج كرسي مساعد","كرسي مساعد"]))return rear&&!front?"shock_absorber_rear":"shock_absorber_front";if(includesAny(raw,["ball joint","stabilizer link","sway bar link","control arm","arm bushing","مفصل سفلي","جامبين","وصله ميزان","وصلة ميزان","مقص","جلبه مقص"]))return rear&&!front?"suspension_rear":front&&!rear?"suspension_front":"suspension_general";return""}
function sfUniversalMapPartKey(card){var raw=sfUniversalRaw(card),front=includesAny(raw,["front","امامي","الامامي"]),rear=includesAny(raw,["rear","back","خلفي","الخلفي"]),left=includesAny(raw,[" left"," lh","يسار"]),right=includesAny(raw,[" right"," rh","يمين"]),upper=includesAny(raw,["upper","علوي","فوق"]),lower=includesAny(raw,["lower","سفلي","تحت"]);if(includesAny(raw,["engine mount","motor mount","transmission mount","قاعده محرك","قاعده مكينه","كرسي مكينه"]))return front&&!rear?"engine_mount_front":rear&&!front?"engine_mount_rear":left&&!right?"engine_mount_left_upper":right&&!left?"engine_mount_right_upper":"engine_mount_general";if(includesAny(raw,["cabin air filter","cabin filter","فلتر مكيف"]))return"cabin_filter";if(includesAny(raw,["engine air filter","air filter","فلتر هواء المحرك"]))return"engine_air_filter";if(includesAny(raw,["oil filter","فلتر زيت"]))return"oil_filter";if(includesAny(raw,["transmission filter","gearbox filter","فلتر جير","فلتر قير"]))return"transmission_filter";if(includesAny(raw,["spark plug","بواجي","شمعات احتراق"]))return"spark_plug";if(includesAny(raw,["ignition coil","كويل"]))return"ignition_coil";if(includesAny(raw,["brake pad","brake shoe","brake disc","brake rotor","brake cable","parking brake","brake hardware","سفايف","فحمات","فرامل","هوب فرامل"]))return rear&&!front?"brake_rear":front&&!rear?"brake_front":"brake_system";if(includesAny(raw,["shock absorber","suspension strut","strut mount","suspension support","مساعد","مساعدات"]))return rear&&!front?"shock_absorber_rear":front&&!rear?"shock_absorber_front":"shock_absorber_general";if(includesAny(raw,["tie rod","rack end","steering rod","راس دركسون","رأس دركسون"]))return"steering_tie_rod";if(includesAny(raw,["steering","power steering","دركسون","توجيه"]))return"steering_system";if(includesAny(raw,["air fuel ratio sensor","oxygen sensor","o2 sensor","lambda sensor","حساس اكسجين","حساس الهواء والوقود"]))return rear||lower||includesAny(raw,["downstream","sensor 2"])?"oxygen_rear":front||includesAny(raw,["upstream","sensor 1"])?left&&!right?"oxygen_front_left":right&&!left?"oxygen_front_right":"oxygen_front":"oxygen_general";if(includesAny(raw,["mass air flow","maf sensor","حساس ماف"]))return"maf_sensor";if(includesAny(raw,["knock sensor","knock control","حساس نوك"]))return"knock_sensor";if(includesAny(raw,["ac pressure sensor","a/c pressure sensor","حساس ضغط المكيف"]))return"ac_pressure_sensor";if(includesAny(raw,["compressor control valve","compressor sensor","ac compressor sensor","بلف كمبريسر","حساس كمبريسر"]))return"compressor_valve";if(includesAny(raw,["ac evaporator","a/c evaporator","ثلاجه المكيف","ثلاجة المكيف"]))return"ac_evaporator";if(includesAny(raw,["thermostat","ثرموستات","بلف حراره"]))return"thermostat";if(includesAny(raw,["water pump","طرمبه ماء","طرمبة ماء"]))return"water_pump";if(includesAny(raw,["radiator hose","cooling hose","خرطوم راديتر","هوز راديتر"]))return lower&&!upper?"radiator_hose_lower":upper&&!lower?"radiator_hose_upper":"radiator_hose_general";if(includesAny(raw,["radiator","cooling fan","coolant","reserve tank","نظام التبريد","راديتر","قربه ماء"]))return includesAny(raw,["radiator assembly","رديتر","راديتر"])&&!includesAny(raw,["fan","tank","cap"])?"radiator":"cooling_system";if(includesAny(raw,["fuel pump","طرمبه بنزين","طرمبة بنزين"]))return"fuel_pump";if(includesAny(raw,["fuel injector","injector","fuel filter","fuel tank","throttle","air cleaner hose","intake","fuel system","بخاخ","نظام الوقود"]))return"fuel_system";if(includesAny(raw,["belt tensioner","chain tensioner","شداد سير","شداد سلسله"]))return"belt_tensioner";if(includesAny(raw,["idler pulley","belt pulley","alternator pulley","بكره سير","بكرة سير"]))return"idler_pulley";if(includesAny(raw,["drive belt","engine belt","timing belt","timing chain","v ribbed belt","serpentine","سير محرك","سلسله توقيت","جنزير"]))return"drive_belt";if(includesAny(raw,["wiper","مساحه","مساحة"]))return"wiper";if(includesAny(raw,["tire pressure","tpms","wheel hub","hub bearing","axle bearing","رمان محور","صرة وبلي"]))return"wheel_hub_general";if(includesAny(raw,["control arm","stabilizer link","sway bar","ball joint","arm bushing","suspension","مقص","وصله ميزان","وصلة ميزان","جلبه مقص"]))return"suspension_general";if(includesAny(raw,["cv axle","cv joint","cv boot","drive shaft","driveshaft","universal joint","axle shaft","عكس","عمود دوران","صليبه"]))return"drivetrain_general";if(includesAny(raw,["clutch","كلتش","دبرياج"]))return"clutch_system";if(includesAny(raw,["transmission","gearbox","differential","جير","قير","دفرنس"]))return"transmission_general";if(includesAny(raw,["exhaust","muffler","عادم","شكمان"]))return"exhaust_system";if(includesAny(raw,["starter","alternator","relay","switch","electric motor","battery","headlamp","lamp","horn","antenna","fuse","distributor","gauge","دينمو","سلف","ريليه","بوق","اسطب","لمبه","لمبة"]))return"electrical_system";if(includesAny(raw,["crankshaft sensor","camshaft sensor","temperature sensor","coolant sensor","oil pressure sensor","speed sensor","abs sensor","accelerator pedal with sensor","حساس كرنك","حساس كام","حساس حراره","حساس حرارة"]))return"engine_sensor_general";if(includesAny(raw,["piston","gasket","cylinder head","oil pump","cam timing","vvt","timing guide","timing sprocket","balance shaft","internal engine","وجيه مكينه","جازكيت","بستم","شنابر"]))return"engine_internal";if(includesAny(raw,["door","handle","body","exterior","interior","mirror","bumper","هيكل","مقبض","مرايه","صدام"]))return"body_system";if(includesAny(raw,["sf part ac part","sf part ac valve","sf main ac","main ac","air conditioning","hvac","مكيف"]))return"ac_system";if(includesAny(raw,["sf part electrical accessory","sf main electrical parts","electrical parts"]))return"electrical_system";if(includesAny(raw,["sf part cooling part","sf main cooling","main cooling","water inlet","water outlet","oil cooler"]))return"cooling_system";if(includesAny(raw,["sf part sensor","sf main electrical sensors","electrical sensors"]))return"engine_sensor_general";if(includesAny(raw,["sf part bearing","sf part bushing","sf main suspension steering","suspension steering"]))return"suspension_general";if(includesAny(raw,["sf part pulley"]))return"idler_pulley";if(includesAny(raw,["sf part ignition part"]))return"electrical_system";if(includesAny(raw,["sf main brakes","main brakes"]))return"brake_system";if(includesAny(raw,["sf main fuel air","fuel air"]))return"fuel_system";if(includesAny(raw,["sf main transmission differential","transmission differential"]))return"transmission_general";if(includesAny(raw,["sf part drivetrain part","sf main drivetrain","main drivetrain"]))return"drivetrain_general";if(includesAny(raw,["sf main exhaust","main exhaust"]))return"exhaust_system";if(includesAny(raw,["sf main body accessories","body accessories"]))return"body_system";if(includesAny(raw,["sf main engine","internal engine","engine part"]))return"engine_internal";return"vehicle_general"}
function sfLocationRaw(product){var card=product&&product.card;return card?sfUniversalRaw(card):normalize(product&&product.title||"")}
var SF_MULTI_POSITION_BY_CODE={"48510-09Q30":"front_sides","48531-80736":"rear_sides","48531-69795":"rear_sides","89615-20090":"engine_sides","48530-80241":"rear_sides","48510-69405":"front_sides","48510-69355":"front_sides","48510-09K80":"front_sides","48530-69425":"rear_sides"};
function sfPairAt(anchor,spread){var point=anchor||[50,50],delta=spread||4;return[[point[0],clamp(point[1]-delta,7,93)],[point[0],clamp(point[1]+delta,7,93)]]}
function sfEnrichLocation(location,product,key){if(!location)return location;location=sfCalibrateCategoryLocation(location,key);var raw=sfLocationRaw(product),sku=String(product&&product.sku||product&&product.card&&product.card.getAttribute("data-sf-product-sku")||"").toUpperCase().trim(),forced=SF_MULTI_POSITION_BY_CODE[sku]||"",isSet=includesAny(raw,["طقم","set","pair","2x","2 x","2pcs","2 pcs"]),bothSides=includesAny(forced,["sides","all"])||isSet&&includesAny(raw,["يمين ويسار","يسار ويمين","يمين و يسار","يسار و يمين","right and left","left and right","right & left","left & right","right + left","left + right","right left","left right","rh lh","lh rh","جهتين"]),bothEnds=includesAny(forced,["ends","all"])||isSet&&includesAny(raw,["امامي وخلفي","خلفي وامامي","امام وخلف","خلف وامام","امامي و خلفي","خلفي و امامي","front and rear","rear and front","front & rear","rear & front","front + rear","rear + front","front rear","rear front"]),front=forced.indexOf("front")!==-1||includesAny(raw,["front","امامي","الامامي"]),rear=forced.indexOf("rear")!==-1||includesAny(raw,["rear","back","خلفي","الخلفي"]),zones=sfActiveProfileZones(),frontPoint=zones&&zones.front_wheel||[76,50],rearPoint=zones&&zones.rear_wheel||[24,50],spread=zones?4:14,anchors=[];if(location.verified===true){anchors=bothSides?sfPairAt(location.anchor,3):[location.anchor?location.anchor.slice():[50,50]]}else if(bothSides&&bothEnds)anchors=sfPairAt(frontPoint,spread).concat(sfPairAt(rearPoint,spread));else if(bothEnds)anchors=[frontPoint.slice(),rearPoint.slice()];else if(bothSides){var point=rear&&!front?rearPoint:front&&!rear?frontPoint:location.anchor||frontPoint;anchors=sfPairAt(point,spread)}else anchors=[location.anchor?location.anchor.slice():[50,50]];location.anchors=anchors;if(anchors.length>1){if(location.verified!==true){location.scene="overview";location.scale=1.35}location.anchor=[anchors.reduce(function(sum,item){return sum+item[0]},0)/anchors.length,anchors.reduce(function(sum,item){return sum+item[1]},0)/anchors.length];location.calloutAnchor=[clamp(location.anchor[0],10,90),clamp(location.anchor[1]-18,10,90)];location.note=(location.note?location.note+" ":"")+"تم عرض جميع المواضع المذكورة في وصف الطقم."}return location}
function sfRenderLocationPins(location,key){if(!state.sceneCamera)return;var root=state.sceneCamera.querySelector("[data-sf-location-pins]");root||(root=document.createElement("div"),root.className="sf-camry-map__location-pins",root.setAttribute("data-sf-location-pins",""),root.setAttribute("aria-hidden","true"),state.sceneCamera.appendChild(root));root.replaceChildren();if(!location||!location.mapped)return;(location.anchors&&location.anchors.length?location.anchors:[location.anchor]).filter(Boolean).forEach(function(anchor,index,list){var pin=document.createElement("span");pin.className="sf-camry-map__location-pin"+(list.length>1?" is-multiple":""),pin.style.left=anchor[0]+"%",pin.style.top=anchor[1]+"%",pin.textContent=PARTS[key]&&PARTS[key].icon||"⌖",pin.setAttribute("data-location-index",String(index+1)),root.appendChild(pin)})}

  function profileZoneLocation(route, profileCode, codes, partKey) {
    if (!/^toyota-/.test(String(route || ''))) return null;
    if (!profileCode || !partKey || !Array.isArray(codes) || !codes.length) return null;
    var choices = PROFILE_CHOICES_BY_ROUTE[route] || [];
    var profileChoice = choices.filter(function (choice) { return choice.code === profileCode; })[0];
    if (!profileChoice || profileChoice.status === 'route_error' || profileChoice.status === 'year_validation_required') return null;
    if (profileChoice.status === 'split_required' && SELECTED_PROFILE_BY_ROUTE[route] !== profileCode) return null;

    var zones = TOYOTA_GLASS_PROFILE_ZONES[profileCode];
    var blueprint = TOYOTA_GLASS_PART_BLUEPRINTS[partKey];
    var assets = PROFILE_ASSETS[profileCode];
    if (!zones || !blueprint || !assets || assets.glass !== true || NON_PHYSICAL_MAP_KEYS[partKey]) return null;

    var matchedCode = '';
    for (var i = 0; i < codes.length && !matchedCode; i += 1) {
      var variants = codeVariants(codes[i]);
      if (variants.length) matchedCode = variants[0];
    }
    if (!matchedCode || codes.length !== 1 || !validSingleSku(matchedCode)) return null;

    var zoneName = blueprint.zone;
    /* Cab-over Hiace: the engine/air box sit under the front seats while the
     * radiator remains inside the short nose, so it needs its own anchor. */
    if (partKey === 'radiator' && zones.radiator_front) zoneName = 'radiator_front';
    if (partKey === 'wiper') {
      var sizeMatch = matchedCode.match(/(?:^|-)(\d{2})(?:$|[^0-9])/);
      var bladeSize = sizeMatch ? Number(sizeMatch[1]) : 0;
      zoneName = bladeSize && bladeSize < 22 ? 'windshield_passenger' : 'windshield_driver';
    }

    var baseAnchor = zones[zoneName];
    if (!baseAnchor || baseAnchor.length !== 2) return null;
    var frontIsRight = zones.engine_top && zones.rear_wheel
      ? zones.engine_top[0] > zones.rear_wheel[0]
      : true;
    var frontShift = blueprint.towardFront && zoneName !== 'radiator_front'
      ? blueprint.towardFront * (frontIsRight ? 1 : -1)
      : 0;
    var anchor = [
      clamp(Number(baseAnchor[0]) + (blueprint.dx || 0) + frontShift, 4, 96),
      clamp(Number(baseAnchor[1]) + (blueprint.dy || 0), 7, 93)
    ];
    var calloutAnchor = [
      clamp(anchor[0] + (anchor[0] > 55 ? -13 : 13), 10, 90),
      clamp(anchor[1] - 15, 10, 90)
    ];
    var part = PARTS[partKey];

    return {
      part: partKey,
      verified: false,
      mapped: true,
      confidence: 'profile-zone',
      profileCode: profileCode,
      scene: 'overview',
      anchor: anchor,
      calloutAnchor: calloutAnchor,
      focusRect: null,
      overlayRect: null,
      shape: '',
      scale: blueprint.scale || 2.5,
      note: 'الموقع يحدد منطقة تركيب ' + (part ? part.ar : partKey) +
        ' على شكل ' + profileCode + '. المؤشر منطقة معايرة لهذا الجيل وليس إثباتًا دقيقًا لمسمار التركيب؛ تحقق من VIN ورقم القطعة قبل الطلب.',
      code: matchedCode
    };
  }


  function routeLocationForCodes(route, profileCode, codes, partKey) {
    var routeMap = route && LOCATION_BY_ROUTE_AND_CODE[route];
    if (!Array.isArray(codes)) return null;
    for (var i = 0; i < codes.length; i += 1) {
      var variants = codeVariants(codes[i]);
      for (var j = 0; j < variants.length; j += 1) {
        var exact = routeMap && routeMap[variants[j]];
        if (!exact || exact.verified !== true) continue;
        var profileMatches = exact.profileCode
          ? exact.profileCode === profileCode
          : trustedLegacyLocationProfile(route, profileCode);
        if (!profileMatches) continue;
        return { exact: exact, code: variants[j] };
      }
    }
    var profileLocation = profileZoneLocation(route, profileCode, codes, partKey);
    return profileLocation ? { exact: profileLocation, code: profileLocation.code } : null;
  }

  function exactPartKeyForCard(card) {
    /* A title or card body can contain cross-reference numbers.  Only the
     * variant SKU is authoritative enough to activate a physical marker. */
    var codes = productCodesFromSku(card.getAttribute('data-sf-product-sku') || '');
    var match = routeLocationForCodes(
      state.profile && state.profile.route,
      state.profile && state.profile.code,
      codes
    );
    return match && match.exact && match.exact.verified ? match.exact.part : '';
  }

  function classifyCard(card) {
    var exactPart = exactPartKeyForCard(card);
    if (exactPart && PARTS[exactPart]) return exactPart;
    var storedPartKey = (card.getAttribute('data-sf-part-key') || '').trim();
    storedPartKey = PART_KEY_ALIASES[storedPartKey] || storedPartKey;
    var precisePartKey = sfPreciseOverridePartKey(card);
    if (precisePartKey && PARTS[precisePartKey]) return precisePartKey;
    if (storedPartKey && PARTS[storedPartKey]) return storedPartKey;
    var universalPartKey = sfUniversalMapPartKey(card);
    if (universalPartKey && PARTS[universalPartKey]) return universalPartKey;
    var raw = normalize(
      (card.getAttribute('data-sf-product-tags') || '') + ' ' +
      (card.getAttribute('data-sf-product-info') || '') + ' ' +
      (card.getAttribute('data-sf-product-title') || '')
    );
    var front = includesAny(raw, ['sf-position-front', 'front', 'امامي', 'الامامي']);
    var rear = includesAny(raw, ['sf-position-rear', 'rear', 'خلفي', 'الخلفي']);
    var left = includesAny(raw, ['sf-side-left', ' left', ' lh', 'يسار']);
    var right = includesAny(raw, ['sf-side-right', ' right', ' rh', 'يمين']);
    var upper = includesAny(raw, ['sf-level-upper', 'upper', 'علوي', 'العلوي', 'فوق']);
    var lower = includesAny(raw, ['sf-level-lower', 'lower', 'سفلي', 'السفلي', 'تحت']);

    if (includesAny(raw, ['sf-part-engine-mount', 'engine mount', 'motor mount', 'كرسي مكينه', 'كرسي مكينة', 'قاعده محرك', 'قاعده مكينه'])) {
      if (front) return 'engine_mount_front';
      if (rear) return 'engine_mount_rear';
      if (left) return 'engine_mount_left_upper';
      if (right) return 'engine_mount_right_upper';
      return '';
    }
    if (includesAny(raw, ['sf-part-cabin-air-filter', 'cabin air filter', 'cabin filter', 'فلتر مكيف', 'فلتر المكيف', 'فلتر هواء المكيف'])) return 'cabin_filter';
    if (includesAny(raw, ['sf-part-engine-air-filter', 'engine air filter', 'air filter', 'فلتر هواء المحرك', 'فلتر هوا'])) return 'engine_air_filter';
    if (includesAny(raw, ['sf-part-oil-filter', 'oil filter', 'فلتر زيت', 'سيفون زيت'])) return 'oil_filter';
    if (includesAny(raw, ['sf-part-transmission-filter', 'transmission filter', 'gearbox filter', 'فلتر جير', 'فلتر الجير', 'فلتر قير', 'فلتر القير', 'فلتر ناقل'])) return 'transmission_filter';
    if (includesAny(raw, ['sf-part-brake-pad', 'brake pad', 'سفايف', 'فحمات', 'بلاكات'])) {
      if (rear) return 'brake_rear';
      return front ? 'brake_front' : '';
    }
    if (includesAny(raw, ['sf-part-spark-plug', 'spark plug', 'بواجي', 'بلكات', 'شمعات احتراق'])) return 'spark_plug';
    if (includesAny(raw, ['sf-part-ignition-coil', 'ignition coil', 'كويل', 'كويلات'])) return 'ignition_coil';
    if (includesAny(raw, ['sf-part-knock-sensor', 'knock sensor', 'حساس نوك', 'نوك سنسر'])) return 'knock_sensor';
    if (includesAny(raw, ['sf-part-maf', 'mass air flow', 'maf sensor', 'حساس ماف', 'حساس كتله الهواء'])) return 'maf_sensor';
    if (includesAny(raw, ['sf-part-oxygen-sensor', 'oxygen sensor', 'o2 sensor', 'lambda sensor', 'air/fuel', 'air fuel', 'air-fuel', 'a/f sensor', 'حساس اكسجين', 'حساس الأكسجين', 'حساس شكمان', 'حساس نسبه الهواء والوقود', 'حساس هواء'])) {
      if (includesAny(raw, ['bank 1 sensor 1', 'bank1 sensor1', 'bank 1 s1', 'b1s1', 'بنك 1 حساس 1'])) return 'oxygen_b1s1';
      if (includesAny(raw, ['bank 2 sensor 1', 'bank2 sensor1', 'bank 2 s1', 'b2s1', 'بنك 2 حساس 1'])) return 'oxygen_b2s1';
      if (includesAny(raw, ['bank 1 sensor 2', 'bank1 sensor2', 'bank 1 s2', 'b1s2', 'بنك 1 حساس 2'])) return 'oxygen_b1s2';
      if (includesAny(raw, ['bank 2 sensor 2', 'bank2 sensor2', 'bank 2 s2', 'b2s2', 'بنك 2 حساس 2'])) return 'oxygen_b2s2';
      if (rear || lower || includesAny(raw, ['downstream', 'sensor 2', 'after catalyst', 'after catalytic', 'بعد المحفز', 'بعد الدبه'])) return 'oxygen_rear';
      if (left) return 'oxygen_front_left';
      if (right) return 'oxygen_front_right';
      return front ? 'oxygen_front' : '';
    }
    if (includesAny(raw, ['sf-part-ac-compressor-sensor', 'sf-part-compressor-valve', 'a/c compressor sensor', 'ac compressor sensor', 'compressor control valve', 'compressor valve', 'حساس كمبريسر', 'حساس كمبروسر', 'بلف كمبريسر', 'بلف كمبروسر', 'صمام كمبريسر', 'صمام كمبروسر'])) return 'compressor_valve';
    if (includesAny(raw, ['sf-part-ac-pressure-sensor', 'ac pressure sensor', 'a/c pressure sensor', 'حساس ضغط المكيف', 'حساس ضغط الفريون'])) return 'ac_pressure_sensor';
    if (includesAny(raw, ['sf-part-ac-evaporator', 'a/c evaporator', 'ac evaporator', 'air conditioner evaporator', 'مبخر المكيف', 'ثلاجه المكيف', 'ثلاجة المكيف'])) return 'ac_evaporator';
    if (includesAny(raw, ['sf-part-thermostat', 'thermostat', 'ثرموستات', 'بلف حراره'])) return 'thermostat';
    if (includesAny(raw, ['sf-part-vacuum-pump', 'vacuum pump', 'brake vacuum', 'مضخه فاكيوم', 'طرمبه فاكيوم'])) return 'brake_vacuum_pump';
    if (includesAny(raw, ['sf-part-fuel-pump', 'fuel pump', 'fuel sender', 'فيول بمب', 'طرمبه بنزين', 'طرمبة بنزين', 'مضخه وقود', 'مضخة وقود'])) return 'fuel_pump';
    if (includesAny(raw, ['sf-part-belt-tensioner', 'belt tensioner', 'drive belt tensioner', 'شداد سير', 'شداد السير', 'شداد مكينه', 'شداد مكينة'])) return 'belt_tensioner';
    if (includesAny(raw, ['sf-part-idler-pulley', 'idler pulley', 'drive belt pulley', 'belt pulley', 'بكره سير', 'بكرة سير', 'رمانه سير', 'رمانة سير', 'ميرانيه السير', 'ميرانية السير'])) return 'idler_pulley';
    if (includesAny(raw, ['sf-part-tie-rod', 'tie rod', 'rack end', 'steering rod', 'تي رود', 'رود دركسون', 'راس رود', 'رأس رود'])) return 'steering_tie_rod';
    if (includesAny(raw, ['sf-part-shock-absorber', 'shock absorber', 'suspension strut', 'مساعدات', 'مساعد امامي', 'مساعد أمامي', 'مساعد خلفي'])) {
      if (rear) return 'shock_absorber_rear';
      return front ? 'shock_absorber_front' : '';
    }
    if (includesAny(raw, ['sf-part-drive-belt', 'sf-part-engine-belt', 'serpentine belt', 'drive belt', 'fan belt', 'سير مكينه', 'سير محرك', 'سيور المحرك', 'سير خارجي'])) return 'drive_belt';
    if (includesAny(raw, ['sf-part-wiper', 'wiper', 'مساحه', 'مساحات'])) return 'wiper';
    if (includesAny(raw, ['sf-part-radiator-hose', 'radiator hose', 'هوز راديتر', 'خرطوم راديتر'])) {
      if (lower) return 'radiator_hose_lower';
      return upper ? 'radiator_hose_upper' : '';
    }
    if (includesAny(raw, ['sf-part-radiator', 'radiator', 'راديتر'])) return 'radiator';
    if (includesAny(raw, ['sf-part-water-pump', 'water pump', 'مضخه ماء', 'طرمبه ماء', 'واتر بمب'])) return 'water_pump';
    if (includesAny(raw, ['sf-main-ac', 'ac kit', 'a/c kit', 'طقم مكيف', 'طقم تكييف', 'كمبروسر مكيف', 'كمبريسر مكيف'])) return 'ac_system';
    return '';
  }

  function isPhysicalMapProduct(card, key) {
    if (!card || !key || NON_PHYSICAL_MAP_KEYS[key]) return false;
    var raw = normalize(
      (card.getAttribute('data-sf-product-tags') || '') + ' ' +
      (card.getAttribute('data-sf-product-info') || '') + ' ' +
      (card.getAttribute('data-sf-product-title') || '')
    );
    /* Department/service tags win over a misleading part tag. This prevents
     * an oil bottle or maintenance bundle from leaking into the parts map. */
    if (includesAny(raw, [
      'sf-department-oils', 'sf-main-oils', 'sf-department-services', 'sf-main-services',
      'زيوت وسوائل', 'قسم الزيوت', 'قسم: زيوت', 'قسم الخدمات', 'قسم: خدمات',
      'oil service', 'maintenance service', 'خدمه زيت', 'باقة صيانه', 'باقه صيانه'
    ])) return false;
    /* Filters are physical spare parts even though their English names can
     * contain the otherwise-fluid phrase "engine oil". */
    if (key === 'oil_filter' || key === 'transmission_filter') return true;
    return !includesAny(raw, [
      'engine oil', 'motor oil', 'transmission fluid', 'atf ', 'gear oil', 'brake fluid',
      'power steering fluid', 'coolant', 'radiator coolant', 'oil treatment', 'fuel additive',
      'technical lubricant', 'copper paste', 'lubricant spray',
      'زيت محرك', 'زيوت محركات', 'زيت قير', 'زيت جير', 'زيت ناقل الحركه', 'سائل فرامل',
      'سائل تبريد', 'ماء راديتر', 'اضافه زيت',
      'معجون نحاس', 'بخاخ نحاس', 'شحم نحاس'
    ]);
  }

  function pointsFor(key) {
    var part = PARTS[key];
    if (!part) return [];
    if (part.dynamic === 'cylinders' || part.dynamic === 'cylinders_low') {
      var z = part.dynamic === 'cylinders_low' ? 0.67 : 0.76;
      var points = [];
      if (state.profile.cylinders === 8) {
        [-0.36, -0.12, 0.12, 0.36].forEach(function (x) {
          points.push([x, 0.97, z]);
          points.push([x, 1.31, z]);
        });
      } else if (state.profile.cylinders === 6) {
        [-0.26, 0, 0.26].forEach(function (x) {
          points.push([x, 0.97, z]);
          points.push([x, 1.31, z]);
        });
      } else {
        [-0.36, -0.12, 0.12, 0.36].forEach(function (x) {
          points.push([x, 1.14, z]);
        });
      }
      return points;
    }
    return part.points.map(function (point) { return point.slice(); });
  }

  function injectLaunch() {
    var entry = document.querySelector('[data-sf-vehicle-map-entry]');
    var nav = document.querySelector('#senfinecoYmmCategories');
    var actions = nav && nav.querySelector('.sf-ymm-nav__vehicle-actions');
    var host = entry || actions;
    if (!host) return;

    var standalone = host === entry;
    var button = document.querySelector('[data-sf-camry-map-open]');
    if (!button) button = document.createElement('button');
    button.type = 'button';
    button.className = 'sf-camry-map-launch' + (standalone ? ' sf-camry-map-launch--entry' : '');
    button.setAttribute('data-sf-camry-map-open', '');
    if (button.getAttribute('data-sf-map-launch-layout') !== (standalone ? 'entry' : 'compact')) {
      button.setAttribute('data-sf-map-launch-layout', standalone ? 'entry' : 'compact');
      button.innerHTML = standalone
        ? '<span class="sf-camry-map-launch__preview" aria-hidden="true"><img alt="" data-sf-map-preview></span>' +
          '<span class="sf-camry-map-launch__copy">' +
            '<span class="sf-camry-map-launch__eyebrow">خارطة سيارتك</span>' +
            '<span class="sf-camry-map-launch__title">اكتشف موقع القطعة</span>' +
            '<span class="sf-camry-map-launch__vehicle" data-sf-map-vehicle></span>' +
            '<span class="sf-camry-map-launch__note">تظهر المواقع المطابقة فقط</span>' +
          '</span>' +
          '<span class="sf-camry-map-launch__arrow" aria-hidden="true">‹</span>'
        : '<span class="sf-camry-map-launch__icon" aria-hidden="true">⌖</span>' +
          '<span class="sf-camry-map-launch__copy">' +
            '<span class="sf-camry-map-launch__title">الخريطة التفاعلية لقطع السيارة</span>' +
            '<span class="sf-camry-map-launch__note">صورة السيارة وتوزيع القطع المتوافقة</span>' +
          '</span>' +
          '<span class="sf-camry-map-launch__arrow" aria-hidden="true">‹</span>';
    }
    if (button.parentElement !== host) host.appendChild(button);
    state.launchButton = button;

    if (standalone) {
      var preview = button.querySelector('[data-sf-map-preview]');
      var vehicle = button.querySelector('[data-sf-map-vehicle]');
      var asset = state.profile && state.profile.assets && state.profile.assets.overview;
      if (vehicle) vehicle.textContent = vehicleText() + (state.profile.profileLabel ? ' · ' + state.profile.profileLabel : '');
      if (!preview || !asset) {
        host.hidden = true;
        return;
      }
      preview.alt = vehicle ? vehicle.textContent : vehicleText();
      preview.onload = function () {
        if (state.profile && state.profile.assets && state.profile.assets.overview === preview.getAttribute('src')) host.hidden = false;
      };
      preview.onerror = function () {
        host.hidden = true;
        preview.removeAttribute('src');
      };
      if (preview.getAttribute('src') !== asset) {
        host.hidden = true;
        preview.setAttribute('src', asset);
      } else if (preview.complete && preview.naturalWidth) {
        host.hidden = false;
      }
    } else {
      host.hidden = false;
    }
    updateLaunchNote();
  }

  function clearLaunchControls() {
    document.querySelectorAll('[data-sf-camry-map-open]').forEach(function (button) { button.remove(); });
    var entry = document.querySelector('[data-sf-vehicle-map-entry]');
    if (entry) {
      entry.replaceChildren();
      entry.hidden = true;
    }
    state.launchButton = null;
  }

  function updateLaunchNote() {
    if (!state.launchButton) return;
    var note = state.launchButton.querySelector('.sf-camry-map-launch__note');
    if (!note) return;
    var productCount = usesDirectProductRows() ? pilotProducts().length : 0;
    if (!usesDirectProductRows()) state.available.forEach(function (cards) { productCount += cards.length; });
    var exactOnly = state.profile && requiresExactLocation(state.profile.route);
    note.textContent = productCount
      ? 'اختر من ' + productCount + ' منتج؛ ' + (exactOnly ? 'تظهر المواقع المطابقة فقط' : 'تظهر المنطقة العامة أو الموقع الموثّق')
      : (exactOnly ? 'نموذج زجاجي؛ تظهر المواقع المطابقة فقط' : 'صورة السيارة وتوزيع القطع المتوافقة');
  }

  function normalizeProductSku(value) {
    return String(value || '')
      .toUpperCase()
      .trim()
      .replace(/\s*-\s*/g, '-')
      .replace(/\s*\/\s*/g, '/');
  }

  function validSingleSku(value) {
    var sku = normalizeProductSku(value);
    if (!sku || /^(?:N\/?A|NA|NONE|NO-SKU|-|0)$/.test(sku)) return false;
    if (/[\s,|]/.test(sku)) return false;
    var items = sku.split('/');
    if (items.length > 2) return false;
    return items.every(function (item) {
      return /^(?=.{4,}$)(?=.*\d)[A-Z0-9]+(?:-[A-Z0-9]+)*$/.test(item);
    });
  }

  function productCodesFromSku(value) {
    var sku = normalizeProductSku(value);
    return validSingleSku(sku) ? [sku] : [];
  }

  function productFromCard(card) {
    var productImage = card.querySelector('product-card img, [data-sf-parts-card] img, img');
    var productLink = card.querySelector('a[href*="/products/"]');
    var price = card.querySelector('.price, price-list, [data-product-price]');
    var title = card.getAttribute('data-sf-product-title') || card.getAttribute('data-sf-product-info') || '';
    var url = card.getAttribute('data-sf-product-url') || (productLink ? productLink.getAttribute('href') : '');
    var image = card.getAttribute('data-sf-product-image') || '';
    if (!image && productImage) image = productImage.currentSrc || productImage.getAttribute('src') || '';
    var id = card.getAttribute('data-sf-product-id') || '';
    if (!id) id = url || normalize(title).replace(/\s+/g, '-');
    var variantId = (card.getAttribute('data-sf-product-variant-id') || '').trim();
    var available = card.getAttribute('data-sf-product-available') !== 'false';
    var defaultVariant = card.getAttribute('data-sf-product-default-variant') !== 'false';
    var cartForm = card.querySelector('form[data-sf-grid-cart], .sf-parts-card__cart-form, .sf-grid-cart-form');
    var sku = normalizeProductSku(card.getAttribute('data-sf-product-sku') || '');
    var codes = productCodesFromSku(sku);
    return {
      id: String(id),
      title: title.trim(),
      url: url,
      image: image,
      price: (card.getAttribute('data-sf-product-price') || (price ? price.textContent : '') || '').trim(),
      sku: sku,
      codes: codes,
      variantId: variantId,
      available: available,
      defaultVariant: defaultVariant,
      cartForm: cartForm,
      card: card
    };
  }

  function productById(productId) {
    var found = null;
    state.available.forEach(function (products) {
      if (found) return;
      for (var i = 0; i < products.length; i += 1) {
        if (products[i].id === String(productId)) {
          found = products[i];
          break;
        }
      }
    });
    return found;
  }

  function cartButtonFor(product, className) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className + ' sf-camry-map__cart-button';
    /* A product-card form is preferred because it preserves the theme cart
     * drawer. A same-origin Ajax fallback below keeps every available
     * single-variant product addable when a card template has no form. */
    var canAdd = Boolean(product && product.available && product.defaultVariant && product.variantId);
    if (canAdd) {
      button.setAttribute('data-action', 'add-to-cart');
      button.setAttribute('data-product-id', product.id);
      button.setAttribute('aria-label', 'أضف إلى السلة: ' + (product.title || product.sku || 'المنتج'));
      button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.1 10.1a2 2 0 0 0 2 1.6h7.8a2 2 0 0 0 1.9-1.4L21 7H7"></path><circle cx="10" cy="20" r="1.4"></circle><circle cx="18" cy="20" r="1.4"></circle></svg><span>أضف للسلة</span>';
    } else {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.textContent = product && !product.available ? 'غير متوفر' : 'اختر الخيارات';
    }
    return button;
  }

  function cartEndpoint(file) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/?$/, '/') + file;
  }

  function dispatchCartUpdate(cartData, product) {
    var detail = {
      source: 'senfineco-parts-map',
      cart: cartData,
      productVariantId: product.variantId
    };
    if (typeof window.CustomEvent === 'function') {
      ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (name) {
        document.dispatchEvent(new window.CustomEvent(name, { detail: detail, bubbles: true }));
      });
    }
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: detail.source,
        productVariantId: product.variantId,
        cartData: cartData
      });
    }
  }

  function showCartAddError(mapButton, message) {
    if (mapButton) {
      mapButton.disabled = false;
      mapButton.classList.remove('is-loading');
      mapButton.setAttribute('title', message || 'تعذرت الإضافة إلى السلة');
    }
    if (state.statusNote) state.statusNote.textContent = message || 'تعذرت الإضافة إلى السلة. حاول مرة أخرى.';
  }

  function addProductToCartAjax(product, mapButton) {
    if (typeof window.fetch !== 'function') {
      showCartAddError(mapButton);
      return;
    }
    window.fetch(cartEndpoint('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(product.variantId), quantity: 1 }] })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'تعذرت الإضافة إلى السلة');
        return data;
      });
    }).then(function (addedData) {
      closeModal();
      return window.fetch(cartEndpoint('cart.js'), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('cart-refresh');
        return response.json();
      }).then(function (cartData) {
        dispatchCartUpdate(cartData, product);
      }).catch(function () {
        /* The item was already added; the add response is still enough for
         * themes that refresh their cart after receiving an update event. */
        dispatchCartUpdate(addedData, product);
      });
    }).catch(function (error) {
      showCartAddError(mapButton, error && error.message);
    });
  }

  function addProductToCart(productId, mapButton) {
    var product = productById(productId);
    if (!product || !product.available || !product.defaultVariant || !product.variantId) return;
    if (mapButton) {
      mapButton.disabled = true;
      mapButton.classList.add('is-loading');
    }
    var form = product.cartForm;
    var idInput = form && form.querySelector('input[name="id"]');
    var quantityInput = form && form.querySelector('input[name="quantity"]');
    var submit = form && form.querySelector('button[type="submit"]:not(:disabled), input[type="submit"]:not(:disabled)');
    if (form && idInput && submit) {
      idInput.value = product.variantId;
      idInput.setAttribute('value', product.variantId);
      if (quantityInput) {
        quantityInput.value = '1';
        quantityInput.setAttribute('value', '1');
      }
      closeModal();
      window.requestAnimationFrame(function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submit);
        else submit.click();
      });
      return;
    }
    addProductToCartAjax(product, mapButton);
  }

  function pilotProductAllowed(product) {
    if (!product) return false;
    /* The deny-list only belongs to the original XV50 pilot.  XV70 has its
     * own exact/VIN-aware records below and must keep every physical part. */
    if (!state.profile || state.profile.route !== PILOT_ROUTE) return true;
    var codes = product.codes && product.codes.length ? product.codes : [product.sku];
    for (var i = 0; i < codes.length; i += 1) {
      var variants = codeVariants(codes[i]);
      for (var j = 0; j < variants.length; j += 1) {
        if (PILOT_HIDDEN_CODES[variants[j]]) return false;
      }
    }
    return true;
  }

  function pilotProducts() {
    var order = {
      compressor_valve: 1,
      oxygen_front: 2,
      oxygen_rear: 3,
      maf_sensor: 4,
      knock_sensor: 5,
      ignition_coil: 6,
      spark_plug: 7,
      drive_belt: 8,
      engine_air_filter: 9,
      cabin_filter: 10,
      oil_filter: 11,
      thermostat: 12,
      brake_vacuum_pump: 13,
      brake_front: 14,
      brake_rear: 15,
      wiper: 16,
      transmission_filter: 17,
      ac_evaporator: 18,
      oxygen_front_left: 19,
      oxygen_front_right: 20
    };
    var rows = [];
    state.available.forEach(function (products, key) {
      products.forEach(function (product) {
        if (pilotProductAllowed(product)) rows.push({ key: key, product: product });
      });
    });
    return rows.sort(function (a, b) {
      var byPart = (order[a.key] || 99) - (order[b.key] || 99);
      if (byPart) return byPart;
      return String(a.product.sku || a.product.title).localeCompare(String(b.product.sku || b.product.title));
    });
  }

  function injectCardButton(card, key, product) {
    var productCard = card.querySelector('product-card') || card.querySelector('[data-sf-parts-card]') || card;
    var buyRow = card.querySelector('.sf-card-buy-row, .sf-parts-card__buy-row');
    var host = buyRow || productCard;
    productCard.classList.add('sf-camry-map-card');
    if (buyRow) buyRow.classList.add('sf-card-buy-row--map');
    var old = card.querySelector('[data-sf-camry-locate]');
    if (old) {
      old.setAttribute('data-part-key', key);
      old.setAttribute('data-product-id', product.id);
      if (old.parentElement !== host) host.appendChild(old);
      return;
    }
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'sf-camry-locate-button';
    button.setAttribute('data-sf-camry-locate', '');
    button.setAttribute('data-part-key', key);
    button.setAttribute('data-product-id', product.id);
    button.innerHTML = '<span aria-hidden="true">⌖</span><span>موقع القطعة</span>';
    host.appendChild(button);
  }

  function clearCardMapControl(card) {
    if (!card) return;
    var button = card.querySelector('[data-sf-camry-locate]');
    if (button) button.remove();
    var productCard = card.querySelector('.sf-camry-map-card');
    if (productCard) productCard.classList.remove('sf-camry-map-card');
    var buyRow = card.querySelector('.sf-card-buy-row--map');
    if (buyRow) buyRow.classList.remove('sf-card-buy-row--map');
  }

  function scanCards() {
    var available = new Map();
    document.querySelectorAll(CARD_SELECTOR).forEach(function (card) {
      var key = classifyCard(card);
      if (!key || !PARTS[key] || !isPhysicalMapProduct(card, key)) {
        clearCardMapControl(card);
        return;
      }
      var product = productFromCard(card);
      var locationMatch = routeLocationForCodes(
        state.profile && state.profile.route,
        state.profile && state.profile.code,
        product.codes,
        key
      );
      var mapped = locationMatch && locationMatch.exact && locationMatch.exact.part === key &&
        (locationMatch.exact.verified === true ||
          (locationMatch.exact.mapped === true && locationMatch.exact.confidence === 'profile-zone'));
      if (state.profile && requiresExactLocation(state.profile.route) && !mapped) {
        clearCardMapControl(card);
        return;
      }
      if (!available.has(key)) available.set(key, []);
      available.get(key).push(product);
      injectCardButton(card, key, product);
    });
    state.available = available;
    updateLaunchNote();
    if (state.modal) renderParts();
  }

  function clearCardMapControls() {
    document.querySelectorAll(CARD_SELECTOR).forEach(clearCardMapControl);
    state.available = new Map();
    if (state.modal) renderParts();
  }

  function resetForVehicleRouteChange() {
    state.selected = [];
    state.activeKey = '';
    state.activeProductId = '';
    state.activeLocation = null;
    state.sceneView = null;
    state.sceneZoom = 1;
    state.scenePanX = 0;
    state.scenePanY = 0;
    state.realReady = false;
    cancelAnimationFrame(state.tweenFrame);
    if (state.sceneCallout) state.sceneCallout.hidden = true;
    if (state.sceneInstalled) {
      state.sceneInstalled.setAttribute('hidden', '');
      state.sceneInstalled.replaceChildren();
    }
    if (state.beltOverlay) {
      state.beltOverlay.setAttribute('hidden', '');
      state.beltOverlay.replaceChildren();
    }
    if (state.markers) {
      state.markers.hidden = true;
      state.markers.replaceChildren();
    }
    if (state.realScene) {
      state.realScene.hidden = true;
      state.realScene.classList.remove('is-ready');
    }
    if (state.scenePending) state.scenePending.hidden = true;
    if (state.sceneImage) {
      state.sceneImage.removeAttribute('src');
      state.sceneImage.alt = '';
    }
    if (state.canvas) state.canvas.hidden = true;
  }

  function sync() {
    if (!isYmmPage()) {
      clearLaunchControls();
      clearCardMapControls();
      state.profile = null;
      return;
    }
    var nextProfile = profileFromPage();
    var routeChanged = Boolean(state.profile && state.profile.route && nextProfile.route && state.profile.route !== nextProfile.route);
    if (routeChanged) {
      if (state.modal && (state.modal.open || state.modal.hasAttribute('open'))) closeModal();
      resetForVehicleRouteChange();
    }
    state.profile = nextProfile;
    var hasRealVehicleProfile = Boolean(
      nextProfile.choices.length &&
      nextProfile.assets &&
      nextProfile.assets.glass === true &&
      nextProfile.assets.overview
    );
    if (!nextProfile.route || !hasRealVehicleProfile) {
      if (state.modal && (state.modal.open || state.modal.hasAttribute('open'))) closeModal();
      clearLaunchControls();
      clearCardMapControls();
      return;
    }
    scanCards();
    injectLaunch();
  }

  function buildModal() {
    if (state.modal) return;
    var dialog = document.createElement('dialog');
    dialog.className = 'sf-camry-map';
    dialog.setAttribute('aria-labelledby', 'sfCamryMapTitle');
    dialog.innerHTML =
      '<div class="sf-camry-map__shell">' +
        '<header class="sf-camry-map__header">' +
          '<button class="sf-camry-map__close" type="button" data-action="close" aria-label="إغلاق الخريطة">×</button>' +
          '<div class="sf-camry-map__heading">' +
            '<span class="sf-camry-map__eyebrow">مشهد واقعي تفاعلي</span>' +
            '<h2 class="sf-camry-map__title" id="sfCamryMapTitle">مواقع قطع السيارة</h2>' +
            '<div class="sf-camry-map__vehicle" data-role="vehicle"></div>' +
            '<div class="sf-camry-map__generations" data-role="generations" hidden></div>' +
          '</div>' +
        '</header>' +
        '<div class="sf-camry-map__main">' +
          '<div class="sf-camry-map__visual" data-role="visual">' +
            '<div class="sf-camry-map__stage" data-role="stage">' +
              '<div class="sf-camry-map__real-scene" data-role="real-scene" hidden>' +
                '<div class="sf-camry-map__scene-camera" data-role="scene-camera">' +
                  '<img class="sf-camry-map__scene-image" data-role="scene-image" alt="" decoding="async">' +
                  '<svg class="sf-camry-map__belt" data-role="belt" viewBox="0 0 280 290" aria-hidden="true" hidden></svg>' +
                  '<svg class="sf-camry-map__installed-part" data-role="installed-part" viewBox="0 0 100 100" aria-hidden="true" hidden></svg>' +
                '</div>' +
                '<button class="sf-camry-map__callout" data-role="callout" type="button" data-action="focus-active" hidden>' +
                  '<span class="sf-camry-map__callout-pin" aria-hidden="true"></span>' +
                  '<img data-role="callout-image" alt="" loading="eager" decoding="async">' +
                  '<span class="sf-camry-map__callout-copy"><span data-role="callout-name"></span><small data-role="callout-confidence"></small></span>' +
                '</button>' +
              '</div>' +
              '<div class="sf-camry-map__scene-pending" data-role="scene-pending" hidden>' +
                '<strong>شكل هذه السيارة قيد التوثيق</strong>' +
                '<span>ستبقى المنتجات ظاهرة، ولن نعرض سيارة عامة أو موقع قطعة تخميني.</span>' +
              '</div>' +
              '<canvas class="sf-camry-map__canvas" data-role="canvas" aria-label="رسم توضيحي احتياطي لمواقع قطع السيارة"></canvas>' +
              '<div class="sf-camry-map__markers" data-role="markers"></div>' +
              '<div class="sf-camry-map__orientation"><strong data-role="direction">↑ مقدمة السيارة</strong><span>يسار السيارة = جهة السائق</span></div>' +
              '<div class="sf-camry-map__toolbar">' +
                '<button class="sf-camry-map__toolbar-button" type="button" data-action="zoom-in" aria-label="تكبير">＋</button>' +
                '<button class="sf-camry-map__toolbar-button" type="button" data-action="zoom-out" aria-label="تصغير">−</button>' +
                '<button class="sf-camry-map__toolbar-button" type="button" data-action="reset" aria-label="إعادة توجيه الكاميرا">↺</button>' +
              '</div>' +
              '<div class="sf-camry-map__hint"><span>اسحب لتحريك المشهد · قرّب بإصبعين</span></div>' +
              '<a class="sf-camry-map__credit" data-role="credit" target="_blank" rel="noopener noreferrer" hidden>مصدر صورة السيارة والترخيص</a>' +
            '</div>' +
            '<section class="sf-camry-map__gallery" data-role="gallery" aria-labelledby="sfCamryGalleryTitle" hidden>' +
              '<div class="sf-camry-map__gallery-head"><h3 id="sfCamryGalleryTitle" data-role="gallery-title">المنتجات المتوفرة</h3><span>صور المنتجات الحقيقية</span></div>' +
              '<div class="sf-camry-map__gallery-list" data-role="gallery-list"></div>' +
            '</section>' +
          '</div>' +
          '<aside class="sf-camry-map__panel">' +
            '<div class="sf-camry-map__panel-scroll">' +
              '<h3 data-role="panel-title">اختر القطعة</h3>' +
              '<p class="sf-camry-map__panel-intro" data-role="panel-intro">اختر قطعة واحدة؛ تتجه الكاميرا للمنطقة المناسبة، وتظهر العلامة عند توثيق الكود.</p>' +
              '<label class="sf-camry-map__search"><span class="visually-hidden">ابحث عن قطعة</span><input type="search" data-role="search" placeholder="مثال: فلتر هواء أو بواجي"></label>' +
              '<div class="sf-camry-map__parts" data-role="parts"></div>' +
              '<div class="sf-camry-map__selection">' +
                '<div class="sf-camry-map__selection-head"><span class="sf-camry-map__selection-title">القطعة المحددة</span><button class="sf-camry-map__clear" type="button" data-action="clear" hidden>إلغاء</button></div>' +
                '<div class="sf-camry-map__selected" data-role="selected"></div>' +
              '</div>' +
            '</div>' +
            '<div class="sf-camry-map__status">' +
              '<div class="sf-camry-map__status-card" role="status" aria-live="polite" aria-atomic="true">' +
                '<strong class="sf-camry-map__status-title" data-role="status-title">اختر قطعة لعرضها</strong>' +
                '<span class="sf-camry-map__status-note" data-role="status-note">لا تظهر علامة التركيب إلا بعد مطابقة كود القطعة مع خريطة موثّقة للمحرك.</span>' +
              '</div>' +
            '</div>' +
          '</aside>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dialog);

    state.modal = dialog;
    state.visual = dialog.querySelector('[data-role="visual"]');
    state.canvas = dialog.querySelector('[data-role="canvas"]');
    state.context = state.canvas.getContext('2d');
    state.realScene = dialog.querySelector('[data-role="real-scene"]');
    state.sceneCamera = dialog.querySelector('[data-role="scene-camera"]');
    state.sceneImage = dialog.querySelector('[data-role="scene-image"]');
    state.sceneCallout = dialog.querySelector('[data-role="callout"]');
    state.sceneCalloutImage = dialog.querySelector('[data-role="callout-image"]');
    state.sceneCalloutName = dialog.querySelector('[data-role="callout-name"]');
    state.sceneConfidence = dialog.querySelector('[data-role="callout-confidence"]');
    state.sceneInstalled = dialog.querySelector('[data-role="installed-part"]');
    state.scenePending = dialog.querySelector('[data-role="scene-pending"]');
    state.beltOverlay = dialog.querySelector('[data-role="belt"]');
    state.stage = dialog.querySelector('[data-role="stage"]');
    state.gallery = dialog.querySelector('[data-role="gallery"]');
    state.galleryList = dialog.querySelector('[data-role="gallery-list"]');
    state.galleryTitle = dialog.querySelector('[data-role="gallery-title"]');
    state.markers = dialog.querySelector('[data-role="markers"]');
    state.partsList = dialog.querySelector('[data-role="parts"]');
    state.selectedList = dialog.querySelector('[data-role="selected"]');
    state.search = dialog.querySelector('[data-role="search"]');
    state.statusTitle = dialog.querySelector('[data-role="status-title"]');
    state.statusNote = dialog.querySelector('[data-role="status-note"]');
    state.vehicleLabel = dialog.querySelector('[data-role="vehicle"]');
    state.generationList = dialog.querySelector('[data-role="generations"]');
    state.creditLink = dialog.querySelector('[data-role="credit"]');

    bindModalEvents();
    if ('ResizeObserver' in window) {
      state.resizeObserver = new ResizeObserver(function () {
        resizeCanvas();
        window.requestAnimationFrame(applySceneTransform);
      });
      state.resizeObserver.observe(state.stage);
    } else {
      window.addEventListener('resize', resizeCanvas);
    }
  }

  function bindModalEvents() {
    state.modal.addEventListener('click', function (event) {
      var action = event.target.closest('[data-action]');
      if (action) {
        var type = action.getAttribute('data-action');
        if (type === 'close') closeModal();
        else if (type === 'reset') {
          if (state.realReady) focusRealScene(state.activeKey || '');
          else animateCamera(cameraPreset('overview'));
        }
        else if (type === 'zoom-in') {
          if (state.realReady) setSceneZoom(state.sceneZoom * 1.18);
          else setZoom(state.camera.zoom * 1.18);
        }
        else if (type === 'zoom-out') {
          if (state.realReady) setSceneZoom(state.sceneZoom / 1.18);
          else setZoom(state.camera.zoom / 1.18);
        }
        else if (type === 'add-to-cart') addProductToCart(action.getAttribute('data-product-id'), action);
        else if (type === 'clear') clearSelection();
        else if (type === 'focus-active' && state.activeKey) focusPart(state.activeKey);
        return;
      }
      var generationChoice = event.target.closest('[data-profile-code]');
      if (generationChoice) {
        event.preventDefault();
        chooseGeneration(generationChoice.getAttribute('data-profile-code'));
        return;
      }
      var productChoice = event.target.closest('[data-scene-product-id]');
      if (productChoice) {
        event.preventDefault();
        chooseProduct(productChoice.getAttribute('data-scene-product-id'));
        return;
      }
      var pilotChoice = event.target.closest('[data-pilot-product]');
      if (pilotChoice) {
        event.preventDefault();
        selectPilotProduct(pilotChoice.getAttribute('data-part-key'), pilotChoice.getAttribute('data-product-id'));
        return;
      }
      var partButton = event.target.closest('[data-map-part]');
      if (partButton) togglePart(partButton.getAttribute('data-map-part'));
      var removeButton = event.target.closest('[data-remove-part]');
      if (removeButton) removePart(removeButton.getAttribute('data-remove-part'));
      var focusButton = event.target.closest('[data-focus-part]');
      if (focusButton) focusPart(focusButton.getAttribute('data-focus-part'));
    });

    state.modal.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeModal();
    });
    state.search.addEventListener('input', renderParts);

    state.sceneImage.addEventListener('load', function () {
      state.realReady = true;
      state.realScene.hidden = false;
      state.realScene.classList.add('is-ready');
      if (state.scenePending) state.scenePending.hidden = true;
      state.canvas.hidden = true;
      state.markers.hidden = true;
      applySceneTransform();
    });
    state.sceneImage.addEventListener('error', function () {
      state.realReady = false;
      state.realScene.hidden = true;
      state.realScene.classList.remove('is-ready');
      if (state.scenePending) state.scenePending.hidden = false;
      state.canvas.hidden = true;
      state.markers.hidden = true;
    });
    state.sceneCalloutImage.addEventListener('error', function () {
      state.sceneCalloutImage.hidden = true;
      state.sceneCallout.classList.add('has-no-image');
    });

    var stage = state.modal.querySelector('[data-role="stage"]');
    stage.addEventListener('pointerdown', onPointerDown);
    stage.addEventListener('pointermove', onPointerMove);
    stage.addEventListener('pointerup', onPointerUp);
    stage.addEventListener('pointercancel', onPointerUp);
    stage.addEventListener('wheel', onWheel, { passive: false });
  }

  function onPointerDown(event) {
    if (event.target.closest('button')) return;
    state.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    event.currentTarget.setPointerCapture(event.pointerId);
    if (state.pointers.size === 1) {
      state.dragging = true;
      state.pointerStart = {
        x: event.clientX,
        y: event.clientY,
        yaw: state.camera.yaw,
        pitch: state.camera.pitch,
        panX: state.scenePanX,
        panY: state.scenePanY,
        real: state.realReady
      };
    } else if (state.pointers.size === 2) {
      state.pinchDistance = pointerDistance();
      state.pointerStart = null;
    }
  }

  function onPointerMove(event) {
    if (!state.pointers.has(event.pointerId)) return;
    state.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (state.pointers.size === 2) {
      var distance = pointerDistance();
      if (state.pinchDistance) {
        if (state.realReady) setSceneZoom(state.sceneZoom * (distance / state.pinchDistance), false);
        else setZoom(state.camera.zoom * (distance / state.pinchDistance), false);
      }
      state.pinchDistance = distance;
      return;
    }
    if (!state.dragging || !state.pointerStart) return;
    if (state.pointerStart.real && state.realReady) {
      state.scenePanX = clamp(state.pointerStart.panX + event.clientX - state.pointerStart.x, -140, 140);
      state.scenePanY = clamp(state.pointerStart.panY + event.clientY - state.pointerStart.y, -110, 110);
      applySceneTransform();
      return;
    }
    state.camera.yaw = state.pointerStart.yaw + (event.clientX - state.pointerStart.x) * 0.008;
    state.camera.pitch = clamp(state.pointerStart.pitch - (event.clientY - state.pointerStart.y) * 0.006, 0.18, 0.94);
    cancelAnimationFrame(state.tweenFrame);
    renderScene();
  }

  function onPointerUp(event) {
    state.pointers.delete(event.pointerId);
    if (state.pointers.size < 2) state.pinchDistance = 0;
    if (state.pointers.size === 0) {
      state.dragging = false;
      state.pointerStart = null;
    }
  }

  function pointerDistance() {
    var values = Array.from(state.pointers.values());
    if (values.length < 2) return 0;
    return Math.hypot(values[0].x - values[1].x, values[0].y - values[1].y);
  }

  function onWheel(event) {
    event.preventDefault();
    if (state.realReady) setSceneZoom(state.sceneZoom * (event.deltaY > 0 ? 0.9 : 1.1));
    else setZoom(state.camera.zoom * (event.deltaY > 0 ? 0.9 : 1.1));
  }

  function setSceneZoom(value) {
    state.sceneZoom = clamp(value, .72, 3.6);
    applySceneTransform();
  }

  function setZoom(value, animate) {
    var zoom = clamp(value, 0.62, 2.35);
    if (animate === false) {
      state.camera.zoom = zoom;
      renderScene();
      return;
    }
    var target = copyCamera(state.camera);
    target.zoom = zoom;
    animateCamera(target);
  }

  function sceneAssetFor(view, allowOverviewFallback) {
    var assets = state.profile && state.profile.assets;
    if (!assets) return '';
    if (assets[view.scene]) return assets[view.scene];
    return allowOverviewFallback ? (assets.overview || '') : '';
  }

  function directionLabel(zone, scene, key) {
    if (key === 'compressor_valve') return '↗ كمبريسر — الرفرف الأمامي الأيمن';
    if (key === 'cabin_filter') return '↘ جهة الراكب — خلف درج الراكب';
    if (key === 'oxygen_front') return '↗ قبل المحفّز — حساس المقدمة';
    if (key === 'oxygen_rear') return '↓ بعد المحفّز — أسفل السيارة';
    if (scene === 'engine') return '↗ حجرة محرك 2.5L';
    if (scene === 'side') return '↔ جانب السيارة';
    if (scene === 'rear') return '↓ خلف السيارة';
    if (scene === 'underbody') return '↓ أسفل السيارة';
    if (zone === 'engine' || zone === 'engine_low') return '↗ حجرة المحرك';
    if (zone === 'cabin') return '↘ داخل المقصورة';
    if (zone === 'underbody') return '↓ أسفل السيارة';
    if (zone === 'front_wheels') return '↗ العجلة الأمامية';
    if (zone === 'rear_wheels') return '↙ العجلة الخلفية';
    if (zone === 'windshield') return '↑ الزجاج الأمامي';
    if (zone === 'front') return '↑ مقدمة السيارة';
    return '↑ السيارة كاملة';
  }

  function focusRealScene(key) {
    var part = key && PARTS[key];
    var zone = part ? part.zone : 'overview';
    var detail = key ? sfEnrichLocation(locationForProduct(key), activeProduct(), key) : null;
    state.activeLocation = detail;
    sfRenderLocationPins(detail, key);
    updateMarkers();
    var verified = Boolean(detail && detail.verified === true);
    var mapped = Boolean(detail && detail.mapped === true);
    var base = mapped ? (SCENE_VIEWS[zone] || SCENE_VIEWS.overview) : SCENE_VIEWS.overview;
    var sceneName = mapped && detail.scene ? detail.scene : base.scene;
    var view = {
      scene: sceneName,
      x: mapped && detail.anchor ? detail.anchor[0] : base.x,
      y: mapped && detail.anchor ? detail.anchor[1] : base.y,
      scale: mapped && detail.scale ? detail.scale : base.scale,
      turn: base.turn || 0,
      anchor: mapped && detail.anchor ? detail.anchor.slice() : base.anchor.slice(),
      calloutAnchor: mapped && detail.calloutAnchor
        ? detail.calloutAnchor.slice()
        : (mapped && detail.anchor ? detail.anchor.slice() : base.anchor.slice()),
      focusRect: verified && detail.focusRect ? detail.focusRect.slice() : null,
      overlayRect: verified && detail.overlayRect ? detail.overlayRect.slice() : null,
      shape: verified && detail.shape ? detail.shape : ''
    };
    /* A verified pin is calibrated to one scene.  If that scene asset is
     * absent, hide the pin rather than projecting it over the overview. */
    var asset = sceneAssetFor(view, !verified);
    if (verified && !asset) {
      detail = null;
      state.activeLocation = null;
      verified = false;
      mapped = false;
      base = SCENE_VIEWS.overview;
      sceneName = base.scene;
      view = {
        scene: base.scene,
        x: base.x,
        y: base.y,
        scale: base.scale,
        turn: base.turn || 0,
        anchor: base.anchor.slice(),
        calloutAnchor: base.anchor.slice(),
        focusRect: null,
        overlayRect: null,
        shape: ''
      };
      asset = sceneAssetFor(view, true);
      updateMarkers();
    }
    state.sceneView = view;
    state.sceneZoom = view.scale;
    state.scenePanX = 0;
    state.scenePanY = 0;

    var direction = state.modal && state.modal.querySelector('[data-role="direction"]');
    if (direction) direction.textContent = directionLabel(mapped ? zone : 'overview', sceneName, mapped ? key : '');
    renderImageCredit();

    if (!asset) {
      state.realReady = false;
      state.realScene.hidden = true;
      state.sceneCallout.hidden = true;
      state.sceneInstalled.setAttribute('hidden', '');
      if (state.scenePending) state.scenePending.hidden = false;
      state.canvas.hidden = true;
      state.markers.hidden = true;
      return;
    }

    if (state.scenePending) state.scenePending.hidden = true;

    state.sceneImage.alt = verified
      ? vehicleText() + ' — موقع ' + PARTS[key].ar
      : (mapped
        ? vehicleText() + (detail && detail.confidence === 'profile-zone'
          ? ' — منطقة ' + PARTS[key].ar + ' المحددة لهذا الجيل'
          : ' — المنطقة العامة لتركيب ' + PARTS[key].ar)
        : vehicleText() + ' — صورة السيارة');
    state.sceneImage.setAttribute('fetchpriority', mapped ? 'high' : 'auto');
    state.realScene.setAttribute('data-scene', sceneName);
    if (state.sceneImage.src !== asset) {
      state.realReady = false;
      state.realScene.hidden = false;
      state.realScene.classList.remove('is-ready');
      state.canvas.hidden = true;
      state.markers.hidden = true;
      state.sceneImage.src = asset;
    } else if (state.sceneImage.complete && state.sceneImage.naturalWidth) {
      state.realReady = true;
      state.realScene.hidden = false;
      state.realScene.classList.add('is-ready');
      state.canvas.hidden = true;
      state.markers.hidden = true;
    }
    renderActiveProduct();
    renderInstalledPart();
    renderBeltOverlay(key);
    applySceneTransform();
  }

  function sceneGeometry() {
    if (!state.stage || !state.sceneImage || !state.sceneImage.naturalWidth || !state.sceneImage.naturalHeight) return null;
    var rect = state.stage.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;
    var fit = Math.min(rect.width / state.sceneImage.naturalWidth, rect.height / state.sceneImage.naturalHeight);
    var width = state.sceneImage.naturalWidth * fit;
    var height = state.sceneImage.naturalHeight * fit;
    return {
      stageWidth: rect.width,
      stageHeight: rect.height,
      imageWidth: width,
      imageHeight: height,
      offsetX: (rect.width - width) / 2,
      offsetY: (rect.height - height) / 2
    };
  }

  function pointInScene(point, geometry) {
    return {
      x: geometry.offsetX + geometry.imageWidth * point[0] / 100,
      y: geometry.offsetY + geometry.imageHeight * point[1] / 100
    };
  }

  function applySceneTransform() {
    if (!state.sceneCamera || !state.sceneView) return;
    var view = state.sceneView;
    var geometry = sceneGeometry();
    if (!geometry) return;
    var target = pointInScene([view.x, view.y], geometry);
    var translateX = geometry.stageWidth * .5 - target.x * state.sceneZoom + state.scenePanX;
    var translateY = geometry.stageHeight * .48 - target.y * state.sceneZoom + state.scenePanY;
    var duration = reducedMotion ? '0ms' : '520ms';
    state.sceneCamera.style.transitionDuration = duration;
    state.sceneCamera.style.transformOrigin = '0 0';
    state.sceneCamera.style.transform =
      'translate3d(' + translateX.toFixed(2) + 'px, ' + translateY.toFixed(2) + 'px, 0) ' +
      'scale(' + state.sceneZoom + ')';
    if (state.sceneCallout && !state.sceneCallout.hidden) {
      state.sceneCallout.classList.toggle(
        'is-compact',
        state.sceneZoom <= 1.15 || (geometry.stageWidth <= 500 && state.sceneZoom <= 1.4)
      );
      var targetPoint = pointInScene(view.anchor, geometry);
      var preferredPoint = pointInScene(view.calloutAnchor || view.anchor, geometry);
      placeSceneCallout(
        translateX + targetPoint.x * state.sceneZoom,
        translateY + targetPoint.y * state.sceneZoom,
        translateX + preferredPoint.x * state.sceneZoom,
        translateY + preferredPoint.y * state.sceneZoom,
        geometry
      );
    }
    if (state.sceneInstalled && view.overlayRect) {
      var overlayStart = pointInScene([view.overlayRect[0], view.overlayRect[1]], geometry);
      state.sceneInstalled.style.left = overlayStart.x.toFixed(2) + 'px';
      state.sceneInstalled.style.top = overlayStart.y.toFixed(2) + 'px';
      state.sceneInstalled.style.width = (geometry.imageWidth * view.overlayRect[2] / 100).toFixed(2) + 'px';
      state.sceneInstalled.style.height = (geometry.imageHeight * view.overlayRect[3] / 100).toFixed(2) + 'px';
    }
  }

  function placeSceneCallout(targetX, targetY, preferredX, preferredY, geometry) {
    var callout = state.sceneCallout;
    if (!callout) return;
    var width = callout.offsetWidth || (window.innerWidth <= 420 ? 154 : 184);
    var height = callout.offsetHeight || (window.innerWidth <= 420 ? 64 : 72);
    var halfW = width / 2;
    var halfH = height / 2;
    var dx = preferredX - targetX;
    var dy = preferredY - targetY;
    var magnitude = Math.hypot(dx, dy);
    if (magnitude < 12) {
      dx = 0;
      dy = -1;
      magnitude = 1;
    }
    var ux = dx / magnitude;
    var uy = dy / magnitude;
    var distance = clamp(Math.max(magnitude, halfH + 62), 104, 176);
    var directions = [
      [ux, uy],
      [-uy, ux],
      [uy, -ux],
      [-ux, -uy],
      [0, -1],
      [0, 1]
    ];
    var minX = halfW + 12;
    var maxX = Math.max(minX, geometry.stageWidth - halfW - 12);
    var minY = halfH + 66;
    var maxY = Math.max(minY, geometry.stageHeight - halfH - 62);
    var best = null;
    directions.forEach(function (direction, index) {
      var x = clamp(targetX + direction[0] * distance, minX, maxX);
      var y = clamp(targetY + direction[1] * distance, minY, maxY);
      var gapX = Math.abs(x - targetX) - halfW;
      var gapY = Math.abs(y - targetY) - halfH;
      var overlapsTarget = gapX < 34 && gapY < 34;
      var preferenceDistance = Math.hypot(x - preferredX, y - preferredY);
      var lineDistance = Math.hypot(x - targetX, y - targetY);
      var score = (overlapsTarget ? 100000 : 0) + preferenceDistance * .7 + lineDistance * .12 + index * 3;
      if (!best || score < best.score) best = { x: x, y: y, score: score };
    });
    if (!best) return;
    callout.style.left = best.x.toFixed(2) + 'px';
    callout.style.top = best.y.toFixed(2) + 'px';
    var lineX = targetX - best.x;
    var lineY = targetY - best.y;
    callout.style.setProperty('--sf-callout-line', Math.max(28, Math.hypot(lineX, lineY)).toFixed(2) + 'px');
    callout.style.setProperty('--sf-callout-angle', Math.atan2(lineY, lineX).toFixed(5) + 'rad');
  }

  function installedShapeMarkup(shape) {
    if (shape === 'air_filter' || shape === 'cabin_filter') {
      return '<rect class="sf-camry-map__installed-fill" x="6" y="10" width="88" height="80" rx="10"/>' +
        '<path d="M18 18V82M29 18V82M40 18V82M51 18V82M62 18V82M73 18V82M84 18V82"/>';
    }
    if (shape === 'ac_evaporator') {
      return '<rect class="sf-camry-map__installed-fill" x="15" y="13" width="67" height="74" rx="7"/>' +
        '<path d="M23 20V80M31 20V80M39 20V80M47 20V80M55 20V80M63 20V80M71 20V80"/>' +
        '<path d="M15 29H82M15 45H82M15 61H82M15 77H82M82 27h10v13H82M82 62h10v13H82"/>' +
        '<path d="M92 33c6 0 6-12 0-12M92 69c6 0 6 12 0 12"/>';
    }
    if (shape === 'maf_sensor') {
      return '<path class="sf-camry-map__installed-fill" d="M24 22h52v44H61v18H39V66H24z"/><path d="M36 35h28M36 48h28M50 66v18"/>';
    }
    if (shape === 'oxygen_sensor') {
      return '<path class="sf-camry-map__installed-fill" d="M15 37h39l12 12-12 14H15z"/>' +
        '<path d="M22 37v26M31 37v26M40 37v26M49 37v26M66 49c13-2 21-11 24-26M66 53c13 2 21 11 24 26"/>' +
        '<circle cx="91" cy="19" r="6"/><circle cx="91" cy="83" r="6"/>';
    }
    if (shape === 'ignition_coil') {
      return '<path class="sf-camry-map__installed-fill" d="M29 10h42v34H60v15l-6 25H46l-6-25V44H29z"/>' +
        '<path d="M37 20h26M37 30h26M43 44h14M46 84v9M54 84v9"/>';
    }
    if (shape === 'spark_plug_single') {
      return '<path class="sf-camry-map__installed-fill" d="M38 8h24v28H38z"/>' +
        '<path d="M42 16h16M42 24h16M38 36h24M42 43h16M42 51h16M45 59h10v25H45zM45 84l-7 8M55 84l7 8"/>';
    }
    if (shape === 'knock_sensor') {
      return '<path class="sf-camry-map__installed-fill" d="M19 36h18l9-15h20l10 15h8v35H70l-8 10H38l-8-10H19z"/>' +
        '<circle cx="51" cy="52" r="14"/><circle cx="51" cy="52" r="5"/><path d="M76 44h17v18H76"/>';
    }
    if (shape === 'thermostat') {
      return '<circle class="sf-camry-map__installed-fill" cx="50" cy="53" r="27"/>' +
        '<path d="M24 53h52M50 26V11M38 26l4-13h16l4 13M40 80v11h20V80M35 44l15-9 15 9v18l-15 9-15-9z"/>';
    }
    if (shape === 'vacuum_pump') {
      return '<path class="sf-camry-map__installed-fill" d="M19 31l18-15h33l13 20v34L67 84H34L17 66z"/>' +
        '<circle cx="50" cy="51" r="21"/><circle cx="50" cy="51" r="7"/><path d="M83 43h12v17H83M24 27l-8-11M75 28l9-12"/>';
    }
    if (shape === 'spark_plugs') {
      return '<path d="M15 18v48m23-48v48m24-48v48m23-48v48"/><path class="sf-camry-map__installed-fill" d="M9 18h12v22H9zm23 0h12v22H32zm24 0h12v22H56zm23 0h12v22H79z"/><path d="M8 67h14m9 0h14m10 0h14m9 0h14"/>';
    }
    if (shape === 'oil_filter') {
      return '<ellipse class="sf-camry-map__installed-fill" cx="50" cy="22" rx="28" ry="15"/><path class="sf-camry-map__installed-fill" d="M22 22v55c0 12 56 12 56 0V22"/><ellipse cx="50" cy="77" rx="28" ry="15"/><path d="M35 18h30M31 34h38"/>';
    }
    if (shape === 'brake_pad') {
      return '<path class="sf-camry-map__installed-fill" d="M18 76C12 46 27 18 50 13c23 5 38 33 32 63l-16 10-9-13H43l-9 13z"/><path d="M31 70c-2-20 6-36 19-42 13 6 21 22 19 42"/>';
    }
    if (shape === 'wiper_driver') {
      return '<path class="sf-camry-map__installed-wide" d="M7 72Q49 43 94 19"/><path d="M10 78Q51 49 96 25M49 45l8 13"/>';
    }
    if (shape === 'wiper_passenger') {
      return '<path class="sf-camry-map__installed-wide" d="M8 63Q49 43 92 27"/><path d="M10 70Q50 50 95 34M49 45l7 13"/>';
    }
    if (shape === 'transmission_filter') {
      return '<path class="sf-camry-map__installed-fill" d="M15 24h58l12 17-8 39H28L12 60z"/><circle cx="27" cy="38" r="5"/><circle cx="66" cy="38" r="5"/><path d="M28 59h49"/>';
    }
    if (shape === 'service_point') {
      return '<circle class="sf-camry-map__installed-fill" cx="50" cy="50" r="34"/><path d="M50 24v32l18 12M31 50h38"/>';
    }
    if (shape === 'compressor_control_valve') {
      return '<path class="sf-camry-map__installed-fill" d="M17 29h39c9 0 15 7 15 15v12c0 8-6 15-15 15H17z"/>' +
        '<path class="sf-camry-map__installed-fill" d="M6 37h15v26H6zM69 35h17v30H69zM85 40h10v20H85z"/>' +
        '<path d="M26 29v42M58 32v36M70 39h16M70 49h16M70 59h16M9 43h8M9 57h8"/>' +
        '<circle cx="62" cy="44" r="3"/>';
    }
    return '';
  }

  function renderInstalledPart() {
    if (!state.sceneInstalled) return;
    var location = state.activeLocation;
    if (!location || !location.verified || !location.shape || !location.overlayRect) {
      state.sceneInstalled.setAttribute('hidden', '');
      state.sceneInstalled.replaceChildren();
      return;
    }
    state.sceneInstalled.innerHTML = installedShapeMarkup(location.shape);
    if (state.sceneInstalled.childNodes.length) state.sceneInstalled.removeAttribute('hidden');
    else state.sceneInstalled.setAttribute('hidden', '');
  }

  function productsFor(key) {
    return state.available.get(key) || [];
  }

  function activeProduct() {
    var products = productsFor(state.activeKey);
    if (!products.length) return null;
    for (var i = 0; i < products.length; i += 1) {
      if (products[i].id === state.activeProductId) return products[i];
    }
    state.activeProductId = products[0].id;
    return products[0];
  }

  function locationForProduct(key) {
    var product = activeProduct();
    if (product) {
      var codes = product.codes && product.codes.length
        ? product.codes
        : productCodesFromSku(product.sku);
      var match = routeLocationForCodes(
        state.profile && state.profile.route,
        state.profile && state.profile.code,
        codes,
        key
      );
      var exact = match && match.exact;
      var resolved = exact && exact.part === key &&
        (exact.verified === true || (exact.mapped === true && exact.confidence === 'profile-zone'));
      if (resolved) {
        return {
          verified: exact.verified === true,
          mapped: true,
          confidence: exact.confidence || 'direct',
          scene: exact.scene,
          anchor: exact.anchor.slice(),
          calloutAnchor: exact.calloutAnchor ? exact.calloutAnchor.slice() : exact.anchor.slice(),
          focusRect: exact.focusRect ? exact.focusRect.slice() : null,
          overlayRect: exact.overlayRect ? exact.overlayRect.slice() : null,
          shape: exact.shape || '',
          scale: exact.scale,
          overlay: exact.overlay || '',
          beltLayout: exact.beltLayout || '',
          asset: exact.asset || '',
          point3d: exact.point3d ? exact.point3d.slice() : null,
          note: exact.note || '',
          code: match.code
        };
      }
      if (state.profile && requiresExactLocation(state.profile.route)) return null;
      var general = PART_SCENES[key];
      var part = PARTS[key];
      if (general && part && state.profile && state.profile.assets) {
        var base = SCENE_VIEWS[part.zone] || SCENE_VIEWS.overview;
        var anchor = general.anchor ? general.anchor.slice() : base.anchor.slice();
        return {
          verified: false,
          mapped: true,
          confidence: 'category-zone',
          scene: general.scene || base.scene,
          anchor: anchor,
          calloutAnchor: [clamp(anchor[0] - 13, 10, 90), clamp(anchor[1] - 14, 10, 90)],
          focusRect: null,
          overlayRect: null,
          shape: '',
          scale: Math.min(general.scale || base.scale || 1.8, 2.35),
          overlay: '',
          beltLayout: '',
          asset: '',
          point3d: null,
          note: 'هذه منطقة التركيب العامة لفئة ' + part.ar + ' على شكل السيارة المختار؛ الموقع الدقيق يختلف حسب المحرك ورقم القطعة.'
        };
      }
    }
    return null;
  }

  function chooseProduct(productId) {
    var products = productsFor(state.activeKey);
    var exists = products.some(function (product) { return product.id === productId; });
    if (!exists) return;
    state.activeProductId = productId;
    state.activeLocation = locationForProduct(state.activeKey);
    renderProductGallery(state.activeKey);
    renderActiveProduct();
    focusRealScene(state.activeKey);
  }

  function renderActiveProduct() {
    if (!state.sceneCallout) return;
    var product = activeProduct();
    var part = PARTS[state.activeKey];
    var mapped = Boolean(state.activeLocation && state.activeLocation.mapped);
    var verified = Boolean(state.activeLocation && state.activeLocation.verified);
    var profileZone = Boolean(mapped && state.activeLocation.confidence === 'profile-zone');
    if (!part || !product || !mapped) {
      state.sceneCallout.hidden = true;
      return;
    }
    state.sceneCallout.hidden = false;
    state.sceneCallout.classList.toggle('is-verified', verified);
    state.sceneCallout.classList.toggle('is-unverified', !verified);
    state.sceneCallout.setAttribute('aria-label', profileZone
      ? 'صورة المنتج في منطقة تركيبه المحددة لهذا الجيل: ' + (product.title || part.ar)
      : (verified
        ? 'صورة المنتج الحقيقي في موقعه الموثق: ' + (product.title || part.ar)
        : 'المنطقة العامة لتركيب ' + part.ar));
    if (!verified) {
      state.sceneCalloutName.textContent = profileZone ? (product.sku || product.title || part.ar) : part.ar;
      state.sceneConfidence.textContent = profileZone
        ? 'منطقة محددة لهذا الجيل · تحقق VIN'
        : 'منطقة تركيب عامة · طابق VIN';
      if (profileZone && product.image) {
        state.sceneCalloutImage.hidden = false;
        state.sceneCalloutImage.src = product.image;
        state.sceneCalloutImage.alt = product.title || part.ar;
        state.sceneCallout.classList.remove('has-no-image');
      } else {
        state.sceneCalloutImage.hidden = true;
        state.sceneCalloutImage.removeAttribute('src');
        state.sceneCallout.classList.add('has-no-image');
      }
      return;
    }
    state.sceneCalloutName.textContent = product.sku || product.title || part.ar;
    if (state.activeLocation.confidence === 'cross-reference') state.sceneConfidence.textContent = 'الموقع موثّق بمرجع بديل';
    else if (state.activeLocation.confidence === 'vin-required') state.sceneConfidence.textContent = 'الموقع صحيح · تحقق VIN/رقم القطعة';
    else if (state.activeLocation.confidence === 'service') state.sceneConfidence.textContent = 'موضع الخدمة الصحيح';
    else if (state.activeLocation.confidence === 'profile-zone') state.sceneConfidence.textContent = 'الموقع مطابق للسيارة والجيل';
    else state.sceneConfidence.textContent = 'الموقع موثّق لهذا الكود';
    if (product.image) {
      state.sceneCalloutImage.hidden = false;
      state.sceneCalloutImage.src = product.image;
      state.sceneCalloutImage.alt = product.title || part.ar;
      state.sceneCallout.classList.remove('has-no-image');
    } else {
      state.sceneCalloutImage.hidden = true;
      state.sceneCalloutImage.removeAttribute('src');
      state.sceneCallout.classList.add('has-no-image');
    }
  }

  function renderProductGallery(key) {
    if (!state.gallery || !state.galleryList) return;
    if (usesDirectProductRows()) {
      state.gallery.hidden = true;
      state.galleryList.replaceChildren();
      return;
    }
    var products = productsFor(key);
    state.gallery.hidden = !products.length;
    state.galleryTitle.textContent = key && PARTS[key]
      ? 'المنتجات المتوفرة — ' + PARTS[key].ar
      : 'المنتجات المتوفرة';
    var fragment = document.createDocumentFragment();
    products.forEach(function (product) {
      var item = document.createElement('article');
      item.className = 'sf-camry-map__product' + (product.id === state.activeProductId ? ' is-active' : '');

      var choice = document.createElement('button');
      choice.type = 'button';
      choice.className = 'sf-camry-map__product-choice';
      choice.setAttribute('data-scene-product-id', product.id);
      choice.setAttribute('aria-pressed', product.id === state.activeProductId ? 'true' : 'false');

      if (product.image) {
        var image = document.createElement('img');
        image.src = product.image;
        image.alt = product.title || PARTS[key].ar;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.addEventListener('error', function () {
          var placeholder = document.createElement('span');
          placeholder.className = 'sf-camry-map__product-placeholder';
          placeholder.textContent = PARTS[key].icon;
          placeholder.setAttribute('aria-hidden', 'true');
          image.replaceWith(placeholder);
        }, { once: true });
        choice.appendChild(image);
      } else {
        var placeholder = document.createElement('span');
        placeholder.className = 'sf-camry-map__product-placeholder';
        placeholder.textContent = PARTS[key].icon;
        placeholder.setAttribute('aria-hidden', 'true');
        choice.appendChild(placeholder);
      }

      var copy = document.createElement('span');
      copy.className = 'sf-camry-map__product-copy';
      var name = document.createElement('strong');
      name.textContent = product.sku || product.title || PARTS[key].ar;
      copy.appendChild(name);
      if (product.price) {
        var price = document.createElement('span');
        price.textContent = product.price;
        copy.appendChild(price);
      }
      choice.appendChild(copy);
      item.appendChild(choice);

      item.appendChild(cartButtonFor(product, 'sf-camry-map__product-link'));
      fragment.appendChild(item);
    });
    state.galleryList.replaceChildren(fragment);
  }

  function renderBeltOverlay(key) {
    if (!state.beltOverlay) return;
    state.beltOverlay.setAttribute('hidden', '');
    state.beltOverlay.replaceChildren();
    if (key !== 'drive_belt' || !state.activeLocation || !state.activeLocation.verified || state.activeLocation.overlay !== 'belt') return;
    var layout = BELT_LAYOUTS[state.activeLocation.beltLayout];
    if (!layout) return;
    var svgNS = 'http://www.w3.org/2000/svg';
    if (state.activeLocation.asset) {
      var beltImage = document.createElementNS(svgNS, 'image');
      beltImage.setAttribute('href', state.activeLocation.asset);
      beltImage.setAttribute('x', '0');
      beltImage.setAttribute('y', '0');
      beltImage.setAttribute('width', '280');
      beltImage.setAttribute('height', '290');
      beltImage.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      beltImage.setAttribute('class', 'sf-camry-map__belt-photo');
      state.beltOverlay.appendChild(beltImage);
      state.beltOverlay.removeAttribute('hidden');
      return;
    }
    var background = document.createElementNS(svgNS, 'rect');
    background.setAttribute('x', '22');
    background.setAttribute('y', '14');
    background.setAttribute('width', '236');
    background.setAttribute('height', '258');
    background.setAttribute('rx', '28');
    background.setAttribute('class', 'sf-camry-map__belt-engine');
    state.beltOverlay.appendChild(background);
    layout.pulleys.forEach(function (pulley) {
      var outer = document.createElementNS(svgNS, 'circle');
      outer.setAttribute('cx', pulley[0]);
      outer.setAttribute('cy', pulley[1]);
      outer.setAttribute('r', pulley[2]);
      outer.setAttribute('class', 'sf-camry-map__pulley');
      state.beltOverlay.appendChild(outer);
      var hub = document.createElementNS(svgNS, 'circle');
      hub.setAttribute('cx', pulley[0]);
      hub.setAttribute('cy', pulley[1]);
      hub.setAttribute('r', Math.max(5, pulley[2] * .28));
      hub.setAttribute('class', 'sf-camry-map__pulley-hub');
      state.beltOverlay.appendChild(hub);
    });
    var beltShadow = document.createElementNS(svgNS, 'path');
    beltShadow.setAttribute('d', layout.path);
    beltShadow.setAttribute('class', 'sf-camry-map__belt-path sf-camry-map__belt-path--shadow');
    state.beltOverlay.appendChild(beltShadow);
    var beltHighlight = document.createElementNS(svgNS, 'path');
    beltHighlight.setAttribute('d', layout.path);
    beltHighlight.setAttribute('class', 'sf-camry-map__belt-path sf-camry-map__belt-path--highlight');
    state.beltOverlay.appendChild(beltHighlight);
    state.beltOverlay.removeAttribute('hidden');
  }

  function openModal(key, sourceButton, productId) {
    buildModal();
    state.lastFocus = sourceButton || document.activeElement;
    state.profile = profileFromPage();
    state.modal.classList.toggle('is-direct-products', usesDirectProductRows());
    var modalTitle = state.modal.querySelector('#sfCamryMapTitle');
    var eyebrow = state.modal.querySelector('.sf-camry-map__eyebrow');
    var panelTitle = state.modal.querySelector('[data-role="panel-title"]');
    var panelIntro = state.modal.querySelector('[data-role="panel-intro"]');
    modalTitle.textContent = 'مواقع قطع ' + ([state.profile.make, state.profile.model].filter(Boolean).join(' ') || 'السيارة');
    eyebrow.textContent = state.profile.assets
      ? 'نموذج السيارة الزجاجي · المواقع المطابقة فقط'
      : 'صور المنتجات المتوافقة';
    panelTitle.textContent = 'اختر القطعة المتوافقة';
    panelIntro.textContent = 'يظهر موقع القطعة تلقائيًا حسب نوعها داخل نتائج سيارتك، ويظهر الموقع الأدق عندما يتوفر توثيق مطابق لرقم القطعة والجيل. طابق VIN قبل الطلب.';
    state.search.placeholder = 'ابحث باسم القطعة أو رقمها';
    refreshVehicleHeader();
    if (!key) {
      state.selected = [];
      state.activeKey = '';
      state.activeProductId = '';
      state.activeLocation = null;
    }
    renderParts();
    if (typeof state.modal.showModal === 'function') state.modal.showModal();
    else state.modal.setAttribute('open', '');
    document.body.classList.add('sf-camry-map-open');
    resizeCanvas();
    if (key && PARTS[key]) selectPart(key, true, productId);
    else {
      updateSelectionUI();
      renderProductGallery('');
      focusRealScene('');
      animateCamera(cameraPreset('overview'));
    }
    window.setTimeout(function () {
      if (!state.modal || !state.modal.open) return;
      var close = state.modal.querySelector('[data-action="close"]');
      if (close) close.focus({ preventScroll: true });
    }, 30);
  }

  function closeModal() {
    if (!state.modal) return;
    cancelAnimationFrame(state.tweenFrame);
    if (typeof state.modal.close === 'function') state.modal.close();
    else state.modal.removeAttribute('open');
    document.body.classList.remove('sf-camry-map-open');
    if (state.lastFocus && typeof state.lastFocus.focus === 'function') {
      state.lastFocus.focus({ preventScroll: true });
    }
  }

  function departmentForPart(key) {
    if (key === 'compressor_valve' || key === 'ac_pressure_sensor' || key === 'ac_system' || key === 'ac_evaporator') return 'التكييف';
    if (key === 'oxygen_front' || key === 'oxygen_rear' || key === 'oxygen_front_left' || key === 'oxygen_front_right' ||
        key === 'oxygen_b1s1' || key === 'oxygen_b1s2' || key === 'oxygen_b2s1' || key === 'oxygen_b2s2' ||
        key === 'maf_sensor' || key === 'knock_sensor') return 'الحساسات والكهرباء';
    if (key === 'ignition_coil' || key === 'spark_plug' || key === 'drive_belt' || key === 'belt_tensioner' || key === 'idler_pulley' || key.indexOf('engine_mount_') === 0) return 'المحرك والإشعال';
    if (key === 'engine_air_filter' || key === 'cabin_filter' || key === 'oil_filter' || key === 'transmission_filter') return 'الفلاتر';
    if (key === 'thermostat' || key === 'radiator' || key === 'radiator_hose_upper' || key === 'radiator_hose_lower' || key === 'radiator_hose_general' || key === 'cooling_system' || key === 'water_pump') return 'نظام التبريد';
    if (key === 'brake_front' || key === 'brake_rear' || key === 'brake_vacuum_pump') return 'الفرامل';
    if (key === 'shock_absorber_front' || key === 'shock_absorber_rear' || key === 'suspension_front' || key === 'suspension_rear' || key === 'suspension_general' || key === 'abs_sensor_front' || key === 'abs_sensor_rear' || key === 'steering_tie_rod') return 'التعليق والدركسون';
    if (key === 'fuel_pump' || key === 'fuel_pump_engine') return 'نظام الوقود';
    if (key === 'wiper') return 'المسّاحات والهيكل';
    return 'قطع غيار أخرى';
  }

  function renderPilotProducts() {
    var query = normalize(state.search ? state.search.value : '');
    var fragment = document.createDocumentFragment();
    var visible = 0;
    var currentDepartment = '';
    pilotProducts().forEach(function (row) {
      var key = row.key;
      var product = row.product;
      var part = PARTS[key];
      var searchable = normalize(part.ar + ' ' + part.en + ' ' + product.title + ' ' + product.sku);
      if (query && searchable.indexOf(query) === -1) return;
      visible += 1;

      var department = departmentForPart(key);
      if (department !== currentDepartment) {
        currentDepartment = department;
        var sectionTitle = document.createElement('h3');
        sectionTitle.className = 'sf-camry-map__pilot-section';
        sectionTitle.textContent = department;
        fragment.appendChild(sectionTitle);
      }

      var locationMatch = routeLocationForCodes(
        state.profile.route,
        state.profile.code,
        product.codes || [],
        key
      );
      var mappedLocation = locationMatch &&
        locationMatch.exact &&
        locationMatch.exact.part === key &&
        (locationMatch.exact.verified === true ||
          (locationMatch.exact.mapped === true && locationMatch.exact.confidence === 'profile-zone'))
          ? locationMatch.exact
          : null;
      var confidence = mappedLocation ? mappedLocation.confidence : '';
      var generalLocation = !mappedLocation &&
        !(state.profile && requiresExactLocation(state.profile.route)) &&
        Boolean(PART_SCENES[key] && state.profile && state.profile.assets);
      var selected = state.activeKey === key && state.activeProductId === product.id;
      var item = document.createElement('article');
      item.className = 'sf-camry-map__pilot-product' + (selected ? ' is-active' : '');

      var choice = document.createElement('button');
      choice.type = 'button';
      choice.className = 'sf-camry-map__pilot-choice';
      choice.setAttribute('data-pilot-product', '');
      choice.setAttribute('data-part-key', key);
      choice.setAttribute('data-product-id', product.id);
      choice.setAttribute('aria-pressed', selected ? 'true' : 'false');

      if (product.image) {
        var image = document.createElement('img');
        image.src = product.image;
        image.alt = product.title || part.ar;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.addEventListener('error', function () {
          var noImage = document.createElement('span');
          noImage.className = 'sf-camry-map__pilot-no-image';
          noImage.textContent = 'الصورة غير متاحة';
          image.replaceWith(noImage);
        }, { once: true });
        choice.appendChild(image);
      } else {
        var noImage = document.createElement('span');
        noImage.className = 'sf-camry-map__pilot-no-image';
        noImage.textContent = 'الصورة غير متاحة';
        choice.appendChild(noImage);
      }

      var copy = document.createElement('span');
      copy.className = 'sf-camry-map__pilot-copy';
      var category = document.createElement('span');
      category.className = 'sf-camry-map__pilot-category';
      category.textContent = part.ar;
      var title = document.createElement('strong');
      title.className = 'sf-camry-map__pilot-title';
      title.textContent = product.title || part.ar;
      var meta = document.createElement('span');
      meta.className = 'sf-camry-map__pilot-meta';
      meta.textContent = [product.sku, product.price].filter(Boolean).join(' · ');
      var status = document.createElement('span');
      status.className = 'sf-camry-map__pilot-status ' + (mappedLocation
        ? (mappedLocation.verified === true ? 'is-verified' : 'is-general')
        : (generalLocation ? 'is-general' : 'is-unverified'));
      status.textContent = mappedLocation
        ? (confidence === 'profile-zone'
          ? 'منطقة القطعة محددة لهذا الجيل'
          : (confidence === 'vin-required'
          ? 'الموقع موثّق · تحقق VIN'
          : (confidence === 'service'
            ? 'موضع الخدمة موثّق'
            : 'الموقع موثّق لهذا الكود')))
        : (generalLocation ? 'منطقة التركيب العامة متاحة' : 'الموقع غير موثّق بعد');
      copy.appendChild(category);
      copy.appendChild(title);
      copy.appendChild(meta);
      copy.appendChild(status);
      choice.appendChild(copy);
      item.appendChild(choice);

      item.appendChild(cartButtonFor(product, 'sf-camry-map__pilot-link'));
      fragment.appendChild(item);
    });

    var unavailable = DISCOVERABLE_PHYSICAL_PARTS.filter(function (entry) {
      if (discoverableAvailable(entry)) return false;
      return !query || discoverableSearchText(entry).indexOf(query) !== -1;
    });
    if (unavailable.length) {
      var unavailableTitle = document.createElement('h3');
      unavailableTitle.className = 'sf-camry-map__pilot-section sf-camry-map__pilot-section--unavailable';
      unavailableTitle.textContent = 'غير متوفر لهذه السيارة حاليًا';
      fragment.appendChild(unavailableTitle);
      unavailable.forEach(function (entry) {
        var part = PARTS[entry.key];
        if (!part) return;
        visible += 1;
        var item = document.createElement('article');
        item.className = 'sf-camry-map__pilot-product is-unavailable';
        item.setAttribute('aria-label', part.ar + ' — غير متوفر لهذه السيارة حاليًا');

        var row = document.createElement('div');
        row.className = 'sf-camry-map__pilot-choice';
        row.setAttribute('aria-disabled', 'true');

        var icon = document.createElement('span');
        icon.className = 'sf-camry-map__pilot-no-image sf-camry-map__unavailable-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = part.icon;

        var copy = document.createElement('span');
        copy.className = 'sf-camry-map__pilot-copy';
        var category = document.createElement('span');
        category.className = 'sf-camry-map__pilot-category';
        category.textContent = departmentForPart(entry.key);
        var name = document.createElement('strong');
        name.className = 'sf-camry-map__pilot-title';
        name.textContent = part.ar;
        var english = document.createElement('span');
        english.className = 'sf-camry-map__pilot-meta';
        english.textContent = part.en;
        var status = document.createElement('span');
        status.className = 'sf-camry-map__pilot-status is-unverified';
        status.textContent = 'لا يوجد منتج مرتبط بهذه السيارة';
        copy.appendChild(category);
        copy.appendChild(name);
        copy.appendChild(english);
        copy.appendChild(status);
        row.appendChild(icon);
        row.appendChild(copy);
        item.appendChild(row);
        fragment.appendChild(item);
      });
    }
    state.partsList.replaceChildren(fragment);
    if (!visible) {
      var empty = document.createElement('div');
      empty.className = 'sf-camry-map__empty';
      var oxygenQuery = query && includesAny(query, ['اكسجين', 'oxygen', 'o2', 'air fuel', 'air-fuel']);
      empty.textContent = state.profile && state.profile.route === PILOT_ROUTE && oxygenQuery
        ? 'لا يوجد حساس أكسجين موثّق متوافق مع محرك 2.5L أربع سلندر حاليًا. استخدم رقم الشاصي للتأكد من رقم الحساس قبل الطلب.'
        : (query ? 'لا يوجد منتج مطابق داخل نتائج هذه السيارة.' : 'لا توجد منتجات قطع غيار ظاهرة لهذه السيارة.');
      state.partsList.appendChild(empty);
    }
    updateSelectionUI();
  }

  function renderParts() {
    if (!state.partsList) return;
    if (usesDirectProductRows()) {
      renderPilotProducts();
      return;
    }
    var query = normalize(state.search ? state.search.value : '');
    var fragment = document.createDocumentFragment();
    var visible = 0;
    Array.from(state.available.keys()).sort(function (a, b) {
      return PARTS[a].ar.localeCompare(PARTS[b].ar, 'ar');
    }).forEach(function (key) {
      var part = PARTS[key];
      var searchable = normalize(part.ar + ' ' + part.en);
      if (query && searchable.indexOf(query) === -1) return;
      visible += 1;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'sf-camry-map__part';
      button.setAttribute('data-map-part', key);
      button.setAttribute('aria-pressed', state.selected.indexOf(key) !== -1 ? 'true' : 'false');
      button.innerHTML =
        '<span class="sf-camry-map__part-icon" aria-hidden="true">' + part.icon + '</span>' +
        '<span class="sf-camry-map__part-copy"><span class="sf-camry-map__part-name"></span><span class="sf-camry-map__part-en"></span></span>' +
        '<span class="sf-camry-map__part-count">' + state.available.get(key).length + '</span>';
      button.querySelector('.sf-camry-map__part-name').textContent = part.ar;
      button.querySelector('.sf-camry-map__part-en').textContent = part.en;
      fragment.appendChild(button);
    });

    DISCOVERABLE_PHYSICAL_PARTS.forEach(function (entry) {
      if (discoverableAvailable(entry)) return;
      var part = PARTS[entry.key];
      if (!part) return;
      if (query && discoverableSearchText(entry).indexOf(query) === -1) return;
      visible += 1;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'sf-camry-map__part is-unavailable';
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.innerHTML =
        '<span class="sf-camry-map__part-icon" aria-hidden="true">' + part.icon + '</span>' +
        '<span class="sf-camry-map__part-copy"><span class="sf-camry-map__part-name"></span><span class="sf-camry-map__part-en"></span></span>' +
        '<span class="sf-camry-map__part-count">غير متوفر</span>';
      button.querySelector('.sf-camry-map__part-name').textContent = part.ar;
      button.querySelector('.sf-camry-map__part-en').textContent = part.en;
      fragment.appendChild(button);
    });
    state.partsList.replaceChildren(fragment);
    if (!visible) {
      var empty = document.createElement('div');
      empty.className = 'sf-camry-map__empty';
      empty.textContent = query ? 'لا توجد قطعة مطابقة داخل نتائج سيارتك.' : 'لا توجد قطع قابلة للتحديد في النتائج الحالية.';
      state.partsList.appendChild(empty);
    }
    updateSelectionUI();
  }

  function togglePart(key) {
    selectPart(key, true);
  }

  function selectPilotProduct(key, productId) {
    if (!PARTS[key]) return;
    state.selected = [key];
    state.activeKey = key;
    state.activeProductId = String(productId || '');
    activeProduct();
    renderParts();
    focusPart(key);
  }

  function selectPart(key, focus, productId) {
    if (!PARTS[key]) return;
    var samePart = state.activeKey === key;
    state.selected = [key];
    state.activeKey = key;
    if (productId) state.activeProductId = String(productId);
    else if (!samePart) state.activeProductId = '';
    activeProduct();
    renderParts();
    if (focus && state.partsList) {
      var replacement = state.partsList.querySelector('[data-map-part="' + key + '"]');
      if (replacement) replacement.focus({ preventScroll: true });
    }
    renderProductGallery(key);
    if (focus) focusPart(key);
  }

  function removePart(key) {
    if (state.activeKey !== key) return;
    state.selected = [];
    state.activeKey = '';
    state.activeProductId = '';
    state.activeLocation = null;
    updateSelectionUI();
    renderParts();
    renderProductGallery('');
    focusRealScene('');
    animateCamera(cameraPreset('overview'));
  }

  function clearSelection() {
    state.selected = [];
    state.activeKey = '';
    state.activeProductId = '';
    state.activeLocation = null;
    updateSelectionUI();
    renderParts();
    renderProductGallery('');
    focusRealScene('');
    animateCamera(cameraPreset('overview'));
  }

  function focusPart(key) {
    if (!PARTS[key]) return;
    state.activeKey = key;
    state.statusTitle.textContent = PARTS[key].ar;
    updateSelectionUI();
    renderProductGallery(key);
    focusRealScene(key);
    state.statusNote.textContent = locationNote(key);
    var hasMappedLocation = Boolean(state.activeLocation && state.activeLocation.mapped === true);
    animateCamera(cameraPreset(hasMappedLocation ? PARTS[key].zone : 'overview', hasMappedLocation ? key : ''));
  }

  function locationNote(key) {
    if (state.activeLocation && state.activeLocation.confidence === 'profile-zone') {
      return (state.activeLocation.note ? state.activeLocation.note + ' ' : '') +
        'رقم المنتج الظاهر ' + state.activeLocation.code + ' موجود ضمن نتائج هذه السيارة، لكن التوافق النهائي يحتاج VIN.';
    }
    if (state.activeLocation && state.activeLocation.verified) {
      if (state.activeLocation.confidence === 'vin-required') {
        var fitmentCheck = key === 'transmission_filter' || key === 'transmission_service'
          ? 'VIN وكود القير'
          : 'VIN ورقم القطعة أو المكوّن';
        return (state.activeLocation.note || '') + ' الموقع الفيزيائي موثّق، لكن توافق المنتج النهائي يحتاج ' + fitmentCheck + '.';
      }
      return (state.activeLocation.note ? state.activeLocation.note + ' ' : '') + 'تمت المطابقة بكود ' + state.activeLocation.code + ' لهذه السيارة.';
    }
    if (state.activeLocation && state.activeLocation.mapped) {
      return (state.activeLocation.note || '') + ' هذه علامة منطقة عامة وليست نقطة مسمار دقيقة؛ طابق VIN قبل الطلب.';
    }
    return 'صورة المنتج الحقيقية متاحة، لكن لا توجد منطقة تركيب معتمدة لهذا التصنيف.';
  }

  function updateSelectionUI() {
    if (!state.selectedList) return;
    var fragment = document.createDocumentFragment();
    state.selected.forEach(function (key) {
      var part = PARTS[key];
      if (!part) return;
      var row = document.createElement('div');
      row.className = 'sf-camry-map__selected-row';
      row.innerHTML =
        '<span class="sf-camry-map__selected-number" aria-hidden="true">' + part.icon + '</span>' +
        '<button class="sf-camry-map__selected-focus" type="button" data-focus-part="' + key + '"></button>' +
        '<button class="sf-camry-map__selected-remove" type="button" data-remove-part="' + key + '" aria-label="إزالة ' + part.ar + '">×</button>';
      row.querySelector('.sf-camry-map__selected-focus').textContent = part.ar;
      fragment.appendChild(row);
    });
    state.selectedList.replaceChildren(fragment);
    var clear = state.modal.querySelector('[data-action="clear"]');
    clear.hidden = state.selected.length === 0;
    if (!state.selected.length) {
      state.statusTitle.textContent = 'اختر قطعة لعرضها';
      state.statusNote.textContent = 'اختر منتجًا: يظهر الدبوس فقط عند مطابقة رقم القطعة مع مسار السيارة والجيل والصورة الحالية.';
    }
    updateMarkers();
  }

  function cameraPreset(zone, key) {
    var preset = { yaw: -0.62, pitch: 0.52, zoom: 0.92, focus: [0, 0, 0.68] };
    if (zone === 'overview' || !zone) return preset;
    var points = pointsFor(key);
    var focus = averagePoint(points);
    if (zone === 'engine') return { yaw: -0.58, pitch: 0.69, zoom: 1.42, focus: focus };
    if (zone === 'engine_low') return { yaw: -0.55, pitch: 0.42, zoom: 1.5, focus: focus };
    if (zone === 'cabin') return { yaw: -0.72, pitch: 0.57, zoom: 1.35, focus: focus };
    if (zone === 'underbody') return { yaw: -0.5, pitch: 0.28, zoom: 1.42, focus: focus };
    if (zone === 'front_wheels') return { yaw: -0.72, pitch: 0.4, zoom: 1.18, focus: [0, 1.38, 0.48] };
    if (zone === 'rear_wheels') return { yaw: 0.72, pitch: 0.4, zoom: 1.18, focus: [0, -1.35, 0.48] };
    if (zone === 'windshield') return { yaw: -0.52, pitch: 0.59, zoom: 1.32, focus: focus };
    if (zone === 'front') return { yaw: -0.18, pitch: 0.45, zoom: 1.42, focus: focus };
    return preset;
  }

  function copyCamera(camera) {
    return { yaw: camera.yaw, pitch: camera.pitch, zoom: camera.zoom, focus: camera.focus.slice() };
  }

  function animateCamera(target) {
    cancelAnimationFrame(state.tweenFrame);
    if (state.realReady) {
      state.camera = copyCamera(target);
      return;
    }
    if (reducedMotion) {
      state.camera = copyCamera(target);
      renderScene();
      return;
    }
    var start = copyCamera(state.camera);
    var started = performance.now();
    var duration = 520;
    function frame(now) {
      var t = clamp((now - started) / duration, 0, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      state.camera.yaw = lerp(start.yaw, target.yaw, eased);
      state.camera.pitch = lerp(start.pitch, target.pitch, eased);
      state.camera.zoom = lerp(start.zoom, target.zoom, eased);
      state.camera.focus = [
        lerp(start.focus[0], target.focus[0], eased),
        lerp(start.focus[1], target.focus[1], eased),
        lerp(start.focus[2], target.focus[2], eased)
      ];
      renderScene();
      if (t < 1) state.tweenFrame = requestAnimationFrame(frame);
    }
    state.tweenFrame = requestAnimationFrame(frame);
  }

  function resizeCanvas() {
    if (!state.canvas || !state.modal || !state.modal.hasAttribute('open')) return;
    var rect = state.canvas.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    var width = Math.max(1, Math.round(rect.width * dpr));
    var height = Math.max(1, Math.round(rect.height * dpr));
    if (state.canvas.width !== width || state.canvas.height !== height) {
      state.canvas.width = width;
      state.canvas.height = height;
    }
    renderScene();
  }

  function project(point) {
    var canvas = state.canvas;
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    var width = canvas.width / dpr;
    var height = canvas.height / dpr;
    var x = point[0] - state.camera.focus[0];
    var y = point[1] - state.camera.focus[1];
    var z = point[2] - state.camera.focus[2];
    var cy = Math.cos(state.camera.yaw);
    var sy = Math.sin(state.camera.yaw);
    var rx = x * cy - y * sy;
    var ry = x * sy + y * cy;
    var cp = Math.cos(state.camera.pitch);
    var sp = Math.sin(state.camera.pitch);
    var screenY = z * cp - ry * sp;
    var depth = ry * cp + z * sp;
    var base = Math.min(width, height);
    var scale = state.camera.zoom * base * 1.17 / Math.max(4.5, 7.1 - depth);
    return {
      x: width * 0.5 + rx * scale,
      y: height * 0.54 - screenY * scale,
      depth: depth,
      scale: scale
    };
  }

  function makeBox(center, size, fill, stroke, role) {
    var x = size[0] / 2;
    var y = size[1] / 2;
    var z = size[2] / 2;
    var cx = center[0], cy = center[1], cz = center[2];
    var vertices = [
      [cx-x,cy-y,cz-z],[cx+x,cy-y,cz-z],[cx+x,cy+y,cz-z],[cx-x,cy+y,cz-z],
      [cx-x,cy-y,cz+z],[cx+x,cy-y,cz+z],[cx+x,cy+y,cz+z],[cx-x,cy+y,cz+z]
    ];
    var faces = [[0,1,2,3],[4,7,6,5],[0,4,5,1],[1,5,6,2],[2,6,7,3],[3,7,4,0]];
    return { vertices: vertices, faces: faces, fill: fill, stroke: stroke, role: role || '' };
  }

  function makeCabin() {
    var vertices = [
      [-0.79,-1.13,0.83],[0.79,-1.13,0.83],[0.79,0.57,0.83],[-0.79,0.57,0.83],
      [-0.55,-0.76,1.53],[0.55,-0.76,1.53],[0.55,0.28,1.53],[-0.55,0.28,1.53]
    ];
    return {
      vertices: vertices,
      faces: [[4,7,6,5],[0,4,5,1],[1,5,6,2],[2,6,7,3],[3,7,4,0]],
      fill: 'rgba(42,125,132,.28)',
      stroke: 'rgba(4,76,80,.62)',
      role: 'body'
    };
  }

  function makeLoft(rings, fill, stroke, role) {
    var vertices = [];
    rings.forEach(function (ring) {
      var y = ring[0], halfWidth = ring[1], bottom = ring[2], top = ring[3];
      vertices.push(
        [-halfWidth, y, bottom],
        [halfWidth, y, bottom],
        [halfWidth, y, top],
        [-halfWidth, y, top]
      );
    });
    var faces = [[0,3,2,1]];
    for (var i = 0; i < rings.length - 1; i += 1) {
      var a = i * 4;
      var b = (i + 1) * 4;
      faces.push([a, b, b + 3, a + 3]);
      faces.push([a + 1, a + 2, b + 2, b + 1]);
      faces.push([a + 3, b + 3, b + 2, a + 2]);
      faces.push([a, a + 1, b + 1, b]);
    }
    var last = (rings.length - 1) * 4;
    faces.push([last, last + 1, last + 2, last + 3]);
    return { vertices: vertices, faces: faces, fill: fill, stroke: stroke, role: role || '' };
  }

  function buildMeshes() {
    var meshes = [
      makeLoft(
        [[-2.25,.68,.29,.60],[-1.84,.88,.25,.77],[-.92,.92,.24,.84],[.92,.92,.24,.86],[1.83,.86,.27,.76],[2.25,.68,.31,.59]],
        'rgba(24,130,135,.34)','rgba(5,77,81,.72)','body'
      ),
      makeLoft(
        [[.38,.80,.77,.91],[1.72,.80,.72,.83],[2.12,.66,.59,.7]],
        'rgba(28,137,142,.24)','rgba(5,77,81,.64)','body'
      ),
      makeLoft(
        [[-2.08,.69,.60,.73],[-1.75,.82,.74,.82],[-1.08,.80,.80,.9]],
        'rgba(28,137,142,.25)','rgba(5,77,81,.64)','body'
      ),
      makeCabin(),
      makeBox([0,1.24,0.62],[1.24,1.13,0.42],'rgba(53,74,76,.26)','rgba(40,72,74,.58)','engine'),
      makeBox([0,2.03,0.62],[1.45,0.13,0.7],'rgba(38,81,84,.25)','rgba(35,78,80,.58)','radiator'),
      makeBox([0.55,1.48,0.75],[0.46,0.56,0.32],'rgba(65,92,94,.28)','rgba(38,76,79,.62)','airbox'),
      makeBox([-0.42,0.78,0.34],[0.6,0.62,0.25],'rgba(68,79,81,.26)','rgba(44,67,69,.55)','transmission'),
      makeBox([0,0.16,0.97],[1.35,0.18,0.24],'rgba(21,92,96,.2)','rgba(14,83,87,.5)','dashboard'),
      makeBox([-.55,2.17,.62],[.34,.08,.19],'rgba(255,191,93,.48)','rgba(143,79,0,.55)','light'),
      makeBox([.55,2.17,.62],[.34,.08,.19],'rgba(255,191,93,.48)','rgba(143,79,0,.55)','light'),
      makeBox([-.55,-2.16,.63],[.35,.08,.18],'rgba(202,66,54,.42)','rgba(112,34,29,.5)','light'),
      makeBox([.55,-2.16,.63],[.35,.08,.18],'rgba(202,66,54,.42)','rgba(112,34,29,.5)','light')
    ];
    if (state.activeLocation && state.activeLocation.verified && state.activeLocation.point3d) {
      meshes.push(makeBox(state.activeLocation.point3d,[0.22,0.22,0.18],'rgba(255,153,28,.82)','rgba(130,66,0,.92)','selected'));
    }
    return meshes;
  }

  function drawMesh(mesh, faces) {
    mesh.faces.forEach(function (face) {
      var projected = face.map(function (index) { return project(mesh.vertices[index]); });
      var depth = projected.reduce(function (sum, point) { return sum + point.depth; }, 0) / projected.length;
      faces.push({ projected: projected, depth: depth, fill: mesh.fill, stroke: mesh.stroke, role: mesh.role });
    });
  }

  function drawWheel(point) {
    var ctx = state.context;
    var p = project(point);
    var radius = clamp(p.scale * 0.32, 11, 37);
    ctx.save();
    ctx.translate(p.x, p.y);
    ctx.scale(1, 0.72);
    ctx.beginPath();
    ctx.arc(0, 0, radius, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(24,37,39,.88)';
    ctx.fill();
    ctx.lineWidth = 2;
    ctx.strokeStyle = 'rgba(5,77,81,.75)';
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(0, 0, radius * 0.45, 0, Math.PI * 2);
    ctx.fillStyle = '#d7e8e7';
    ctx.fill();
    ctx.strokeStyle = '#587a7c';
    ctx.stroke();
    ctx.restore();
  }

  function renderScene() {
    if (state.realReady) return;
    if (!state.context || !state.canvas || !state.canvas.width) return;
    var ctx = state.context;
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    var width = state.canvas.width / dpr;
    var height = state.canvas.height / dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, width, height);

    var ground = project([0,0,0.08]);
    ctx.save();
    ctx.translate(ground.x, ground.y + Math.min(height * .12, 55));
    ctx.scale(1, .25);
    ctx.beginPath();
    ctx.arc(0, 0, clamp(ground.scale * 2.05, 70, width * .38), 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(2,65,68,.13)';
    ctx.fill();
    ctx.restore();

    [[-0.94,1.45,.45],[0.94,1.45,.45],[-0.94,-1.42,.45],[0.94,-1.42,.45]].forEach(drawWheel);

    var faces = [];
    buildMeshes().forEach(function (mesh) { drawMesh(mesh, faces); });
    faces.sort(function (a, b) { return a.depth - b.depth; });
    faces.forEach(function (face) {
      var points = face.projected;
      ctx.beginPath();
      ctx.moveTo(points[0].x, points[0].y);
      for (var i = 1; i < points.length; i += 1) ctx.lineTo(points[i].x, points[i].y);
      ctx.closePath();
      ctx.fillStyle = face.fill;
      ctx.fill();
      ctx.lineWidth = face.role === 'selected' ? 2.3 : 1.1;
      ctx.strokeStyle = face.stroke;
      ctx.stroke();
    });

    var front = project([0,2.48,.08]);
    var center = project([0,1.95,.08]);
    ctx.save();
    ctx.strokeStyle = 'rgba(255,137,0,.82)';
    ctx.fillStyle = 'rgba(255,137,0,.9)';
    ctx.lineWidth = 2.2;
    ctx.beginPath();
    ctx.moveTo(center.x, center.y);
    ctx.lineTo(front.x, front.y);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(front.x, front.y);
    ctx.lineTo(front.x - 6, front.y + 9);
    ctx.lineTo(front.x + 6, front.y + 9);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
    updateMarkerPositions();
  }

  function updateMarkers() {
    if (!state.markers) return;
    var fragment = document.createDocumentFragment();
    if (state.activeKey && state.activeLocation && state.activeLocation.verified && state.activeLocation.point3d) {
      var key = state.activeKey;
      var part = PARTS[key];
      var point = state.activeLocation.point3d;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'sf-camry-map__marker is-active';
      button.setAttribute('data-focus-part', key);
      button.setAttribute('data-point', point.join(','));
      button.textContent = part.icon;
      button.setAttribute('aria-label', part.ar);
      fragment.appendChild(button);
    }
    state.markers.replaceChildren(fragment);
    updateMarkerPositions();
  }

  function updateMarkerPositions() {
    if (!state.markers || !state.canvas) return;
    var canvasRect = state.canvas.getBoundingClientRect();
    state.markers.querySelectorAll('.sf-camry-map__marker').forEach(function (marker) {
      var point = marker.getAttribute('data-point').split(',').map(Number);
      var p = project(point);
      marker.style.left = p.x + 'px';
      marker.style.top = p.y + 'px';
      var outside = p.x < -25 || p.y < -25 || p.x > canvasRect.width + 25 || p.y > canvasRect.height + 25;
      marker.hidden = outside;
    });
  }

  function averagePoint(points) {
    if (!points.length) return [0, 0, 0.68];
    var sum = points.reduce(function (acc, point) {
      return [acc[0] + point[0], acc[1] + point[1], acc[2] + point[2]];
    }, [0,0,0]);
    return [sum[0] / points.length, sum[1] / points.length, sum[2] / points.length];
  }

  function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function debounce(fn, wait) {
    var timer = 0;
    return function () {
      clearTimeout(timer);
      timer = window.setTimeout(fn, wait);
    };
  }

  document.addEventListener('click', function (event) {
    var launch = event.target.closest('[data-sf-camry-map-open]');
    if (launch) {
      event.preventDefault();
      openModal('', launch);
      return;
    }
    var locate = event.target.closest('[data-sf-camry-locate]');
    if (locate) {
      event.preventDefault();
      event.stopPropagation();
      openModal(locate.getAttribute('data-part-key'), locate, locate.getAttribute('data-product-id'));
    }
  }, true);

  var scheduleSync = debounce(sync, 90);
  state.observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (mutation) {
      var target = mutation.target && mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      if (!target) return false;
      if (target.closest && target.closest('.sf-camry-map')) return false;
      if (target.closest && target.closest('.sf-camry-map-launch')) return false;
      return true;
    });
    if (relevant) scheduleSync();
  });
  state.observer.observe(document.documentElement, { childList: true, subtree: true });

  window.SenfinecoCamryMap = {
    sync: sync,
    open: function (key, productId) { openModal(key || '', document.activeElement, productId || ''); },
    close: closeModal,
    version: '2.6.0-real-vehicles'
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
})();
